/*!
 * BK-Sunray Zellen-Explorer 1.9
 * 3D-Kamerafahrt durch eine LiFePO4-Zelle: Rundum, Explosionszeichnung, Querschnitt mit Zoom
 * bis ins Kristallgitter, Verschaltung mit Stromfluss, BMS und den Gehäusen der Selbstbauspeicher,
 * Qualitätsvergleich.
 * Reines JavaScript, keine Abhängigkeiten.
 *
 * Einbau:  <link rel="stylesheet" href="bk-zellen-explorer.css">
 *          <div data-bk-zellen-explorer></div>
 *          <script src="bk-zellen-explorer.js" defer></script>
 *
 * Optionen als data-Attribute am div:
 *   data-autoplay="false"                Film nicht automatisch starten
 *   data-price-lf105 / -mb31 / -mb56     Preistext je Zelle (leer = kein Preis)
 *   data-note-lf105 / -mb31 / -mb56      Zusatz neben dem Preis, z. B. «pro Zelle»
 *   data-url-lf105 / -mb31 / -mb56       Produktlink je Zelle
 *   data-store-url                       Link zur Speicher-Übersicht
 */
(function () {
  'use strict';
  if (window.BKZellenExplorer) return;

  /* ------------------------------------------------------------------ Helfer */
  function U(px) { return (px / 6.8).toFixed(3) + 'cqw'; }
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function win(e, s0, s1) { return clamp01((e - s0) / (s1 - s0)); }
  function eio(x) { return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
  function eback(x) { var c1 = 1.3, c3 = c1 + 1; return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2); }
  function smooth(x) { var v = clamp01(x); return v * v * v * (v * (v * 6 - 15) + 10); }
  function near(cur, tgt) { return tgt + 360 * Math.round((cur - tgt) / 360); }
  function T3(x, y, z) { return 'translate3d(' + U(x) + ',' + U(y) + ',' + U(z) + ')'; }
  function fmt(x) { var m = Math.floor(x / 60), s = Math.floor(x % 60); return m + ':' + (s < 10 ? '0' : '') + s; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function cache(el) { return el.__bkzc || (el.__bkzc = {}); }
  function setS(el, prop, val) { var c = cache(el); if (c[prop] !== val) { c[prop] = val; el.style[prop] = val; } }
  function setV(el, name, val) { var c = cache(el); if (c[name] !== val) { c[name] = val; el.style.setProperty(name, val); } }
  function setA(el, name, val) { var c = cache(el); if (c['@' + name] !== val) { c['@' + name] = val; el.setAttribute(name, val); } }
  function setT(el, txt) { var c = cache(el); if (c.txt !== txt) { c.txt = txt; el.textContent = txt; } }
  function setH(el, hide) { if (el.hidden !== hide) el.hidden = hide; }

  function rot(v, yaw, pitch) {
    var b = yaw * Math.PI / 180, a = pitch * Math.PI / 180;
    var x = v[0] * Math.cos(b) + v[2] * Math.sin(b);
    var z = -v[0] * Math.sin(b) + v[2] * Math.cos(b);
    var y = v[1];
    return [x, y * Math.cos(a) - z * Math.sin(a), y * Math.sin(a) + z * Math.cos(a)];
  }
  function proj(p, cam) {
    var r = rot([p[0] - cam.tx, p[1] - cam.ty, p[2] - cam.tz], cam.yaw, cam.pitch);
    var z = r[2] * cam.zoom;
    var f = 1400 / Math.max(80, 1400 - z);
    return [340 + r[0] * cam.zoom * f, 239.2 + (cam.cy + r[1] * cam.zoom - 239.2) * f];
  }
  function depth(p, cam) { return rot([p[0] - cam.tx, p[1] - cam.ty, p[2] - cam.tz], cam.yaw, cam.pitch)[2]; }
  function shade(n, yaw, pitch) {
    var r = rot(n, yaw, pitch);
    var d = (r[0] * -0.42 + r[1] * -0.72 + r[2] * 0.55) / 0.9986;
    return (0.6 + 0.52 * Math.max(0, d)).toFixed(3);
  }
  function glint(n, cam, k) {
    var r = rot(n, cam.yaw, cam.pitch);
    if (r[2] <= 0.03) return { x: '50% 0', o: '0' };
    var phi = Math.atan2(r[0], r[2]) * 57.2958;
    var u = (phi + 16) / 30;
    var o = k * Math.exp(-u * u) * Math.min(1, r[2] * 2.2);
    return { x: (50 + 26 * u).toFixed(1) + '% 0', o: o.toFixed(3) };
  }
  function blurAt(p, cam, dof) {
    if (dof <= 0.01) return '0px';
    var z = Math.abs(depth(p, cam)) * cam.zoom;
    var px = Math.min(7, Math.max(0, (z - 24) * 0.024 * dof));
    return px < 0.5 ? '0px' : U(px);
  }
  function nearFade(P, w, h, d, cam) {
    var mz = -1e9;
    for (var i = 0; i < 8; i++) {
      var q = [P[0] + ((i & 1) ? 0.5 : -0.5) * w, P[1] + ((i & 2) ? 0.5 : -0.5) * h, P[2] + ((i & 4) ? 0.5 : -0.5) * d];
      var z = depth(q, cam) * cam.zoom;
      if (z > mz) mz = z;
    }
    return clamp01((1000 - mz) / 250);
  }
  function box(w, h, d) {
    var F = function (fw, fh, tr) { return { l: U(-fw / 2), t: U(-fh / 2), w: U(fw), h: U(fh), tr: tr }; };
    return {
      front: F(w, h, 'translateZ(' + U(d / 2) + ')'),
      back: F(w, h, 'rotateY(180deg) translateZ(' + U(d / 2) + ')'),
      right: F(d, h, 'rotateY(90deg) translateZ(' + U(w / 2) + ')'),
      left: F(d, h, 'rotateY(-90deg) translateZ(' + U(w / 2) + ')'),
      top: F(w, d, 'rotateX(90deg) translateZ(' + U(h / 2) + ')'),
      bottom: F(w, d, 'rotateX(-90deg) translateZ(' + U(h / 2) + ')')
    };
  }
  var NORM = { front: [0, 0, 1], back: [0, 0, -1], right: [1, 0, 0], left: [-1, 0, 0], top: [0, -1, 0], bottom: [0, 1, 0] };
  var SIDES = ['front', 'back', 'right', 'left', 'top', 'bottom'];
  var SIDES6 = ['front', 'back', 'right', 'left', 'top', 'bottom'];

  /* ------------------------------------------------------------------ Daten */
  var SHOP = 'https://bk-sunray.ch';
  var MODELS = {
    lf105: { name: 'LF105', ah: 105, w: 131, h: 210, t: 37, wh: '336 Wh', kg: '2 kg', cyc: "3'000 bis 70 %", dims: '131 × 210 × 37 mm', price: 'CHF 85.–', note: 'pro Zelle, ab 4 Stück', url: SHOP + '/products/eve-lf105-105ah-lifepo4-zellen', ir: [0.21, 0.22, 0.21, 0.22], irB: [0.29, 0.36, 0.33, 0.27], irMax: 0.25 },
    mb31: { name: 'MB31', ah: 314, w: 174, h: 205, t: 72, wh: "1'005 Wh", kg: '5.6 kg', cyc: "8'000 laut Hersteller", dims: '174 × 205 × 72 mm', price: '', note: 'pro Zelle', url: SHOP + '/products/eve-mb31-lifepo4-zelle-314ah-grade-hsev', ir: [0.17, 0.17, 0.18, 0.17], irB: [0.24, 0.31, 0.27, 0.22], irMax: 0.18 },
    mb56: { name: 'MB56', ah: 628, w: 352, h: 207, t: 72, wh: "2'010 Wh", kg: '11.5 kg', cyc: "8'000 bis 70 %", dims: '352 × 207 × 72 mm', price: 'CHF 250.–', note: 'pro Zelle, ab 4 Stück', url: SHOP + '/products/eve-mb56-628ah-lifepo4-zelle', ir: [0.10, 0.10, 0.11, 0.10], irB: [0.17, 0.21, 0.19, 0.16], irMax: 0.15 }
  };
  var PRESETS = {
    film: { part: 'filmSide', zoom: 1.9, yaw: 66, pitch: -12, n: '1', name: 'Isolierfolie', title: 'Trennt die Zelle elektrisch', text: 'Die blaue Folie isoliert das Gehäuse gegenüber den Nachbarzellen im Speicher.' },
    cover: { part: 'cover', zoom: 2.4, yaw: 22, pitch: -46, n: '2', name: 'Deckel', title: 'Plus- und Minuspol', text: 'Beide Pole haben ein Gewinde. Daran werden die Zellverbinder fest verschraubt.' },
    vent: { part: 'vent', zoom: 3.6, yaw: 12, pitch: -60, n: '3', name: 'Sicherheits­ventil', title: 'Öffnet bei Überdruck', text: 'Steigt der Druck in der Zelle zu stark an, öffnet das Ventil kontrolliert.' },
    tabs: { part: 'tabs', zoom: 2.7, yaw: 24, pitch: -34, n: '4', name: 'Strom­ableiter', title: 'Verbinden Wickel und Pole', text: 'Gebündelte Folienränder, verschweisst mit Blechen unter dem Deckel. Aluminium führt zum Pluspol, Kupfer zum Minuspol.' },
    can: { part: 'can', zoom: 1.5, yaw: 30, pitch: -22, n: '5', name: 'Aluminium­gehäuse', title: 'Stabil und leicht', text: 'Der Aluminiumbecher hält Elektrodenwickel und Elektrolyt dicht verschlossen.' },
    jelly: { part: 'jellySide', zoom: 2.2, yaw: 62, pitch: -16, n: '6', name: 'Elektroden­wickel', title: 'Hauchdünne Schichten', text: 'Kathode, Separator und Anode sind eng aufgewickelt. An der Seite sieht man die Lagen wie Jahresringe.' },
    page0: { part: 'page0', zoom: 1.9, yaw: 38, pitch: -12, n: '7', name: 'Kathode', title: 'Lithium-Eisenphosphat', text: 'Auf eine Aluminiumfolie aufgetragen. Im entladenen Zustand sitzt hier das Lithium.' },
    page1: { part: 'page1', zoom: 2.0, yaw: 43, pitch: -12, n: '8', name: 'Separator', title: 'Nur Ionen kommen durch', text: 'Die poröse Kunststofffolie trennt Kathode und Anode und verhindert einen Kurzschluss.' },
    page2: { part: 'page2', zoom: 2.1, yaw: 48, pitch: -11, n: '9', name: 'Anode', title: 'Graphit auf Kupferfolie', text: 'Beim Laden lagern sich die Lithium-Ionen zwischen den Graphitschichten ein.' },
    qr: { part: 'qr', zoom: 3.4, yaw: -10, pitch: -4, n: '1', name: 'QR-Code', title: ['Original mit Seriennummer', 'Neu gelasert'], text: ['Über den Code lässt sich die Zelle zum Hersteller zurückverfolgen.', 'Abgeschliffene oder neu gelaserte Codes verschleiern die Herkunft. Ein Warnsignal.'] },
    term: { part: 'termPlus', zoom: 3.0, yaw: 8, pitch: -50, n: '2', name: 'Pole', title: ['Saubere Gewinde', 'Gewinde prüfen'], text: ['Unbeschädigte Pole sorgen für einen festen Kontakt zu den Zellverbindern.', 'Beschädigte oder verschmutzte Gewinde verschlechtern den Kontakt.'] },
    dent: { part: 'dent', zoom: 2.6, yaw: -24, pitch: -6, n: '3', name: 'Gehäuse', title: ['Keine Dellen', 'Delle im Gehäuse'], text: ['Ein unversehrtes Gehäuse spricht für sorgfältige Lagerung und Transport.', 'Dellen oder Wölbungen können auf Transportschäden oder Überlastung hinweisen.'] }
  };
  var KITS = {
    p4: { n: 4, cell: 'mb31', name: '12V Solarspeicher 4 kWh', seg: ['12 V · 4 kWh', '4 × MB31'], meta: '4 × EVE MB31 · 35 × 20 × 26 cm · ca. 25 kg', use: 'Camper, Boot, Gartenhaus', handle: '12v-lifepo4-solarbatterie-4kwh', price: 'ab CHF 850.–', sub: 'Bausatz oder fertig montiert', link: 'Zum Produkt', zoom: 0.84 },
    p4b: { n: 4, cell: 'mb56', name: '12V Solarspeicher 8 kWh', seg: ['12 V · 8 kWh', '4 × MB56'], meta: '4 × EVE MB56 mit je 628 Ah', use: 'Ferienhaus, Alp, Wohnmobil', handle: '12v-lifepo4-solarspeicher-8kwh-1', price: "CHF 1'359.–", sub: '', link: 'Zum Produkt', zoom: 0.66 },
    p8: { n: 8, cell: 'mb31', name: '24V Solarspeicher 8 kWh', seg: ['24 V · 8 kWh', '8 × MB31'], meta: '8 × EVE MB31 · 63 × 20 × 26 cm · ca. 46 kg', use: 'Van, Alp, Offgrid', handle: '24v-lifepo4-solarbatterie-8kwh', price: "ab CHF 1'750.–", sub: 'Bausatz oder fertig montiert', link: 'Zum Produkt', zoom: 0.72 },
    p16: { n: 16, cell: 'mb31', name: '48 V aus zwei 24V-Gehäusen', seg: ['48 V · 16 kWh', '16 × MB31'], meta: 'Zwei Gehäuse des 24V Solarspeichers 8 kWh nebeneinander, die 16 Zellen in Serie', use: 'Haus mit Hybridwechselrichter', handle: '24v-lifepo4-solarbatterie-8kwh', price: '', sub: '', link: 'Zum 24V-Speicher', zoom: 0.56 }
  };
  var KIT_ORDER = ['p4', 'p4b', 'p8', 'p16'];
  function kitKey(S) { return S.pcell === 'mb56' ? 'p4b' : 'p' + S.pack; }
  var PARTS1 = ['film', 'cover', 'vent', 'tabs', 'can', 'jelly', 'page0', 'page1', 'page2'];
  var PARTS4 = ['qr', 'term', 'dent'];
  var CHAPTERS = [
    { t: 'Rundum', s: 'Die Zelle von allen Seiten' },
    { t: 'Aufbau', s: 'Explosions\u00adzeichnung' },
    { t: 'Funktion', s: 'Bis zum Atom' },
    { t: 'Verschalten', s: 'Vom Baustein zum Speicher' },
    { t: 'Qualität', s: 'Grade A oder B?' },
    { t: 'Anlage', s: 'Vom Modul zum E-Auto' },
    { t: 'Vergleich', s: 'Mit AGM und Blei' },
    { t: 'Kosten', s: 'Mit echten Preisen' },
    { t: 'Finder', s: 'Was passt zu mir?' }
  ];
  var NEXT = ['Weiter: Aufbau ansehen', 'Weiter: So funktioniert sie', 'Weiter: Zellen verschalten', 'Weiter: Qualität erkennen', 'Weiter: Speicher in der Anlage', 'Weiter: Vergleich mit Blei und AGM', 'Weiter: Was ein Speicher spart', 'Weiter: Welcher Speicher passt?', 'Von vorne beginnen'];
  var USE = { 4: 'Camper, Boot, Gartenhaus', 8: 'Van, Alp, Offgrid', 16: 'Haus mit Hybridwechselrichter' };
  var CHECK_A = ['Kapazität über dem Nennwert', 'Innenwiderstand im Datenblattbereich', 'Alle Zellen eng beieinander', 'Original-QR-Code und Prüfbericht des Herstellers'];
  var CHECK_B = ['Kapazität unter dem Nennwert', 'Höherer, ungleicher Innenwiderstand', 'Werte streuen stark, das BMS muss ständig ausgleichen', 'QR-Code oft neu gelasert, Dellen möglich'];

  function K(t, yaw, pitch, zoom, tg, cy, ease) { return { t: t, yaw: yaw, pitch: pitch, lz: Math.log(zoom), tg: tg, cy: cy, ease: !!ease }; }
  var FILM = {
    dur: 44,
    keys: [
      K(0, -80, -4, 0.95, 'cell', 262), K(3.6, -30, -12, 1.18, 'cell', 262), K(6.2, -12, -6, 2.9, 'qr', 250), K(7.6, -4, -8, 2.5, 'label', 250),
      K(9.8, 18, -48, 2.3, 'cover', 250), K(11.2, 26, -58, 3.3, 'vent', 250), K(14.6, 40, -20, 0.74, 'exploded', 262), K(16.8, 38, -12, 1.9, 'page0', 250),
      K(19.0, 43, -12, 2.0, 'page1', 250), K(21.2, 48, -11, 2.1, 'page2', 250), K(22.4, 47, -11, 2.4, 'page2', 250), K(23.6, 46, -11, 8.0, 'page2', 250, true),
      K(37.4, 150, -22, 2.4, 'exploded', 262, true), K(39.2, 168, -18, 0.78, 'exploded', 262), K(41.6, 268, -14, 1.1, 'cell', 262), K(44, 318, -14, 1.22, 'cell', 262)
    ],
    e: [[0, 0], [7.8, 0], [10.6, 0.34], [11.6, 0.34], [14.2, 1], [39.4, 1], [41.8, 0]],
    l: [[0, 0], [14.6, 0], [16.2, 1], [39.0, 1], [40.6, 0]],
    oc: [[0, 1], [22.8, 1], [23.5, 0], [36.8, 0], [37.5, 1]],
    dof: [[0, 0], [5.0, 0], [6.0, 1], [7.6, 1], [8.6, 0.4], [9.8, 1], [11.6, 1], [12.6, 0], [15.6, 0], [16.6, 1], [22.4, 1], [22.9, 1.8], [37.4, 1.8], [38.6, 0]],
    fade: [[0, 1], [1.0, 0.62], [2.9, 0.62], [3.9, 0]],
    peel: [[0, 0], [18.4, 0], [19.0, 1], [20.6, 1], [21.2, 2], [39.0, 2], [39.6, 0]],
    lb: [[0, 0], [0.9, 1], [43.0, 1], [44, 0]],
    m1: [[0, 0], [23.3, 0], [24.1, 1], [28.9, 1], [29.6, 0]],
    z1: [[0, 2.6], [23.3, 2.6], [25.8, 1.0], [27.6, 1.06], [29.6, 5.4]],
    c1x: [[0, 112], [23.3, 112], [25.8, 0], [27.6, -12], [29.6, -78]],
    c1y: [[0, 0], [23.3, 0], [25.8, 0], [27.6, 8], [29.6, 61]],
    s1: [[0, 0.12], [24.2, 0.12], [29.0, 0.66]],
    m3: [[0, 0], [29.1, 0], [29.9, 1], [36.2, 1], [36.9, 0]],
    z3: [[0, 0.5], [29.1, 0.5], [30.6, 1], [35.4, 1.04], [36.9, 0.55]],
    g3: [[0, 0], [30.0, 0], [32.4, 1]],
    c3x: [[0, -118], [33.0, -118], [35.0, 124], [37.0, 40]],
    sC: [[0, 0.1], [29.8, 0.1], [33.2, 0.86]],
    sA: [[0, 0.12], [33.0, 0.12], [36.4, 0.9]],
    caps: [
      { t0: 0.8, t1: 3.4, pos: 'center', eyebrow: 'model', title: 'Im Inneren einer LiFePO4-Zelle' },
      { t0: 4.4, t1: 7.4, eyebrow: 'Rückverfolgbar', title: 'Original-QR-Code mit Seriennummer' },
      { t0: 8.4, t1: 11.8, eyebrow: 'Der Deckel', title: 'Plus- und Minuspol, dazwischen das Sicherheitsventil' },
      { t0: 12.6, t1: 15.6, eyebrow: 'Das Innere', title: 'Aluminiumgehäuse und Elektrodenwickel' },
      { t0: 16.6, t1: 18.8, eyebrow: 'Kathode', title: 'Lithium-Eisenphosphat auf Aluminiumfolie' },
      { t0: 18.9, t1: 21.0, eyebrow: 'Separator', title: 'Lässt nur Lithium-Ionen durch' },
      { t0: 21.1, t1: 23.0, eyebrow: 'Anode', title: 'Graphit auf Kupferfolie' },
      { t0: 24.4, t1: 28.4, eyebrow: 'Unter dem Mikroskop', title: 'Beim Laden wandern Lithium-Ionen durch den Separator zum Graphit' },
      { t0: 30.2, t1: 33.2, eyebrow: 'Ein Millionstel Millimeter', title: 'Lithium verlässt das Kristallgitter, das Eisen gibt ein Elektron ab' },
      { t0: 33.6, t1: 36.4, eyebrow: 'Graphit', title: 'Zwischen den Kohlenstoffschichten lagert sich das Lithium ein' },
      { t0: 38.2, t1: 40.6, eyebrow: 'Zusammenbau', title: 'Gebaut für Tausende Ladezyklen' },
      { t0: 41.0, t1: 44.0, pos: 'low', eyebrow: 'BK-Sunray', title: 'Nur neue Grade-A-Zellen von EVE' }
    ],
    scenes: [
      { t: 0, name: 'Auftritt' }, { t: 4.0, name: 'QR-Code' }, { t: 7.8, name: 'Der Deckel' }, { t: 11.8, name: 'Das Innere' },
      { t: 15.0, name: 'Die Schichten' }, { t: 22.6, name: 'Unter dem Mikroskop' }, { t: 28.8, name: 'Im Kristallgitter' }, { t: 37.2, name: 'Zusammenbau' }
    ]
  };

  /* ------------------------------------------------------------------ Geometrie */
  function zf(dims) { return Math.max(0.75, Math.min(1.15, Math.sqrt(165.3 / dims.w))); }
  function dimsOf(model) { var M = MODELS[model]; return { w: M.w * 0.95, h: M.h * 0.95, d: M.t * 0.95 }; }
  function geo(dims, e, l) {
    var W = dims.w, H = dims.h, D = dims.d, Hc = 10, Hb = H - Hc;
    var pC = eback(win(e, 0, 0.5)), pK = eio(win(e, 0.15, 0.75)), pF = eio(win(e, 0.25, 0.85)), pJ = eback(win(e, 0.3, 0.95));
    var coverY = -H / 2 + Hc / 2 - 0.72 * H * pC;
    var canY = Hc / 2 + 0.82 * H * pK;
    var fsx = 1 + 0.05 * pF, fsz = 1 + 0.18 * pF;
    var Wj = W - 12, Hj = Hb - 16, Dj = Math.max(14, D - 10);
    var jy = Hc / 2 - 0.1 * H * pJ, jz = 0.12 * D * eio(win(e, 0.62, 1));
    var Wp = Wj - 10, Hp = Hj - 12, hx = -Wj / 2 + 6;
    var lf = Math.min(l, clamp01((e - 0.75) / 0.25));
    var z0 = jz + Dj / 2 + 1.5;
    var pages = [0, 1, 2].map(function (i) {
      var r = 2 - i, k = r + 1;
      var lp = win(lf, 0.12 * i, 0.55 + 0.12 * i);
      var el = eback(lp);
      var th = -3 * k * el;
      var cx = hx + Wp / 2 + 11 * k * el, cy = jy - 5 * k * el, cz = z0 + 0.6 * r + 26 * k * el;
      return { lp: lp, th: th, rad: th * Math.PI / 180, center: [cx, cy, cz], left: cx - Wp / 2 };
    });
    return { W: W, H: H, D: D, Hc: Hc, Hb: Hb, pF: pF, coverY: coverY, canY: canY, fsx: fsx, fsz: fsz, Wj: Wj, Hj: Hj, Dj: Dj, jy: jy, jz: jz, Wp: Wp, Hp: Hp, pages: pages, front: (D + 1.5) / 2 * fsz, qrS: 0.72 * 0.33 * Hb, qy: canY - Hb / 2 + 0.235 * Hb, tw: Math.min(0.16 * W, 0.62 * D), th: 3 };
  }
  function partPos(name, g) {
    switch (name) {
      case 'exploded': return [0, ((g.coverY - g.Hc / 2) + (g.canY + g.Hb / 2)) / 2, 0];
      case 'label': return [0, g.qy, g.front];
      case 'qr': return [g.W / 2 - 0.14 * g.W - g.qrS / 2, g.qy, g.front + 0.5];
      case 'cover': case 'vent': return [0, g.coverY - g.Hc / 2, 0];
      case 'termPlus': return [-0.28 * g.W, g.coverY - g.Hc / 2 - g.th, 0];
      case 'can': return [0, g.canY, 0];
      case 'filmSide': return [-(g.W + 1.5) / 2 * g.fsx, g.canY - 0.1 * g.Hb, 0];
      case 'jelly': return [0, g.jy, g.jz];
      case 'jellySide': return [-g.Wj / 2, g.jy - 0.1 * g.Hj, g.jz];
      case 'tabs': return [0, g.jy - g.Hj / 2 - 2, g.jz];
      case 'page0': return g.pages[0].center;
      case 'page1': return g.pages[1].center;
      case 'page2': return g.pages[2].center;
      case 'dent': return [-0.26 * (g.W + 1.5), g.canY + 0.2 * g.Hb, g.front];
      default: return [0, 0, 0];
    }
  }

  /* ------------------------------------------------------------------ Film */
  function track(tr, t, linear) {
    if (t <= tr[0][0]) return tr[0][1];
    for (var i = 1; i < tr.length; i++) {
      if (t <= tr[i][0]) {
        var p = tr[i - 1], q = tr[i];
        var u = (t - p[0]) / Math.max(1e-6, q[0] - p[0]);
        return p[1] + (q[1] - p[1]) * (linear ? u : smooth(u));
      }
    }
    return tr[tr.length - 1][1];
  }
  function spline(keys, t, get) {
    var n = keys.length;
    if (t <= keys[0].t) return get(keys[0]);
    if (t >= keys[n - 1].t) return get(keys[n - 1]);
    var i = 0;
    while (i < n - 2 && t > keys[i + 1].t) i++;
    var tan = function (j) {
      if (keys[j].ease) return 0;
      var p = keys[Math.max(0, j - 1)], q = keys[Math.min(n - 1, j + 1)];
      return q.t === p.t ? 0 : (get(q) - get(p)) / (q.t - p.t);
    };
    var k0 = keys[i], k1 = keys[i + 1];
    var dt = k1.t - k0.t, u = (t - k0.t) / dt, u2 = u * u, u3 = u2 * u;
    return (2 * u3 - 3 * u2 + 1) * get(k0) + (u3 - 2 * u2 + u) * dt * tan(i) + (-2 * u3 + 3 * u2) * get(k1) + (u3 - u2) * dt * tan(i + 1);
  }
  function filmFrame(ft, dims) {
    var e = track(FILM.e, ft), l = track(FILM.l, ft);
    var g = geo(dims, e, l);
    var keys = FILM.keys.map(function (k) { var P = partPos(k.tg, g); return { t: k.t, ease: k.ease, yaw: k.yaw, pitch: k.pitch, lz: k.lz, cy: k.cy, x: P[0], y: P[1], z: P[2] }; });
    var S = function (get) { return spline(keys, ft, get); };
    return {
      yaw: S(function (k) { return k.yaw; }), pitch: S(function (k) { return k.pitch; }), zoom: Math.exp(S(function (k) { return k.lz; })) * zf(dims), cy: S(function (k) { return k.cy; }),
      tx: S(function (k) { return k.x; }), ty: S(function (k) { return k.y; }), tz: S(function (k) { return k.z; }),
      e: e, l: l, oc: track(FILM.oc, ft), dof: track(FILM.dof, ft),
      fade: track(FILM.fade, ft), lb: track(FILM.lb, ft), peel: track(FILM.peel, ft),
      m1: track(FILM.m1, ft), z1: track(FILM.z1, ft), c1x: track(FILM.c1x, ft), c1y: track(FILM.c1y, ft), s1: track(FILM.s1, ft, true),
      m3: track(FILM.m3, ft), z3: track(FILM.z3, ft), c3x: track(FILM.c3x, ft), g3: track(FILM.g3, ft), sC: track(FILM.sC, ft, true), sA: track(FILM.sA, ft, true)
    };
  }

  /* ------------------------------------------------------------------ Mikrowelt */
  var MICRO = null;
  function micro() {
    if (!MICRO) {
      MICRO = makeMicro();
      FILM.c1x[4][1] = MICRO.target[0];
      FILM.c1y[4][1] = MICRO.target[1];
    }
    return MICRO;
  }
  var SPIRAL = (function () {
    var s = '<svg class="bkz-spiral" viewBox="0 0 60 170" preserveAspectRatio="none" aria-hidden="true">', cols = ['#C67B3C', '#3A4252', '#DCE2EA', '#262C37', '#A7B2C2', '#3A4252'];
    for (var i = 0; i < 11; i++) {
      var p = 1.4 + i * 2.65, w = 60 - 2 * p, h = 170 - 2 * p;
      s += '<rect x="' + p.toFixed(2) + '" y="' + p.toFixed(2) + '" width="' + w.toFixed(2) + '" height="' + h.toFixed(2) + '" rx="' + (w / 2).toFixed(2) + '" fill="none" stroke="' + cols[i % cols.length] + '" stroke-width="1.6"/>';
    }
    return s + '<path d="M30 46V124" stroke="#090B10" stroke-width="2.4" stroke-linecap="round"/></svg>';
  })();

  /* ------------------------------------------------------------------ Querschnitt */
  function ocv(sv) {
    var P = [[0, 2.5], [0.03, 2.95], [0.08, 3.12], [0.15, 3.2], [0.3, 3.25], [0.5, 3.28], [0.7, 3.3], [0.9, 3.33], [0.96, 3.38], [0.99, 3.5], [1, 3.65]];
    var x = clamp01(sv);
    for (var i = 1; i < P.length; i++) { if (x <= P[i][0]) { var p0 = P[i - 1], p1 = P[i]; return p0[1] + (p1[1] - p0[1]) * (x - p0[0]) / (p1[0] - p0[0]); } }
    return 3.65;
  }
  var CURVE = (function () { var d = ''; for (var i = 0; i <= 60; i++) { var sv = i / 60; d += (i ? 'L' : 'M') + (468 + sv * 184).toFixed(1) + ' ' + (440 - (ocv(sv) - 2.4) / 1.4 * 110).toFixed(1); } return d; })();
  var QR = (function () {
    var seed = 7, N = 21, m = [], x, y, i;
    var rnd = function () { seed = (seed * 9301 + 49297) % 233280; return seed / 233280; };
    for (y = 0; y < N; y++) { var row = []; for (x = 0; x < N; x++) row.push(rnd() > 0.52 ? 1 : 0); m.push(row); }
    var finder = function (ox, oy) {
      for (var yy = -1; yy < 8; yy++) for (var xx = -1; xx < 8; xx++) {
        var X = ox + xx, Y = oy + yy;
        if (X < 0 || Y < 0 || X >= N || Y >= N) continue;
        var ring = Math.max(Math.abs(xx - 3), Math.abs(yy - 3));
        m[Y][X] = (ring === 3 || ring <= 1) ? 1 : 0;
      }
    };
    finder(0, 0); finder(14, 0); finder(0, 14);
    for (i = 8; i < 13; i++) { m[6][i] = i % 2 === 0 ? 1 : 0; m[i][6] = i % 2 === 0 ? 1 : 0; }
    var d = '';
    for (y = 0; y < N; y++) for (x = 0; x < N; x++) if (m[y][x]) d += 'M' + x + ' ' + y + 'h1v1h-1z';
    return d;
  })();

  /* Mikrowelt: Elektrode unter dem Mikroskop (L1) und Kristallgitter (L3).
     Zeichnet auf ein 2D-Canvas in Bühnen-Einheiten (680 x 520). */
  function makeMicro() {
    var seed = 7;
    function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function mk(n) { var c = document.createElement('canvas'); c.width = n; c.height = n; return c; }
    var TAU = 6.283185307;

    /* ---------------- Sprites ---------------- */
    function ball(c0, c1, c2) {
      var c = mk(96), g = c.getContext('2d');
      var gr = g.createRadialGradient(34, 30, 3, 48, 48, 47);
      gr.addColorStop(0, c0); gr.addColorStop(0.42, c1); gr.addColorStop(1, c2);
      g.fillStyle = gr; g.beginPath(); g.arc(48, 48, 46, 0, TAU); g.fill();
      return c;
    }
    function glow(rgb, a) {
      var c = mk(96), g = c.getContext('2d');
      var gr = g.createRadialGradient(48, 48, 0, 48, 48, 48);
      gr.addColorStop(0, 'rgba(' + rgb + ',' + a + ')');
      gr.addColorStop(0.32, 'rgba(' + rgb + ',' + (a * 0.32) + ')');
      gr.addColorStop(1, 'rgba(' + rgb + ',0)');
      g.fillStyle = gr; g.fillRect(0, 0, 96, 96);
      return c;
    }
    function grain() {
      var c = mk(160), g = c.getContext('2d'), n = 11, pts = [], i;
      for (i = 0; i < n; i++) { var an = i / n * TAU, rr = 62 * (0.84 + 0.16 * rnd()); pts.push([80 + Math.cos(an) * rr, 80 + Math.sin(an) * rr]); }
      var m0 = [(pts[n - 1][0] + pts[0][0]) / 2, (pts[n - 1][1] + pts[0][1]) / 2];
      function outline() {
        g.beginPath(); g.moveTo(m0[0], m0[1]);
        for (var j = 0; j < n; j++) { var p = pts[j], q = pts[(j + 1) % n]; g.quadraticCurveTo(p[0], p[1], (p[0] + q[0]) / 2, (p[1] + q[1]) / 2); }
        g.closePath();
      }
      outline();
      var gr = g.createRadialGradient(58, 52, 5, 80, 80, 70);
      gr.addColorStop(0, '#93A1B3'); gr.addColorStop(0.5, '#5E6C7E'); gr.addColorStop(1, '#2C3442');
      g.fillStyle = gr; g.fill();
      g.save(); g.clip();
      for (i = 0; i < 22; i++) {
        var x = 25 + rnd() * 110, y = 25 + rnd() * 110, r = 5 + rnd() * 11;
        g.fillStyle = 'rgba(' + (rnd() < 0.5 ? '20,26,36' : '170,185,205') + ',' + (0.1 + rnd() * 0.12) + ')';
        g.beginPath(); g.arc(x, y, r, 0, TAU); g.fill();
      }
      g.restore();
      outline(); g.lineWidth = 4; g.strokeStyle = 'rgba(10,13,18,0.85)'; g.stroke();
      return c;
    }
    var SPR = null;
    function sprites() {
      if (SPR) return SPR;
      SPR = {
        g: [grain(), grain(), grain(), grain()],
        core: ball('#F8DA92', '#CE9134', '#6F4710'),
        li: ball('#FFF8DC', '#F7C531', '#AE7908'),
        liGlow: glow('247,197,49', 0.85),
        e: ball('#EEF4FF', '#8FB6FF', '#3A62C4'),
        eGlow: glow('143,182,255', 0.9),
        o: ball('#FFCCC5', '#E25B4C', '#83221A'),
        c: ball('#C2CBD9', '#5D687B', '#212834'),
        sol: glow('170,195,240', 0.5),
        bokeh: glow('160,195,255', 0.55),
        bokehW: glow('255,205,120', 0.45)
      };
      return SPR;
    }
    var FE2 = [194, 106, 51], FE3 = [122, 42, 34], PO4 = [128, 96, 220];

    /* ---------------- L1: Elektrode unter dem Mikroskop ---------------- */
    var X = { al0: -212, al1: -198, ca1: -16, se1: 16, an1: 200, cu1: 210, y0: -212, y1: 212 };
    var lfp = [], gra = [], cb = [], fib = [], sol = [], ions = [], bok = [];
    (function () {
      var n, i, ok, x, y, r, q, dx, dy;
      for (n = 0; n < 9000 && lfp.length < 200; n++) {
        r = 5.5 + rnd() * 8;
        x = X.al1 + r + 1 + rnd() * (X.ca1 - X.al1 - 2 * r - 2);
        y = X.y0 + rnd() * (X.y1 - X.y0);
        ok = true;
        for (i = 0; i < lfp.length; i++) { q = lfp[i]; dx = q.x - x; dy = q.y - y; if (dx * dx + dy * dy < (q.r + r) * (q.r + r) * 0.8) { ok = false; break; } }
        if (ok) { var xn = (x - X.al1) / (X.ca1 - X.al1); lfp.push({ x: x, y: y, r: r, v: (rnd() * 4) | 0, a: rnd() * TAU, th: 0.05 + 0.9 * (0.72 * rnd() + 0.28 * (1 - xn)) }); }
      }
      for (n = 0; n < 14000 && gra.length < 110; n++) {
        var len = 22 + rnd() * 30, t = 7 + rnd() * 6, ang = Math.PI / 2 + (rnd() - 0.5) * 0.9;
        var ca = Math.cos(ang), sa = Math.sin(ang), hl = len / 2;
        var ex = Math.abs(ca) * hl + t / 2, ey = Math.abs(sa) * hl + t / 2;
        x = X.se1 + ex + 1 + rnd() * (X.an1 - X.se1 - 2 * ex - 2);
        y = X.y0 - ey * 0.5 + rnd() * (X.y1 - X.y0 + ey);
        var cs = [], k = Math.max(2, Math.ceil(len / t));
        for (i = 0; i < k; i++) { var u = -hl + t / 2 + (len - t) * i / (k - 1); cs.push([x + ca * u, y + sa * u]); }
        ok = true;
        for (i = 0; i < gra.length && ok; i++) {
          q = gra[i];
          if (Math.abs(q.x - x) > (q.len + len) / 2 + 2 || Math.abs(q.y - y) > (q.len + len) / 2 + 2) continue;
          for (var a1 = 0; a1 < cs.length && ok; a1++) for (var b1 = 0; b1 < q.cs.length; b1++) {
            dx = cs[a1][0] - q.cs[b1][0]; dy = cs[a1][1] - q.cs[b1][1];
            var rr2 = (t + q.t) / 2;
            if (dx * dx + dy * dy < rr2 * rr2 * 0.84) { ok = false; break; }
          }
        }
        if (ok) gra.push({ x: x, y: y, len: len, t: t, ca: ca, sa: sa, cs: cs, th: rnd(), n: Math.max(3, Math.round(t / 1.9)) });
      }
      for (n = 0; n < 3000 && cb.length < 340; n++) {
        x = X.al1 + 1 + rnd() * (X.an1 - X.al1 - 2);
        if (x > X.ca1 - 1 && x < X.se1 + 1) continue;
        y = X.y0 + rnd() * (X.y1 - X.y0);
        ok = true;
        for (i = 0; i < lfp.length && ok; i++) { q = lfp[i]; dx = q.x - x; dy = q.y - y; if (dx * dx + dy * dy < q.r * q.r * 1.1) ok = false; }
        for (i = 0; i < gra.length && ok; i++) { q = gra[i]; for (var c2 = 0; c2 < q.cs.length; c2++) { dx = q.cs[c2][0] - x; dy = q.cs[c2][1] - y; if (dx * dx + dy * dy < q.t * q.t * 0.36) { ok = false; break; } } }
        if (ok) cb.push([x, y, 0.8 + rnd() * 1.2]);
      }
      for (n = 0; n < 200; n++) {
        x = X.ca1 + rnd() * (X.se1 - X.ca1); y = X.y0 + rnd() * (X.y1 - X.y0);
        var l = 5 + rnd() * 13, an = rnd() * Math.PI;
        fib.push([x - Math.cos(an) * l / 2, y - Math.sin(an) * l / 2, x + Math.cos(an) * l / 2, y + Math.sin(an) * l / 2]);
      }
      for (n = 0; n < 110; n++) sol.push([X.al1 + rnd() * (X.an1 - X.al1), X.y0 + rnd() * (X.y1 - X.y0), rnd() * TAU, 0.5 + rnd() * 0.7]);
      var near = lfp.filter(function (p) { return p.x > -120; });
      for (n = 0; n < 36; n++) {
        var gp = near[(rnd() * near.length) | 0], phi = (rnd() - 0.5) * 2.4;
        var sx = gp.x + Math.cos(phi) * gp.r, sy = gp.y + Math.sin(phi) * gp.r;
        var fl = gra[(rnd() * gra.length) | 0], end = rnd() < 0.5 ? -1 : 1, h2 = fl.len / 2;
        var exx = fl.x + fl.ca * h2 * end, eyy = fl.y + fl.sa * h2 * end;
        var my = (sy + eyy) / 2 + (rnd() - 0.5) * 70;
        ions.push({
          p: [[sx, sy], [(sx + X.ca1) / 2, sy + (my - sy) * 0.35 + (rnd() - 0.5) * 30], [0, my], [(X.se1 + exx) / 2, my + (eyy - my) * 0.6 + (rnd() - 0.5) * 30], [exx, eyy]],
          d: 3.6 + rnd() * 2.4, o: rnd() * 10, w: rnd() * TAU
        });
      }
      for (n = 0; n < 7; n++) bok.push([rnd() * 680, rnd() * 520, 40 + rnd() * 70, 0.05 + rnd() * 0.08, rnd() < 0.3, rnd() * TAU]);
    })();
    var target = (function () {
      var best = lfp[0], i, q;
      for (i = 0; i < lfp.length; i++) { q = lfp[i]; if (q.x > -112 && q.x < -58 && Math.abs(q.y) < 70 && q.r > best.r) best = q; }
      return [best.x, best.y, best.r];
    })();

    function catmull(p, u) {
      var n = p.length - 1, s = u * n, i = Math.min(n - 1, Math.floor(s)), t = s - i;
      var p0 = p[Math.max(0, i - 1)], p1 = p[i], p2 = p[i + 1], p3 = p[Math.min(n, i + 2)], t2 = t * t, t3 = t2 * t;
      return [
        0.5 * (2 * p1[0] + (-p0[0] + p2[0]) * t + (2 * p0[0] - 5 * p1[0] + 4 * p2[0] - p3[0]) * t2 + (-p0[0] + 3 * p1[0] - 3 * p2[0] + p3[0]) * t3),
        0.5 * (2 * p1[1] + (-p0[1] + p2[1]) * t + (2 * p0[1] - 5 * p1[1] + 4 * p2[1] - p3[1]) * t2 + (-p0[1] + 3 * p1[1] - 3 * p2[1] + p3[1]) * t3)
      ];
    }
    function rrect(g, x, y, w, h, r) {
      g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r);
      g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath();
    }
    function pill(g, txt, x, y, fs, align, font) {
      g.font = '600 ' + fs + 'px ' + font;
      var w = g.measureText(txt).width, px = fs * 0.7, h = fs * 1.75;
      var x0 = align === 'left' ? x : align === 'right' ? x - w - 2 * px : x - w / 2 - px;
      g.fillStyle = 'rgba(8,18,43,0.82)'; g.beginPath(); rrect(g, x0, y - h / 2, w + 2 * px, h, h / 2); g.fill();
      g.strokeStyle = 'rgba(255,255,255,0.12)'; g.lineWidth = 0.8; g.stroke();
      g.fillStyle = '#E8EEF8'; g.textBaseline = 'middle'; g.textAlign = 'left';
      g.fillText(txt, x0 + px, y + fs * 0.04);
    }
    function scaleBar(g, perUnit, unit, vals, x, y, k, fs, font) {
      var best = vals[0], i;
      for (i = 0; i < vals.length; i++) if (vals[i] / perUnit * k <= 104) best = vals[i];
      var len = best / perUnit * k;
      g.strokeStyle = 'rgba(255,255,255,0.92)'; g.lineWidth = 2; g.beginPath();
      g.moveTo(x - len, y); g.lineTo(x, y); g.moveTo(x - len, y - 4); g.lineTo(x - len, y + 4); g.moveTo(x, y - 4); g.lineTo(x, y + 4); g.stroke();
      g.font = '650 ' + fs + 'px ' + font; g.fillStyle = '#FFFFFF'; g.textAlign = 'center'; g.textBaseline = 'bottom';
      g.fillText(best + ' ' + unit, x - len / 2, y - 6);
    }
    function fsz(s, units, k) { return Math.max(units, (s.minPx || 10) / ((s.pxu || 1) * k)); }

    function drawL1(g, s, S) {
      var t = s.t, soc = s.soc1 == null ? s.soc : s.soc1, dir = s.dir, A = s.m1, i, j, q, x, y;
      g.save();
      g.globalAlpha = A;
      if (s.win) { g.beginPath(); rrect(g, s.win[0], s.win[1], s.win[2], s.win[3], 9.5); g.clip(); }
      g.translate(s.a1[0], s.a1[1]); g.scale(s.k1, s.k1); g.translate(-s.c1[0], -s.c1[1]);
      var bg = g.createLinearGradient(X.al0, X.y0, X.cu1, X.y1);
      bg.addColorStop(0, '#0C1838'); bg.addColorStop(0.5, '#142A5A'); bg.addColorStop(1, '#0C1838');
      g.fillStyle = bg; g.fillRect(X.al0 - 60, X.y0 - 60, X.cu1 - X.al0 + 120, X.y1 - X.y0 + 120);
      g.globalAlpha = A * 0.55;
      for (i = 0; i < sol.length; i++) {
        q = sol[i]; x = q[0] + Math.sin(t * q[3] + q[2]) * 3.2; y = q[1] + Math.cos(t * q[3] * 0.8 + q[2] * 1.3) * 3.2;
        g.drawImage(S.sol, x - 2.4, y - 2.4, 4.8, 4.8);
      }
      g.globalAlpha = A;
      g.fillStyle = 'rgba(214,226,246,0.16)'; g.fillRect(X.ca1, X.y0 - 60, X.se1 - X.ca1, X.y1 - X.y0 + 120);
      g.save(); g.beginPath(); g.rect(X.ca1, X.y0 - 60, X.se1 - X.ca1, X.y1 - X.y0 + 120); g.clip();
      g.lineWidth = 0.9; g.strokeStyle = 'rgba(232,240,252,0.42)'; g.beginPath();
      for (i = 0; i < fib.length; i++) { q = fib[i]; g.moveTo(q[0], q[1]); g.lineTo(q[2], q[3]); }
      g.stroke(); g.restore();
      var al = g.createLinearGradient(X.al0, 0, X.al1, 0);
      al.addColorStop(0, '#6F7B8C'); al.addColorStop(0.45, '#EEF2F6'); al.addColorStop(1, '#94A0B1');
      g.fillStyle = al; g.fillRect(X.al0 - 60, X.y0 - 60, X.al1 - X.al0 + 60, X.y1 - X.y0 + 120);
      var cu = g.createLinearGradient(X.an1, 0, X.cu1, 0);
      cu.addColorStop(0, '#7C3F15'); cu.addColorStop(0.5, '#EAA66C'); cu.addColorStop(1, '#94511F');
      g.fillStyle = cu; g.fillRect(X.an1, X.y0 - 60, X.cu1 - X.an1 + 60, X.y1 - X.y0 + 120);
      g.fillStyle = 'rgba(6,8,12,0.9)'; g.beginPath();
      for (i = 0; i < cb.length; i++) { q = cb[i]; g.moveTo(q[0] + q[2], q[1]); g.arc(q[0], q[1], q[2], 0, TAU); }
      g.fill();
      for (i = 0; i < lfp.length; i++) {
        q = lfp[i];
        var f = sm((q.th - soc) / 0.07 + 0.5), D = q.r * 2.5;
        g.save(); g.translate(q.x, q.y); g.rotate(q.a);
        g.drawImage(S.g[q.v], -D / 2, -D / 2, D, D);
        if (f > 0.02) {
          var rc = q.r * 0.8 * Math.sqrt(f);
          g.globalAlpha = A * 0.8; g.drawImage(S.core, -rc, -rc, rc * 2, rc * 2); g.globalAlpha = A;
          if (f < 0.97) { g.strokeStyle = 'rgba(255,240,190,0.85)'; g.lineWidth = 0.7; g.beginPath(); g.arc(0, 0, rc, 0, TAU); g.stroke(); }
        }
        g.restore();
      }
      g.beginPath();
      for (i = 0; i < gra.length; i++) {
        q = gra[i];
        var h = q.len / 2 - q.t / 2, an = Math.atan2(q.sa, q.ca);
        var ax = q.x - q.ca * h, ay = q.y - q.sa * h, bx = q.x + q.ca * h, by = q.y + q.sa * h;
        g.moveTo(ax + Math.cos(an + Math.PI / 2) * q.t / 2, ay + Math.sin(an + Math.PI / 2) * q.t / 2);
        g.arc(ax, ay, q.t / 2, an + Math.PI / 2, an + Math.PI * 1.5);
        g.arc(bx, by, q.t / 2, an - Math.PI / 2, an + Math.PI / 2);
        g.closePath();
      }
      g.fillStyle = '#181C24'; g.fill();
      g.strokeStyle = 'rgba(130,145,170,0.55)'; g.lineWidth = 0.8; g.stroke();
      g.beginPath();
      var gold = [];
      for (i = 0; i < gra.length; i++) {
        q = gra[i];
        var nx = -q.sa, ny = q.ca, hl = q.len / 2 - 2.2, fg = cl(soc * 1.15 - 0.06 + (q.th - 0.5) * 0.3);
        for (j = 1; j < q.n; j++) {
          var off = -q.t / 2 + q.t * j / q.n, ox = nx * off, oy = ny * off;
          g.moveTo(q.x - q.ca * hl + ox, q.y - q.sa * hl + oy); g.lineTo(q.x + q.ca * hl + ox, q.y + q.sa * hl + oy);
          if (fg > 0.01) {
            var L = hl * fg * (0.82 + 0.18 * Math.sin(j * 1.9 + q.th * 9)), mo = off - q.t / q.n * 0.5;
            gold.push([q, nx * mo, ny * mo, hl, L]);
          }
        }
      }
      g.strokeStyle = 'rgba(92,104,126,0.95)'; g.lineWidth = 0.55; g.stroke();
      if (gold.length) {
        g.beginPath();
        for (i = 0; i < gold.length; i++) {
          var gq = gold[i], qq = gq[0];
          g.moveTo(qq.x - qq.ca * gq[3] + gq[1], qq.y - qq.sa * gq[3] + gq[2]);
          g.lineTo(qq.x - qq.ca * (gq[3] - gq[4]) + gq[1], qq.y - qq.sa * (gq[3] - gq[4]) + gq[2]);
          g.moveTo(qq.x + qq.ca * gq[3] + gq[1], qq.y + qq.sa * gq[3] + gq[2]);
          g.lineTo(qq.x + qq.ca * (gq[3] - gq[4]) + gq[1], qq.y + qq.sa * (gq[3] - gq[4]) + gq[2]);
        }
        g.strokeStyle = 'rgba(255,196,64,0.35)'; g.lineWidth = 1.9; g.stroke();
        g.strokeStyle = 'rgba(255,218,120,0.98)'; g.lineWidth = 0.75; g.stroke();
      }
      var span = X.y1 - X.y0 + 8, ne = 11, ve = 62 * (dir > 0 ? 1 : -1), pos = [];
      for (i = 0; i < ne; i++) {
        var ya = X.y0 - 4 + ((((i / ne) * span - t * ve) % span) + span) % span;
        var yc = X.y0 - 4 + ((((i / ne) * span + t * ve + 9) % span) + span) % span;
        pos.push([(X.al0 + X.al1) / 2, ya], [(X.an1 + X.cu1) / 2, yc]);
      }
      g.globalCompositeOperation = 'lighter';
      for (i = 0; i < pos.length; i++) { g.globalAlpha = A * 0.8; g.drawImage(S.eGlow, pos[i][0] - 7, pos[i][1] - 7, 14, 14); }
      var ip = [];
      for (i = 0; i < ions.length; i++) {
        q = ions[i];
        var u = ((t + q.o) / q.d) % 1;
        for (j = 3; j >= 0; j--) {
          var uu = u - j * 0.018;
          if (uu < 0) continue;
          var w0 = dir < 0 ? 1 - uu : uu, p = catmull(q.p, w0), w = Math.sin(w0 * 19 + q.w) * 1.5, al2 = sm(w0 / 0.08) * sm((1 - w0) / 0.08);
          if (j === 0) { ip.push([p[0] + w, p[1] - w * 0.6, al2]); g.globalAlpha = A * al2 * 0.9; g.drawImage(S.liGlow, p[0] + w - 9, p[1] - w * 0.6 - 9, 18, 18); }
          else { g.globalAlpha = A * al2 * (0.32 - j * 0.08); g.drawImage(S.liGlow, p[0] + w - 5, p[1] - w * 0.6 - 5, 10, 10); }
        }
      }
      g.globalCompositeOperation = 'source-over';
      for (i = 0; i < pos.length; i++) { g.globalAlpha = A; g.drawImage(S.e, pos[i][0] - 2.1, pos[i][1] - 2.1, 4.2, 4.2); }
      for (i = 0; i < ip.length; i++) { g.globalAlpha = A * ip[i][2]; g.drawImage(S.li, ip[i][0] - 2.7, ip[i][1] - 2.7, 5.4, 5.4); }
      g.globalAlpha = A;
      if (s.lab > 0.01) {
        g.globalAlpha = A * s.lab;
        var f1 = fsz(s, 11, s.k1);
        if (!s.small) {
          pill(g, 'Aluminiumfolie', X.al0 + 2, X.y0 + 18, f1 * 0.92, 'left', s.font);
          pill(g, 'Kupferfolie', X.cu1 - 2, X.y0 + 18, f1 * 0.92, 'right', s.font);
          pill(g, 'Elektrolyt', (X.al1 + X.ca1) / 2, X.y0 + 48, f1 * 0.92, 'center', s.font);
        }
        pill(g, s.small ? 'Kathode' : 'Kathode · LiFePO₄', (X.al1 + X.ca1) / 2, X.y1 - 18, f1, 'center', s.font);
        pill(g, 'Separator', 0, X.y1 - 18 - f1 * 2.4, f1 * 0.92, 'center', s.font);
        pill(g, s.small ? 'Anode' : 'Anode · Graphit', (X.se1 + X.an1) / 2, X.y1 - 18, f1, 'center', s.font);
      }
      g.restore();
    }

    /* ---------------- L3: Kristallgitter ---------------- */
    var CX = -118, GX = 124, FOC = 760;
    var CR = (function () {
      var nx = 4, ny = 3, nz = 3, dx = 40, dy = 38, dz = 38, oct = [], tet = [], ch = [], i, j, k;
      for (i = 0; i < nx; i++) for (j = 0; j < ny; j++) for (k = 0; k < nz; k++) oct.push({ p: [(i - (nx - 1) / 2) * dx, (j - (ny - 1) / 2) * dy, (k - (nz - 1) / 2) * dz], i: i, j: j, k: k });
      for (i = 0; i < nx - 1; i++) for (j = 0; j < ny - 1; j++) for (k = 0; k < nz; k++) tet.push({ p: [(i + 0.5 - (nx - 1) / 2) * dx, (j + 0.5 - (ny - 1) / 2) * dy, (k - (nz - 1) / 2) * dz] });
      for (j = 0; j < ny; j++) for (k = 0; k < nz - 1; k++) ch.push({ y: (j - (ny - 1) / 2) * dy, z: (k + 0.5 - (nz - 1) / 2) * dz, off: (rnd() - 0.5) * 0.9, j: j, k: k });
      var sx = []; for (i = 0; i < nx; i++) sx.push((i + 0.5 - nx / 2) * dx);
      var R = 15.5, OV = [[R, 0, 0], [-R, 0, 0], [0, R, 0], [0, -R, 0], [0, 0, R], [0, 0, -R]];
      var OF = []; for (var a = 0; a < 2; a++) for (var b = 2; b < 4; b++) for (var c = 4; c < 6; c++) OF.push([a, b, c]);
      var T = 12.5 / Math.sqrt(3), TV = [[T, T, T], [T, -T, -T], [-T, T, -T], [-T, -T, T]], TF = [[0, 1, 2], [0, 1, 3], [0, 2, 3], [1, 2, 3]];
      return { nx: nx, ny: ny, oct: oct, tet: tet, ch: ch, sx: sx, OV: OV, OF: OF, TV: TV, TF: TF, exit: nx / 2 * dx + 30, top: -(ny - 1) / 2 * dy - 20 };
    })();
    var GRA = (function () {
      var a = 19, b = a / Math.sqrt(3), C = 8, RW = 6, cen = [], vk = {}, V = [], E = [], ek = {}, r, c, kk;
      for (r = 0; r < RW; r++) for (c = 0; c < C; c++) cen.push([c * a + (r % 2) * a / 2, r * a * Math.sqrt(3) / 2, r, c]);
      var mx = 0, mz = 0; cen.forEach(function (p) { mx += p[0]; mz += p[1]; }); mx /= cen.length; mz /= cen.length;
      cen.forEach(function (p) { p[0] -= mx; p[1] -= mz; });
      function vid(x, z) { var key = Math.round(x * 10) + ':' + Math.round(z * 10); if (!(key in vk)) { vk[key] = V.length; V.push([x, z]); } return vk[key]; }
      cen.forEach(function (p) {
        var ids = [];
        for (kk = 0; kk < 6; kk++) { var an = (60 * kk + 30) * Math.PI / 180; ids.push(vid(p[0] + b * Math.cos(an), p[1] + b * Math.sin(an))); }
        for (kk = 0; kk < 6; kk++) { var e0 = ids[kk], e1 = ids[(kk + 1) % 6], key = Math.min(e0, e1) + '-' + Math.max(e0, e1); if (!ek[key]) { ek[key] = 1; E.push([e0, e1]); } }
      });
      var minx = 1e9, maxx = -1e9, minz = 1e9, maxz = -1e9;
      V.forEach(function (v) { minx = Math.min(minx, v[0]); maxx = Math.max(maxx, v[0]); minz = Math.min(minz, v[1]); maxz = Math.max(maxz, v[1]); });
      var sites = cen.filter(function (p) { return (p[3] + 2 * p[2] + (p[2] % 2)) % 3 === 0; }).map(function (p) { return [p[0], p[1], (p[0] - minx) / (maxx - minx)]; });
      return { V: V, E: E, ys: [-48, -16, 16, 48], sh: b * 0.5, sites: sites, minx: minx, maxx: maxx, minz: minz, maxz: maxz };
    })();
    var fions = [], elc = [];
    (function () {
      for (var i = 0; i < 9; i++) fions.push({ y: (rnd() - 0.5) * 90, ye: (rnd() - 0.5) * 80, d: 2.6 + rnd() * 1.6, o: rnd() * 6, w: rnd() * TAU });
      for (i = 0; i < 12; i++) elc.push({ x: (rnd() - 0.5) * 120, d: 1.6 + rnd() * 1.2, o: rnd() * 4, s: i % 2 });
    })();

    function rot(v, cy, sy, cp, sp) {
      var x = v[0] * cy + v[2] * sy, z = -v[0] * sy + v[2] * cy, y = v[1];
      return [x, y * cp - z * sp, y * sp + z * cp];
    }
    function shade(rgb, f) { return 'rgb(' + Math.round(Math.min(255, rgb[0] * f)) + ',' + Math.round(Math.min(255, rgb[1] * f)) + ',' + Math.round(Math.min(255, rgb[2] * f)) + ')'; }
    var LX = -0.38, LY = -0.72, LZ = 0.58;

    function drawL3(g, s, S) {
      var t = s.t, A = s.m3, dir = s.dir, i, j, q;
      var fc = 1 - cl(s.socC == null ? s.soc : s.socC), fg = cl(s.socA == null ? s.soc : s.socA);
      g.save();
      g.globalAlpha = A;
      if (s.win) { g.beginPath(); rrect(g, s.win[0], s.win[1], s.win[2], s.win[3], 9.5); g.clip(); }
      g.translate(s.a3[0], s.a3[1]); g.scale(s.k3, s.k3); g.translate(-s.c3[0], -s.c3[1]);
      var bg = g.createRadialGradient(0, 0, 20, 0, 0, 420);
      bg.addColorStop(0, '#17295C'); bg.addColorStop(1, '#0A1430');
      g.fillStyle = bg; g.fillRect(-700, -500, 1400, 1000);
      g.globalAlpha = A * 0.5;
      for (i = 0; i < sol.length; i++) {
        q = sol[i];
        g.drawImage(S.sol, q[0] * 1.9 + Math.sin(t * q[3] + q[2]) * 5 - 4, q[1] * 1.3 + Math.cos(t * q[3] + q[2]) * 5 - 4, 8, 8);
      }
      g.globalAlpha = A;

      var cyw = (-24 + 9 * Math.sin(t * 0.23)) * Math.PI / 180, cpt = -17 * Math.PI / 180;
      var cY = Math.cos(cyw), sY = Math.sin(cyw), cP = Math.cos(cpt), sP = Math.sin(cpt);
      var occ = [];
      for (i = 0; i < CR.ch.length; i++) {
        var qv = fc * (CR.nx + 0.8) - 0.4 + CR.ch[i].off, row = [];
        for (j = 0; j < CR.nx; j++) row.push(cl(qv - j));
        occ.push(row);
      }
      function proj3(v) { var r = rot(v, cY, sY, cP, sP), f = FOC / (FOC - r[2]); return [CX + r[0] * f, r[1] * f, r[2], f]; }
      var items = [];
      for (i = 0; i < CR.oct.length; i++) {
        var o = CR.oct[i], lit = 0, cnt = 0;
        for (j = 0; j < CR.ch.length; j++) {
          var cc = CR.ch[j];
          if (cc.j !== o.j || (cc.k !== o.k && cc.k !== o.k - 1)) continue;
          lit += occ[j][o.i]; cnt++;
          if (o.i - 1 >= 0) { lit += occ[j][o.i - 1]; cnt++; }
        }
        var fe = cnt ? sm(lit / cnt * 1.2) : 0;
        var col = [FE3[0] + (FE2[0] - FE3[0]) * fe, FE3[1] + (FE2[1] - FE3[1]) * fe, FE3[2] + (FE2[2] - FE3[2]) * fe];
        var pv = [];
        for (j = 0; j < 6; j++) pv.push(proj3([o.p[0] + CR.OV[j][0], o.p[1] + CR.OV[j][1], o.p[2] + CR.OV[j][2]]));
        for (j = 0; j < CR.OF.length; j++) {
          var fa = CR.OF[j], d0 = CR.OV[fa[0]], d1 = CR.OV[fa[1]], d2 = CR.OV[fa[2]];
          var nrm = rot([d0[0] + d1[0] + d2[0], d0[1] + d1[1] + d2[1], d0[2] + d1[2] + d2[2]], cY, sY, cP, sP);
          var nl = Math.sqrt(nrm[0] * nrm[0] + nrm[1] * nrm[1] + nrm[2] * nrm[2]);
          if (nrm[2] / nl < -0.05) continue;
          var lam = Math.max(0, (nrm[0] * LX + nrm[1] * LY + nrm[2] * LZ) / nl);
          items.push({ z: (pv[fa[0]][2] + pv[fa[1]][2] + pv[fa[2]][2]) / 3, k: 0, pts: [pv[fa[0]], pv[fa[1]], pv[fa[2]]], c: shade(col, 0.55 + 0.6 * lam), a: 0.9 });
        }
        for (j = 0; j < 6; j++) items.push({ z: pv[j][2] + 0.5, k: 1, x: pv[j][0], y: pv[j][1], r: 2.4 * pv[j][3] });
      }
      for (i = 0; i < CR.tet.length; i++) {
        var tt = CR.tet[i], tv = [];
        for (j = 0; j < 4; j++) tv.push(proj3([tt.p[0] + CR.TV[j][0], tt.p[1] + CR.TV[j][1], tt.p[2] + CR.TV[j][2]]));
        for (j = 0; j < 4; j++) {
          var tf = CR.TF[j], e0 = CR.TV[tf[0]], e1 = CR.TV[tf[1]], e2 = CR.TV[tf[2]];
          var tn = rot([e0[0] + e1[0] + e2[0], e0[1] + e1[1] + e2[1], e0[2] + e1[2] + e2[2]], cY, sY, cP, sP);
          var tl = Math.sqrt(tn[0] * tn[0] + tn[1] * tn[1] + tn[2] * tn[2]);
          if (tn[2] / tl < -0.05) continue;
          var lm = Math.max(0, (tn[0] * LX + tn[1] * LY + tn[2] * LZ) / tl);
          items.push({ z: (tv[tf[0]][2] + tv[tf[1]][2] + tv[tf[2]][2]) / 3, k: 0, pts: [tv[tf[0]], tv[tf[1]], tv[tf[2]]], c: shade(PO4, 0.55 + 0.6 * lm), a: 0.92 });
        }
        for (j = 0; j < 4; j++) items.push({ z: tv[j][2] + 0.5, k: 1, x: tv[j][0], y: tv[j][1], r: 2.2 * tv[j][3] });
      }
      for (i = 0; i < CR.ch.length; i++) {
        var c3 = CR.ch[i];
        for (j = 0; j < CR.nx; j++) {
          var oc = occ[i][j];
          if (oc <= 0.01) continue;
          var lx = CR.sx[j] + (1 - oc) * (CR.exit - CR.sx[j]), la = oc < 0.3 ? oc / 0.3 : 1;
          var lp = proj3([lx, c3.y, c3.z]);
          items.push({ z: lp[2] + 1, k: 2, x: lp[0], y: lp[1], r: 6.6 * lp[3], a: la });
        }
      }
      items.sort(function (m, n) { return m.z - n.z; });
      g.lineJoin = 'round';
      for (i = 0; i < items.length; i++) {
        q = items[i];
        if (q.k === 0) {
          g.globalAlpha = A * q.a; g.fillStyle = q.c; g.beginPath();
          g.moveTo(q.pts[0][0], q.pts[0][1]); g.lineTo(q.pts[1][0], q.pts[1][1]); g.lineTo(q.pts[2][0], q.pts[2][1]); g.closePath(); g.fill();
          g.globalAlpha = A * 0.3; g.strokeStyle = '#FFFFFF'; g.lineWidth = 0.6; g.stroke();
        } else if (q.k === 1) {
          g.globalAlpha = A; g.drawImage(S.o, q.x - q.r, q.y - q.r, q.r * 2, q.r * 2);
        } else {
          g.globalAlpha = A * q.a * 0.75; g.globalCompositeOperation = 'lighter';
          g.drawImage(S.liGlow, q.x - q.r * 2.4, q.y - q.r * 2.4, q.r * 4.8, q.r * 4.8);
          g.globalCompositeOperation = 'source-over'; g.globalAlpha = A * q.a;
          g.drawImage(S.li, q.x - q.r, q.y - q.r, q.r * 2, q.r * 2);
        }
      }

      /* Graphit-Schichten */
      var gyw = (24 + 6 * Math.sin(t * 0.19 + 1)) * Math.PI / 180, gpt = -21 * Math.PI / 180;
      var gcY = Math.cos(gyw), gsY = Math.sin(gyw), gcP = Math.cos(gpt), gsP = Math.sin(gpt);
      function projG(x, y, z) { var r = rot([x, y, z], gcY, gsY, gcP, gsP), f = FOC / (FOC - r[2]); return [GX + r[0] * f, r[1] * f, r[2], f]; }
      var layers = [];
      for (i = 0; i < GRA.ys.length; i++) {
        var yy = GRA.ys[i], shx = i % 2 ? GRA.sh : 0, PV = [];
        for (j = 0; j < GRA.V.length; j++) PV.push(projG(GRA.V[j][0] + shx, yy, GRA.V[j][1]));
        var corners = [projG(GRA.minx - 4, yy, GRA.minz - 4), projG(GRA.maxx + 4, yy, GRA.minz - 4), projG(GRA.maxx + 4, yy, GRA.maxz + 4), projG(GRA.minx - 4, yy, GRA.maxz + 4)];
        layers.push({ z: projG(0, yy, 0)[2] - 0.2, kind: 0, pv: PV, cn: corners });
      }
      for (i = 0; i < GRA.ys.length - 1; i++) {
        var gy = (GRA.ys[i] + GRA.ys[i + 1]) / 2, LS = [];
        for (j = 0; j < GRA.sites.length; j++) {
          var st = GRA.sites[j], arr = cl((fg * 1.18 - 0.06 - st[2]) / 0.16 + (i - 1) * 0.04);
          if (arr <= 0.01) continue;
          var ex2 = GRA.minx - 18, px = ex2 + (st[0] - ex2) * sm(arr);
          LS.push([projG(px, gy, st[1]), sm(arr * 2.5)]);
        }
        layers.push({ z: projG(0, gy, 0)[2], kind: 1, ls: LS });
      }
      layers.sort(function (m, n) { return m.z - n.z; });
      var AG = A * (s.g3 == null ? 1 : s.g3);
      for (i = 0; i < layers.length && AG > 0.003; i++) {
        var Ly = layers[i];
        if (Ly.kind === 0) {
          g.globalAlpha = AG * 0.22; g.fillStyle = '#5B6C8C'; g.beginPath();
          g.moveTo(Ly.cn[0][0], Ly.cn[0][1]); for (j = 1; j < 4; j++) g.lineTo(Ly.cn[j][0], Ly.cn[j][1]); g.closePath(); g.fill();
          g.globalAlpha = AG * 0.9; g.strokeStyle = 'rgba(160,176,202,0.8)'; g.lineWidth = 1.2; g.beginPath();
          for (j = 0; j < GRA.E.length; j++) { var E0 = Ly.pv[GRA.E[j][0]], E1 = Ly.pv[GRA.E[j][1]]; g.moveTo(E0[0], E0[1]); g.lineTo(E1[0], E1[1]); }
          g.stroke();
          g.globalAlpha = AG;
          for (j = 0; j < Ly.pv.length; j++) { var cp = Ly.pv[j], cr2 = 2.5 * cp[3]; g.drawImage(S.c, cp[0] - cr2, cp[1] - cr2, cr2 * 2, cr2 * 2); }
        } else {
          for (j = 0; j < Ly.ls.length; j++) {
            var lq = Ly.ls[j][0], la2 = Ly.ls[j][1], lr = 5.8 * lq[3];
            g.globalAlpha = AG * la2 * 0.7; g.globalCompositeOperation = 'lighter';
            g.drawImage(S.liGlow, lq[0] - lr * 2.3, lq[1] - lr * 2.3, lr * 4.6, lr * 4.6);
            g.globalCompositeOperation = 'source-over'; g.globalAlpha = AG * la2;
            g.drawImage(S.li, lq[0] - lr, lq[1] - lr, lr * 2, lr * 2);
          }
        }
      }

      /* Ionen mit Lösungsmittelhülle zwischen Kathode und Anode */
      var x0 = CX + CR.exit * 0.92, x1 = GX + GRA.minx - 16;
      for (i = 0; i < fions.length; i++) {
        q = fions[i];
        var u = ((t + q.o) / q.d) % 1;
        for (j = 3; j >= 0; j--) {
          var uu = u - j * 0.03;
          if (uu < 0) continue;
          var w0 = dir < 0 ? 1 - uu : uu, fx = x0 + (x1 - x0) * w0, fy = q.y * (1 - w0) + q.ye * w0 + Math.sin(w0 * 10 + q.w) * 6;
          var fa2 = sm(w0 / 0.12) * sm((1 - w0) / 0.12);
          if (j > 0) { g.globalCompositeOperation = 'lighter'; g.globalAlpha = A * fa2 * (0.3 - j * 0.08); g.drawImage(S.liGlow, fx - 8, fy - 8, 16, 16); g.globalCompositeOperation = 'source-over'; continue; }
          g.globalAlpha = A * fa2 * 0.55;
          for (var m = 0; m < 4; m++) { var oa = q.w + t * 1.4 + m * TAU / 4; g.drawImage(S.sol, fx + Math.cos(oa) * 11 - 4.5, fy + Math.sin(oa) * 8 - 4.5, 9, 9); }
          g.globalCompositeOperation = 'lighter'; g.globalAlpha = A * fa2 * 0.8;
          g.drawImage(S.liGlow, fx - 15, fy - 15, 30, 30);
          g.globalCompositeOperation = 'source-over'; g.globalAlpha = A * fa2;
          g.drawImage(S.li, fx - 6, fy - 6, 12, 12);
        }
      }
      /* Elektronen: verlassen die Kathode, erreichen die Anode über den äusseren Kreis */
      g.globalCompositeOperation = 'lighter';
      for (i = 0; i < elc.length; i++) {
        q = elc[i];
        var ue = ((t + q.o) / q.d) % 1, up = q.s === 0;
        var ex3 = up ? CX + q.x * 0.7 : GX + q.x * 0.7, ytop = -205, ybase = up ? CR.top : GRA.ys[0] - 12;
        var vv = (up ? dir > 0 : dir < 0) ? ue : 1 - ue, ey3 = ybase + (ytop - ybase) * vv;
        var ea = sm(ue / 0.15) * sm((1 - ue) / 0.15);
        g.globalAlpha = A * ea * 0.85; g.drawImage(S.eGlow, ex3 - 8, ey3 - 8, 16, 16);
        g.globalAlpha = A * ea; g.drawImage(S.e, ex3 - 2.6, ey3 - 2.6, 5.2, 5.2);
      }
      g.globalCompositeOperation = 'source-over';
      g.globalAlpha = A;
      if (s.lab > 0.01) {
        g.globalAlpha = A * s.lab;
        var f3 = fsz(s, 11, s.k3);
        pill(g, s.small ? 'LiFePO₄' : 'Kathode · LiFePO₄', CX, -128, f3, 'center', s.font);
        pill(g, s.small ? 'Graphit' : 'Anode · Graphit', GX, -128, f3, 'center', s.font);
        if (!s.small) {
          var lg = [[0, 'Lithium-Ion'], [1, 'Fe²⁺'], [2, 'Fe³⁺'], [3, 'Phosphat'], [4, 'Kohlenstoff']], fl = f3 * 0.9;
          g.font = '600 ' + fl + 'px ' + s.font; g.textBaseline = 'middle'; g.textAlign = 'left';
          var tw = 0; for (i = 0; i < lg.length; i++) tw += fl * 1.4 + g.measureText(lg[i][1]).width + fl * 1.6;
          var lx2 = -tw / 2, ly = 168;
          for (i = 0; i < lg.length; i++) {
            var kx = lx2 + fl * 0.55, r0 = fl * 0.5;
            if (lg[i][0] === 0) g.drawImage(S.li, kx - r0, ly - r0, r0 * 2, r0 * 2);
            else if (lg[i][0] === 4) g.drawImage(S.c, kx - r0 * 0.8, ly - r0 * 0.8, r0 * 1.6, r0 * 1.6);
            else {
              g.fillStyle = lg[i][0] === 1 ? shade(FE2, 1.05) : lg[i][0] === 2 ? shade(FE3, 1.1) : shade(PO4, 1);
              g.beginPath();
              if (lg[i][0] === 3) { g.moveTo(kx, ly - r0); g.lineTo(kx + r0, ly + r0 * 0.8); g.lineTo(kx - r0, ly + r0 * 0.8); }
              else { g.moveTo(kx, ly - r0 * 1.1); g.lineTo(kx + r0, ly); g.lineTo(kx, ly + r0 * 1.1); g.lineTo(kx - r0, ly); }
              g.closePath(); g.fill();
            }
            g.fillStyle = '#C9D4E8'; g.fillText(lg[i][1], lx2 + fl * 1.4, ly + fl * 0.04);
            lx2 += fl * 1.4 + g.measureText(lg[i][1]).width + fl * 1.6;
          }
        }
      }
      g.restore();
    }

    function draw(g, cw, ch, s) {
      var S = sprites(), k = cw / 680;
      g.setTransform(k, 0, 0, k, 0, 0);
      g.clearRect(0, 0, 680, 520);
      g.imageSmoothingEnabled = true;
      if (s.m1 > 0.003) drawL1(g, s, S);
      if (s.m3 > 0.003) drawL3(g, s, S);
      g.setTransform(k, 0, 0, k, 0, 0);
      g.globalAlpha = 1;
      if (s.film && (s.m1 > 0.003 || s.m3 > 0.003)) {
        var l3 = s.m3 > s.m1, cx = l3 ? s.c3[0] : s.c1[0], cy = l3 ? s.c3[1] : s.c1[1], mm = Math.max(s.m1, s.m3);
        g.globalCompositeOperation = 'lighter';
        for (var i = 0; i < bok.length; i++) {
          var b = bok[i], bx = ((b[0] - cx * 1.6 + Math.sin(s.t * 0.2 + b[5]) * 30) % 760 + 760) % 760 - 40, by = b[1] - cy * 1.2 + Math.cos(s.t * 0.17 + b[5]) * 20;
          g.globalAlpha = mm * b[3]; g.drawImage(b[4] ? S.bokehW : S.bokeh, bx - b[2], by - b[2], b[2] * 2, b[2] * 2);
        }
        g.globalCompositeOperation = 'source-over'; g.globalAlpha = 1;
      }
      if (s.sb && (s.m1 > 0.2 || s.m3 > 0.2)) {
        var fs = Math.max(11, (s.minPx || 10) / (s.pxu || 1));
        g.globalAlpha = (s.sbA == null ? 1 : s.sbA) * Math.max(s.m1, s.m3);
        if (s.m3 > s.m1) scaleBar(g, 1 / 80, 'nm', [0.2, 0.5, 1, 2], s.sb[0], s.sb[1], s.k3, fs, s.font);
        else scaleBar(g, 0.34, 'µm', [1, 2, 5, 10, 20, 50], s.sb[0], s.sb[1], s.k1, fs, s.font);
        g.globalAlpha = 1;
      }
    }
    return { draw: draw, target: target };
  }

  /* ------------------------------------------------------------------ Speicher: BMS, Leitungen, Stromfluss */
  var PEND = 1.4;
  var PCELL = { mb31: { W: 165.3, H: 194.8, ah: 314, name: 'MB31' }, mb56: { W: 334.4, H: 196.65, ah: 628, name: 'MB56' } };
  var PGEO = {};
  function packGeo(n, cell) {
    var key = n + (cell || 'mb31');
    if (PGEO[key]) return PGEO[key];
    var CC = PCELL[cell] || PCELL.mb31;
    var D = 68.4, H = CC.H, Wd = CC.W, stepX = D + 4, tz = 0.28 * Wd, top = -H / 2, bot = H / 2;
    var RT = 12.4, RH = 22, ET = 12;
    var rows = n === 16 ? 2 : 1, per = n / rows, cross = rows === 2 ? per - 1 : -1;
    var rowZ = function (r) { return rows === 1 ? 0 : r === 0 ? -(Wd / 2 + 30) : Wd / 2 + 30; };
    var pos = function (k) { return k < per ? { r: 0, c: k } : { r: 1, c: per - 1 - (k - per) }; };
    var cx = function (c) { return (c - (per - 1) / 2) * stepX; };
    var side = function (k) { return rows === 1 || k < per - 1 ? (k % 2 === 0 ? -1 : 1) : ((k - per) % 2 === 0 ? 1 : -1); };
    var zPlus = function (k) { if (k === n - 1) return rowZ(pos(k).r) - side(n - 2) * tz; if (k === cross) return rowZ(0) + tz; return rowZ(pos(k).r) + side(k) * tz; };
    var zMinus = function (k) { if (k === 0) return rowZ(0) - side(0) * tz; if (k - 1 === cross) return rowZ(1) - tz; return rowZ(pos(k).r) + side(k - 1) * tz; };
    var mix = function (p, q, u) { return [p[0] + (q[0] - p[0]) * u, p[1] + (q[1] - p[1]) * u, p[2] + (q[2] - p[2]) * u]; };
    var bez = function (p0, p1, p2, p3, m, out) {
      for (var i = out.length ? 1 : 0; i <= m; i++) {
        var u = i / m, v = 1 - u, a = v * v * v, b = 3 * v * v * u, c = 3 * v * u * u, d = u * u * u;
        out.push([a * p0[0] + b * p1[0] + c * p2[0] + d * p3[0], a * p0[1] + b * p1[1] + c * p2[1] + d * p3[1], a * p0[2] + b * p1[2] + c * p2[2] + d * p3[2]]);
      }
      return out;
    };
    var cells = [], k, i;
    for (k = 0; k < n; k++) { var q = pos(k), x = cx(q.c); cells.push({ x: x, z: rowZ(q.r), m: [x, top, zMinus(k)], p: [x, top, zPlus(k)] }); }
    var front = rowZ(rows - 1) + Wd / 2, hf = front + RT;
    // Gehäuse: Bodenplatte, Leisten oben und unten, Endplatten, Gewindestangen, Deckplatten
    var hx = (per - 1) / 2 * stepX + D / 2 + 2, hz = Wd / 2 + RT, yRail = top + (18 - RH) / 2;
    var hous = [];
    for (var r = 0; r < rows; r++) {
      var zc = rowZ(r), parts = [], P = function (id, c, s, kind) { parts.push({ id: id, c: c, s: s, kind: kind }); };
      P('slab', [0, bot + 6, zc], [2 * hx, 12, 2 * hz], 'base');
      P('rtf', [0, yRail, zc + Wd / 2 + RT / 2], [2 * hx, RH + 18, RT], 'rail');
      P('rtb', [0, yRail, zc - Wd / 2 - RT / 2], [2 * hx, RH + 18, RT], 'rail');
      P('rbf', [0, bot - 9, zc + Wd / 2 + RT / 2], [2 * hx, 18, RT], 'base');
      P('rbb', [0, bot - 9, zc - Wd / 2 - RT / 2], [2 * hx, 18, RT], 'base');
      var eTop = top - RH - 2, eBot = bot + 12, eh = eBot - eTop, ez = 2 * hz + 10;
      P('endl', [-(hx + ET / 2), (eTop + eBot) / 2, zc], [ET, eh, ez], 'endl');
      P('endr', [hx + ET / 2, (eTop + eBot) / 2, zc], [ET, eh, ez], 'endr');
      var rods = [[yRail, zc + hz + 2.6], [yRail, zc - hz - 2.6], [bot - 4, zc + hz + 2.6], [bot - 4, zc - hz - 2.6]];
      rods.forEach(function (rd, j) { P('rod' + j, [0, rd[0], rd[1]], [2 * hx + 2 * ET + 14, 4.2, 4.2], 'rod'); });
      var nuts = rods.map(function (rd) { return { t: (rd[0] - eTop) / eh, z: (rd[1] - zc) / ez }; });
      var covers = [];
      for (i = 0; i < per; i += 2) {
        var c2 = Math.min(i + 1, per - 1), x0 = i === 0 ? -hx + 0.3 : cx(i) - stepX / 2 + 1.5, x1 = c2 === per - 1 ? hx - 0.3 : cx(c2) + stepX / 2 - 1.5;
        covers.push({ c: [(x0 + x1) / 2, top - RH - 3, zc], s: [x1 - x0, 6, 2 * hz - 1] });
      }
      var inserts = [];
      covers.forEach(function (cv) { inserts.push((cv.c[0] - cv.s[0] / 2 + 9 + hx) / (2 * hx), (cv.c[0] + cv.s[0] / 2 - 9 + hx) / (2 * hx)); });
      hous.push({ r: r, z: zc, parts: parts, nuts: nuts, covers: covers, inserts: inserts });
    }
    var B = n === 4 ? { w: 128, h: 76 } : n === 8 ? { w: 156, h: 86 } : { w: 172, h: 92 };
    B.x = 0; B.y = 20; B.d = 16; B.con = 0.66 * B.w;
    B.z = front + 2 + B.d / 2; B.fz = B.z + B.d / 2; B.ty = B.y - B.h / 2;
    B.padB = [B.x - B.w / 2 + 0.115 * B.w, B.y - B.h / 2 + 0.73 * B.h, B.fz + 1.5];
    B.padP = [B.x - B.w / 2 + 0.885 * B.w, B.padB[1], B.fz + 1.5];
    var over = top - RH - 9;
    // Messleitungen: vom Stecker am BMS über die Kopfleiste zu jedem Pol und Verbinder
    var wires = [];
    for (i = 0; i <= n; i++) {
      var T = i === 0 ? cells[0].m : cells[i - 1].p;
      var px = B.x - B.con / 2 + B.con * (i + 0.5) / (n + 1);
      var tgt = [T[0], top - 3, T[2]];
      var E = [px + (tgt[0] - px) * 0.35, over, hf + 3];
      var path = [];
      bez([px, B.ty - 1, B.z + 2], [px, B.ty - 30, B.fz + 8], [px + (tgt[0] - px) * 0.3, top - RH + 10, hf + 6], E, 10, path);
      bez(E, [E[0] + (tgt[0] - E[0]) * 0.35, over - 10, E[2] - 6], [tgt[0], top - RH - 4, tgt[2] + (E[2] - tgt[2]) * 0.3], tgt, 12, path);
      wires.push(path);
    }
    // Hauptleitungen: B− zum BMS, P− vom BMS weg, P+ direkt vom Pluspol
    var b0 = cells[0].m, bp = cells[n - 1].p, sg = bp[0] >= 0 ? 1 : -1;
    var cB = [], cP = [], cM = [], cX = [];
    var Eb = [B.padB[0] + (b0[0] - B.padB[0]) * 0.75, over - 4, hf + 8];
    bez(B.padB, [B.padB[0] - 6, B.padB[1] - 18, B.fz + 30], [Eb[0], top - RH + 30, hf + 24], Eb, 12, cB);
    bez(Eb, [Eb[0] + (b0[0] - Eb[0]) * 0.4, over - 18, Eb[2] - 2], [b0[0], top - RH - 10, b0[2] + (Eb[2] - b0[2]) * 0.3], [b0[0], top - 4, b0[2]], 10, cB);
    var Ep = [bp[0] + sg * 8, over - 4, hf + 8], Fp = [bp[0] + sg * 22, bot + 4, hf + 46];
    bez([bp[0], top - 4, bp[2]], [bp[0], over - 18, bp[2] + (Ep[2] - bp[2]) * 0.3], [Ep[0], over - 14, Ep[2] - 10], Ep, 10, cP);
    bez(Ep, [Ep[0], top + 40, Ep[2] + 14], [Fp[0], Fp[1] - 40, Fp[2] - 12], Fp, 14, cP);
    var Fm = [B.padP[0] + 30, bot + 4, hf + 46];
    bez(B.padP, [B.padP[0] + 4, B.padP[1] + 14, B.fz + 26], [Fm[0], Fm[1] - 34, Fm[2] - 12], Fm, 14, cM);
    // Temperaturfühler T1 und T2 auf den Zellen, Leitung über die Kopfleiste zum BMS
    var ts = [];
    (n === 4 ? [1, 3] : n === 16 ? [13, 9] : [2, 6]).forEach(function (ci, j) {
      var C = cells[ci], tp = [C.x, top - 2.5, C.z + 22], tx = B.x + (j ? 1 : -1) * B.w * 0.42;
      var E = [tx + (tp[0] - tx) * 0.35, over - 5, hf + 3], path = [];
      bez([tx, B.ty - 1, B.z], [tx, B.ty - 28, B.fz + 8], [tx + (tp[0] - tx) * 0.3, top - RH + 8, hf + 6], E, 10, path);
      bez(E, [E[0] + (tp[0] - E[0]) * 0.35, over - 14, E[2] - 8], [tp[0], top - RH - 6, tp[2] + (E[2] - tp[2]) * 0.3], tp, 12, path);
      ts.push({ p: tp, c: ci, wire: path });
    });
    // Bei geschlossenem Deckel liegt das BMS oben auf den Deckplatten
    var cTop = top - RH - 6, zl = rowZ(rows - 1);
    var BL = { x: B.x, y: cTop - B.d / 2 - 0.5, z: zl };
    BL.padB = [B.x - B.w / 2 + 0.115 * B.w, cTop - B.d - 2, zl + 0.23 * B.h];
    BL.padP = [B.x - B.w / 2 + 0.885 * B.w, cTop - B.d - 2, zl + 0.23 * B.h];
    var hw = [], zs = zl - B.h / 2 - 22;
    for (i = 0; i <= n; i++) {
      var hx0 = B.x - B.con / 2 + B.con * (i + 0.5) / (n + 1), hp0 = [hx0, cTop - B.d / 2, zl - B.h / 2 - 1], hpath = [];
      bez(hp0, [hx0, hp0[1] - 6, hp0[2] - 9], [hx0 * 0.8, cTop - 6, zs + 5], [hx0 * 0.72, cTop + 0.5, zs], 10, hpath);
      hw.push(hpath);
    }
    var cB2 = [], cM2 = [], pb2 = BL.padB, pp2 = BL.padP;
    bez(pb2, [pb2[0] - 8, pb2[1] - 12, pb2[2] + 6], [pb2[0] - 28, cTop - 16, pb2[2] - 8], [pb2[0] - 32, cTop + 0.5, pb2[2] - 24], 12, cB2);
    var Em = [pp2[0] + 18, cTop - 12, hf + 8];
    bez(pp2, [pp2[0] + 6, pp2[1] - 16, pp2[2] + 10], [Em[0], Em[1] - 12, Em[2] - 22], Em, 10, cM2);
    bez(Em, [Em[0], top + 40, Em[2] + 14], [B.padP[0] + 30, bot - 36, hf + 34], [B.padP[0] + 30, bot + 4, hf + 46], 14, cM2);
    var slots = [{ c: [0, cTop - 0.3, zs + 2], w: B.con * 0.8, d: 10 }, { c: [pb2[0] - 32, cTop - 0.3, pb2[2] - 24], w: 14, d: 10 }];
    if (cross >= 0) {
      var xa = cells[cross].p, xb = cells[cross + 1].m;
      bez([xa[0], top - 4, xa[2]], [xa[0] + 6, over - 30, xa[2] + 12], [xb[0] + 6, over - 30, xb[2] - 12], [xb[0], top - 4, xb[2]], 16, cX);
    }
    // Strompfad vom äusseren Minus-Ende bis zum äusseren Plus-Ende
    var chain = [];
    chain.push({ e: 1, front: 1, fa: 1, pts: cM.slice().reverse() });
    chain.push({ e: 1, front: 1, pts: [[B.padP[0], B.padP[1], B.fz + 2], [B.padB[0], B.padB[1], B.fz + 2]] });
    chain.push({ e: 1, front: 1, pts: cB });
    for (k = 0; k < n; k++) {
      var C = cells[k];
      chain.push({ e: 0, pts: [[C.m[0], top - 2, C.m[2]], [C.p[0], top - 2, C.p[2]]] });
      if (k < n - 1) {
        var N = cells[k + 1];
        if (k === cross) chain.push({ e: 1, bar: k, pts: cX });
        else chain.push({ e: 1, bar: k, pts: [[C.p[0], top - 4.5, C.p[2]], [N.m[0], top - 4.5, N.m[2]]] });
      }
    }
    chain.push({ e: 1, front: 1, fb: 1, pts: cP });
    chain.forEach(function (s) {
      var cum = [0];
      for (var j = 1; j < s.pts.length; j++) { var a = s.pts[j - 1], b = s.pts[j]; cum.push(cum[j - 1] + Math.sqrt((b[0] - a[0]) * (b[0] - a[0]) + (b[1] - a[1]) * (b[1] - a[1]) + (b[2] - a[2]) * (b[2] - a[2]))); }
      s.cum = cum; s.len = cum[cum.length - 1];
    });
    var inside = function (pt) {
      if (pt[1] > top + 4 || Math.abs(pt[0]) > hx + 0.5) return 0;
      for (var h = 0; h < rows; h++) if (Math.abs(pt[2] - rowZ(h)) < hz - 0.5) return 1;
      return 0;
    };
    var mask = function (pts) { return pts.map(inside); };
    // bei geschlossenem Deckel verschwindet alles hinter der Vorderkante unter den Deckplatten
    var under = function (pts) { return pts.map(function (pt) { return pt[1] <= top + 4 && pt[2] < hf - 0.5 && Math.abs(pt[0]) <= hx + 0.5 ? 1 : 0; }); };
    var hotJ = rows === 2 ? 3 : Math.floor((n - 1) / 2);
    var hb = chain.filter(function (s) { return s.bar === hotJ; })[0];
    var G = {
      n: n, cell: cell, rows: rows, per: per, cross: cross, top: top, bot: bot, D: D, H: H, Wd: Wd, tz: tz, RT: RT, RH: RH, front: front, hf: hf, hx: hx, hz: hz,
      rowZ: rowZ, cells: cells, hous: hous, B: B, wires: wires, cB: cB, cP: cP, cM: cM, cX: cX, Fp: Fp, Fm: Fm, chain: chain,
      mW: wires.map(under), mB: under(cB), mP: under(cP), mM: under(cM), mX: mask(cX),
      ts: ts, BL: BL, hw: hw, cB2: cB2, cM2: cM2, slots: slots, m0: function (pts) { return pts.map(function () { return 0; }); },
      bmsTagL: [B.x - B.w * 0.18, cTop - B.d - 1, zl - 0.12 * B.h],
      hotJ: hotJ, hot: mix(hb.pts[0], hb.pts[1], 0.5), wireMid: wires[Math.floor(n / 2)][6], bmsTag: [B.x - B.w * 0.18, B.y - 8, B.fz],
      rodTag: [-hx + 26, yRail, rowZ(rows - 1) + hz + 2.6]
    };
    PGEO[key] = G;
    return G;
  }

  /* Ausgleich der Zellen: ein Zyklus, in dem eine Zelle voraus ist und vom BMS zurückgeholt wird */
  function balState(t, n, mode) {
    var Tc = mode === 'a' ? 8 : 11, cyc = Math.floor(t / Tc), u = (t - cyc * Tc) / Tc;
    var hi = (cyc * 5 + 2) % n, lo = (hi + Math.floor(n / 2) + 1) % n;
    if (lo === hi) lo = (hi + 1) % n;
    var ramp = smooth(u / 0.1), dec = 1 - smooth((u - 0.12) / 0.6), dv = ramp * dec;
    var v = [], k, mn = 9, mx = 0, sum = 0;
    for (k = 0; k < n; k++) {
      var j = ((k * 7919) % 23 / 22 - 0.5) * 0.006, d = 0;
      if (k === hi) d = 0.046 * dv;
      if (mode === 'a' && k === lo) d = -0.024 * dv;
      var x = 3.392 + j + d + 0.0008 * Math.sin(t * 0.9 + k);
      v.push(x); mn = Math.min(mn, x); mx = Math.max(mx, x); sum += x;
    }
    return { v: v, hi: hi, lo: lo, act: clamp01(dv * 3), dv: dv, avg: sum / n, dmv: Math.round((mx - mn) * 1000) };
  }

  /* Schutzfunktionen des BMS: je ein Ablauf mit Grenzwert, Abschaltung und Freigabe.
     own: 1 = Grenzwerte wie bei unserem BMS eingestellt, sonst typische Beispielwerte. */
  function makeProt() {
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function num(x, d) { var s = Math.abs(x).toFixed(d); return (x < 0 && +s !== 0 ? '−' : '') + s; }
    var TC = 12, ORDER = ['ot', 'otb', 'uv', 'ov', 'ut', 'oc'], cache = {};
    var DEF = {
      ot: { t: 'Übertemperatur', s: 'Fühler im Speicher', unit: ' °C', dec: 0, lo: 20, hi: 72, lim: 60, rel: 50, up: 1, blk: 'cd',
        K: [[0, 34], [0.1, 37], [0.3, 57], [0.36, 60.4], [0.42, 62], [0.55, 58], [0.7, 51], [0.76, 49], [0.88, 41], [1, 34]], F: [[-1, 80], [0, 0], [-1, 40]] },
      otb: { t: 'Übertemperatur', s: 'Sensor im BMS', unit: ' °C', dec: 0, lo: 30, hi: 102, lim: 90, rel: 70, up: 1, blk: 'cd',
        K: [[0, 46], [0.1, 52], [0.3, 86], [0.36, 90.5], [0.42, 92], [0.55, 85], [0.7, 72], [0.76, 69], [0.88, 58], [1, 46]], F: [[-1, 180], [0, 0], [-1, 80]] },
      uv: { t: 'Unterspannung', s: 'Zelle zu leer', unit: ' V', dec: 2, lo: 2.6, hi: 3.3, lim: 2.8, rel: 3.0, up: 0, blk: 'd', own: 1,
        K: [[0, 3.22], [0.12, 3.18], [0.24, 3.1], [0.31, 2.97], [0.36, 2.79], [0.42, 2.88], [0.5, 2.92], [0.62, 2.96], [0.74, 3.01], [0.86, 3.12], [1, 3.22]], F: [[-1, 60], [1, 30], [1, 30]] },
      ov: { t: 'Überspannung', s: 'Zelle zu voll', unit: ' V', dec: 2, lo: 3.3, hi: 3.72, lim: 3.65, rel: 3.4, up: 1, blk: 'c',
        K: [[0, 3.4], [0.12, 3.44], [0.24, 3.5], [0.31, 3.6], [0.36, 3.655], [0.39, 3.66], [0.47, 3.52], [0.6, 3.45], [0.74, 3.395], [0.86, 3.38], [1, 3.4]], F: [[1, 60], [-1, 15], [1, 60]] },
      ut: { t: 'Untertemperatur', s: 'Laden bei Frost', unit: ' °C', dec: 0, lo: -8, hi: 14, lim: 0, rel: 5, up: 0, blk: 'c',
        K: [[0, 8], [0.12, 6], [0.26, 2], [0.36, -0.4], [0.46, -3], [0.56, -2.4], [0.66, 2], [0.75, 5.3], [0.88, 7], [1, 8]], F: [[1, 40], [-1, 20], [1, 40]] },
      oc: { t: 'Überstrom', s: '100 A / 200 A', unit: ' A', dec: 0, lc: 100, ld: 200, own: 1,
        K: [[0, 0.45], [0.12, 0.5], [0.24, 0.75], [0.31, 1], [0.36, 1.1], [0.45, 1.14]] }
    };
    var TXT = {
      ot: 'Zwei Temperaturfühler, T1 und T2, sitzen direkt auf den Zellen. Wird es an einem zu heiss, etwa bei hoher Last im warmen Raum, trennt das BMS Laden und Entladen, bis die Zellen abgekühlt sind.',
      otb: 'Ein dritter Sensor sitzt im BMS bei den Leistungsschaltern, durch die der ganze Strom fliesst. Werden sie bei hohem Dauerstrom oder schlechter Belüftung zu heiss, trennt das BMS und schaltet nach dem Abkühlen wieder zu.',
      uv: 'Beim Entladen erreicht die schwächste Zelle zuerst die untere Grenze. Dann sperrt das BMS das Entladen, damit keine Zelle tiefentladen wird. Laden bleibt möglich, zum Beispiel mit Solarstrom am nächsten Morgen.',
      ov: 'Beim Laden ist meist eine Zelle zuerst voll. Erreicht sie die obere Grenze, sperrt das BMS das Laden, auch wenn die anderen noch nicht ganz voll sind. Entladen bleibt möglich.',
      ut: 'Unter 0 °C dürfen LiFePO4-Zellen nicht geladen werden, sonst lagert sich Lithium als Metall auf dem Graphit ab. Melden die Fühler Frost, sperrt das BMS das Laden. Entladen bleibt möglich.',
      oc: 'Unser BMS lässt beim Laden bis 100 A zu, beim Entladen bis 200 A. Fliesst mehr, trennt es nach kurzer Verzögerung, bei einem Kurzschluss sofort. Nach einer Wartezeit schaltet es wieder zu.'
    };
    function crv(K, u) {
      var i = 0, m = K.length;
      while (i < m - 2 && u > K[i + 1][0]) i++;
      var p0 = K[Math.max(0, i - 1)], p1 = K[i], p2 = K[i + 1], p3 = K[Math.min(m - 1, i + 2)];
      var h = (p2[0] - p1[0]) || 1, s = cl((u - p1[0]) / h), s2 = s * s, s3 = s2 * s;
      var m1 = (p2[1] - p0[1]) / ((p2[0] - p0[0]) || 1) * h, m2 = (p3[1] - p1[1]) / ((p3[0] - p1[0]) || 1) * h;
      return (2 * s3 - 3 * s2 + 1) * p1[1] + (s3 - 2 * s2 + s) * m1 + (3 * s2 - 2 * s3) * p2[1] + (s3 - s2) * m2;
    }
    function def(key, occ) {
      var D = DEF[key] || DEF.ot;
      if (key !== 'oc') return D;
      var c = occ === 'c', L = c ? D.lc : D.ld;
      return { t: D.t, s: D.s, unit: D.unit, dec: 0, lo: 0, hi: L * 1.3, lim: L, rel: 0, up: 1, blk: c ? 'c' : 'd', K: D.K, oc: true, own: D.own, dir: c ? 1 : -1 };
    }
    // Verlauf über einen Zyklus, dazu die Zeitpunkte von Abschaltung und Freigabe
    function curve(key, occ) {
      var id = key === 'oc' ? 'oc' + (occ === 'c' ? 'c' : 'd') : key;
      if (cache[id]) return cache[id];
      var D = def(key, occ), N = 240, vs = [], i, u, trip = 1, rel = 1, ti = -1;
      if (D.oc) {
        for (i = 0; i <= N && ti < 0; i++) if (crv(D.K, Math.min(i / N, 0.45)) >= 1) ti = i;
        trip = ti / N + 0.035; rel = 0.72;
        for (i = 0; i <= N; i++) { u = i / N; vs.push(u < trip ? D.lim * crv(D.K, Math.min(u, 0.45)) : u < rel ? 0 : D.lim * 0.45 * sm((u - rel) / 0.04)); }
      } else {
        for (i = 0; i <= N; i++) vs.push(crv(D.K, i / N));
        for (i = 0; i <= N; i++) if (D.up ? vs[i] >= D.lim : vs[i] <= D.lim) { ti = i; trip = i / N; break; }
        for (i = Math.max(ti, 0); i <= N; i++) if (D.up ? vs[i] <= D.rel : vs[i] >= D.rel) { rel = i / N; break; }
      }
      cache[id] = { D: D, vs: vs, N: N, trip: trip, rel: rel };
      return cache[id];
    }
    function frame(key, occ, t, n) {
      var C = curve(key, occ), D = C.D, N = C.N, u = (((t % TC) + TC) % TC) / TC;
      var f = u * N, i = Math.min(N - 1, Math.floor(f)), v = C.vs[i] + (C.vs[i + 1] - C.vs[i]) * (f - i);
      var ph = u < C.trip ? 0 : u < C.rel ? 1 : 2;
      var F = D.oc ? [[D.dir, v], [0, 0], [D.dir, v]] : D.F, fl = F[ph];
      var gap = function (b, f1, f2) { return f1[0] === f2[0] ? 1 : cl(Math.abs(u - b) / 0.02); };
      var fa = fl[0] ? gap(C.trip, F[0], F[1]) * gap(C.rel, F[1], F[2]) * gap(0, F[2], F[0]) * gap(1, F[2], F[0]) : 0;
      var cc = n === 4 ? [2, 0] : n === 16 ? [11, 14] : [4, 1], co = 'Zelle ' + (cc[0] + 1), cu = 'Zelle ' + (cc[1] + 1);
      var t1 = 25, t2 = 24, heat = 0, mos = 0, cold = 0, hiC = 0, loC = 0, over = 0;
      if (key === 'ot') { t1 = v; t2 = 26 + (v - 26) * 0.55; heat = cl((v - D.lim + 22) / 22); }
      else if (key === 'ut') { t1 = v; t2 = v + 1.5; cold = cl((D.lim + 8 - v) / 9); }
      else if (key === 'otb') mos = cl((v - D.lim + 35) / 35);
      else if (key === 'ov') hiC = cl((v - D.lim + 0.15) / 0.15);
      else if (key === 'uv') loC = cl((D.rel + 0.08 - v) / (D.rel + 0.08 - D.lim));
      else over = cl((v / D.lim - 0.75) / 0.3);
      var off = ph === 1, offC = off && D.blk.indexOf('c') >= 0, offD = off && D.blk.indexOf('d') >= 0;
      var L = num(D.lim, D.dec) + D.unit, R = num(D.rel, D.dec) + D.unit, tEm = key === 'ot' || key === 'ut';
      var ST = key === 'ot' ? ['Entladen: Die Zellen werden warm', 'Fühler T1 hat ' + L + ' erreicht', 'Unter ' + R + ': wieder frei']
        : key === 'otb' ? ['Hoher Dauerstrom: Das BMS wird warm', 'Sensor im BMS hat ' + L + ' erreicht', 'Unter ' + R + ': wieder frei']
        : key === 'uv' ? ['Entladen: ' + cu + ' ist fast leer', cu + ' hat ' + L + ' erreicht', 'Über ' + R + ': Entladen wieder frei']
        : key === 'ov' ? ['Laden: ' + co + ' ist fast voll', co + ' hat ' + L + ' erreicht', 'Unter ' + R + ': Laden wieder frei']
        : key === 'ut' ? ['Laden bei Frost', 'Fühler T1 hat ' + L + ' erreicht', 'Über ' + R + ': Laden wieder frei']
        : D.dir > 0 ? ['Der Ladestrom steigt', 'Ladestrom über ' + L, 'Nach der Wartezeit wieder frei'] : ['Die Last steigt', 'Entladestrom über ' + L, 'Nach der Wartezeit wieder frei'];
      var th = function (x) { return key === 'ot' && x >= D.lim - 5 ? 1 : key === 'ut' && x <= D.lim + 2 ? -1 : 0; };
      var cs = key === 'ov' ? co + ' · ' + v.toFixed(2) + ' V' : key === 'uv' ? cu + ' · ' + v.toFixed(2) + ' V' : '';
      return {
        key: key, D: D, C: C, u: u, v: v, ph: ph, offC: offC, offD: offD, dir: fl[0], amps: fl[1], fa: fa,
        t1: t1, t2: t2, heat: heat, mos: mos, cold: cold, hiC: hiC, loC: loC, over: over, cOv: cc[0], cUv: cc[1],
        st: ST[ph], rd: tEm ? 'T1 ' + num(v, 0) + ' °C' : key === 'otb' ? 'BMS ' + num(v, 0) + ' °C' : cs ? v.toFixed(2) + ' V' : Math.round(v) + ' A',
        limL: 'Sperre ' + L, relL: D.oc ? '' : 'Frei ' + R,
        tEm: tEm, t1s: 'T1' + (tEm ? ' ' + num(t1, 0) + ' °C' : ''), t2s: 'T2' + (tEm ? ' ' + num(t2, 0) + ' °C' : ''), t1h: th(t1), t2h: th(t2),
        cs: cs, bs: key === 'otb' ? 'BMS ' + num(v, 0) + ' °C' : '',
        gs: off ? (offC && offD ? 'Laden und Entladen gesperrt' : offC ? 'Laden gesperrt' : 'Entladen gesperrt') : ''
      };
    }
    return { TC: TC, ORDER: ORDER, DEF: DEF, TXT: TXT, frame: frame };
  }
  var PROTX = null;
  function prot() { if (!PROTX) PROTX = makeProt(); return PROTX; }

  /* Anlage über einen Tag: Solarmodule, Laderegler, Speicher, Wechselrichter, Haus, Wallbox mit E-Auto, Netz.
     Beispielanlage: 10 kWp, Speicher 16.1 kWh (48 V aus zwei 24V-Gehäusen), Haushalt rund 14 kWh pro Tag, E-Auto 15 kWh pro Tag. */
  function makeSys() {
    var TAU = 6.283185307, TC = 36, N = 288, HS = 24 / N;
    var CAP = 16.1, CHG = 5.1, DIS = 10.2, SMIN = 0.1, NEED = 15, EVMIN = 1.4, EVMAX = 11, EVN = 3.7, EVCAP = 60, KM = 0.15;
    var SUN = { s: [5.75, 21.25, 8], w: [8.25, 16.75, 3.4] };
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function win(h, a, b, r) { return sm((h - a) / r) * sm((b - h) / r); }
    function pvAt(h, sea) { var r = SUN[sea]; if (h <= r[0] || h >= r[1]) return 0; var x = Math.sin(Math.PI * (h - r[0]) / (r[1] - r[0])); return r[2] * x * x; }
    function houseAt(h) { return 0.25 + 0.9 * win(h, 6.5, 8.5, 0.25) + 1.4 * win(h, 11.75, 13, 0.2) + 1.4 * win(h, 17.75, 20.5, 0.3) + 0.5 * win(h, 20.5, 23, 0.4); }
    function carAt(h) { return h < 7 ? 1 : h < 7.4 ? 1 - sm((h - 7) / 0.4) : h < 11 ? 0 : h < 11.4 ? sm((h - 11) / 0.4) : 1; }
    var cache = {};
    // Energiefluss in 5-Minuten-Schritten: zuerst das Haus, dann der Speicher, dann das E-Auto, der Rest ins Netz oder abgeregelt
    function sim(sea, grid) {
      var id = sea + (grid ? 'g' : 'i');
      if (cache[id]) return cache[id];
      var soc = 0.5, recv = 0, R = [], d, i;
      for (d = 0; d < 4; d++) {
        R = [];
        for (i = 0; i <= N; i++) {
          var h = i * HS;
          if (i === Math.round(7 / HS)) recv = 0;
          var pv = pvAt(h, sea), hs = houseAt(h), sur = pv - hs, chg = 0, dis = 0, ev = 0, evn = 0, imp = 0, exp = 0, cur = 0, un = 0;
          if (sur >= 0) {
            chg = Math.min(sur, CHG, Math.max(0, (1 - soc) * CAP / HS));
            var rest = sur - chg;
            if (h >= 11.4 && h < 16 && recv < NEED && rest >= EVMIN) ev = Math.min(rest, EVMAX, (NEED - recv) / HS);
            rest -= ev;
            if (grid) exp = rest; else cur = rest;
          } else {
            dis = Math.min(-sur, DIS, Math.max(0, (soc - SMIN) * CAP / HS));
            if (grid) imp = -sur - dis; else un = -sur - dis;
          }
          if (grid && (h >= 22 || h < 6) && recv < NEED) { evn = Math.min(EVN, (NEED - recv) / HS); imp += evn; ev += evn; }
          R.push({ h: h, pv: pv - cur, sun: pv, hs: hs, ev: ev, evn: evn, chg: chg, dis: dis, imp: imp, exp: exp, cur: cur, un: un, soc: soc, recv: recv });
          if (i < N) { soc = cl(soc + (chg - dis) * HS / CAP); recv += ev * HS; }
        }
      }
      var T = { pv: 0, sun: 0, hs: 0, ev: 0, imp: 0, exp: 0, cur: 0, un: 0, chg: 0 };
      for (i = 0; i < N; i++) for (var k in T) T[k] += R[i][k] * HS;
      T.aut = cl(1 - (T.imp + T.un) / Math.max(0.01, T.hs + T.ev));
      T.km = T.ev / KM;
      cache[id] = { R: R, T: T, id: id };
      return cache[id];
    }
    function num(x) { return x.toFixed(1); }
    function frame(sea, grid, t) {
      var S = sim(sea, grid), u = (((t % TC) + TC) % TC) / TC, f = u * N, i = Math.min(N - 1, Math.floor(f)), k = f - i, A = S.R[i], B = S.R[i + 1], q = {};
      for (var key in A) q[key] = A[key] + (B[key] - A[key]) * k;
      q.h = u * 24;
      var hh = Math.floor(q.h), mm = Math.floor((q.h - hh) * 12) * 5;
      q.clock = (hh < 10 ? '0' : '') + hh + ':' + (mm < 10 ? '0' : '') + mm;
      q.u = u; q.S = S; q.T = S.T; q.sea = sea; q.grid = grid; q.car = carAt(q.h);
      q.carSoc = cl(0.45 + q.recv / EVCAP);
      q.inv = q.pv - q.chg + q.dis;
      q.st = q.un > 0.05 ? 'Speicher leer: Der Strom reicht nicht'
        : q.evn > 0.05 ? 'Nachts lädt das E-Auto aus dem Netz'
        : q.ev > 0.05 ? (q.chg > 0.05 ? 'Die Sonne lädt Speicher und E-Auto' : 'Solarüberschuss lädt das E-Auto')
        : q.cur > 0.05 ? 'Speicher voll: Der Laderegler regelt ab'
        : q.exp > 0.05 ? 'Speicher voll: Überschuss geht ins Netz'
        : q.chg > 0.05 ? 'Die Sonne deckt das Haus und lädt den Speicher'
        : q.dis > 0.05 ? (q.sun > 0.05 ? 'Wenig Sonne: Der Speicher hilft mit' : 'Der Speicher versorgt das Haus')
        : q.imp > 0.05 ? 'Speicher leer: Das Netz springt ein'
        : 'Die Sonne deckt das Haus';
      q.socTxt = Math.round(q.soc * 100) + ' %';
      return q;
    }

    // Zeichnung: Schema der Anlage mit Energiefluss
    function glow(rgb, a) {
      var c = document.createElement('canvas'); c.width = 96; c.height = 96;
      var g = c.getContext('2d'), gr = g.createRadialGradient(48, 48, 0, 48, 48, 48);
      gr.addColorStop(0, 'rgba(' + rgb + ',' + a + ')'); gr.addColorStop(0.32, 'rgba(' + rgb + ',' + (a * 0.32) + ')'); gr.addColorStop(1, 'rgba(' + rgb + ',0)');
      g.fillStyle = gr; g.fillRect(0, 0, 96, 96);
      return c;
    }
    var SPR = null;
    function spr() { if (!SPR) SPR = { sun: glow('255,206,96', 0.95), dc: glow('245,181,38', 0.95), ac: glow('143,182,255', 0.95), gr: glow('199,165,255', 0.95), ok: glow('61,220,132', 0.9), wh: glow('214,232,255', 0.85) }; return SPR; }
    function rr(g, x, y, w, h, r) { g.beginPath(); g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath(); }
    function txt(g, s, x, y, size, weight, col, font, align) { g.font = weight + ' ' + size.toFixed(1) + 'px ' + font; g.fillStyle = col; g.textAlign = align || 'center'; g.textBaseline = 'middle'; g.fillText(s, x, y); }
    function along(pts, d) {
      for (var i = 1; i < pts.length; i++) {
        var a = pts[i - 1], b = pts[i], l = Math.sqrt((b[0] - a[0]) * (b[0] - a[0]) + (b[1] - a[1]) * (b[1] - a[1]));
        if (d <= l || i === pts.length - 1) { var u = l ? Math.min(1, d / l) : 0; return [a[0] + (b[0] - a[0]) * u, a[1] + (b[1] - a[1]) * u]; }
        d -= l;
      }
      return pts[pts.length - 1];
    }
    function plen(pts) { var L = 0; for (var i = 1; i < pts.length; i++) L += Math.sqrt((pts[i][0] - pts[i - 1][0]) * (pts[i][0] - pts[i - 1][0]) + (pts[i][1] - pts[i - 1][1]) * (pts[i][1] - pts[i - 1][1])); return L; }
    function path(g, pts) { g.beginPath(); g.moveTo(pts[0][0], pts[0][1]); for (var i = 1; i < pts.length; i++) g.lineTo(pts[i][0], pts[i][1]); }
    // Leitung mit wanderndem Strom: Dichte und Helligkeit nach Leistung
    function flow(g, pts, P, col, sp, A, t) {
      g.lineCap = 'round'; g.lineJoin = 'round';
      g.globalAlpha = A; g.strokeStyle = 'rgba(255,255,255,0.12)'; g.lineWidth = 3; path(g, pts); g.stroke();
      var p = Math.abs(P);
      if (p < 0.03) return;
      var a2 = A * Math.min(1, 0.3 + p / 2.5), L = plen(pts);
      g.globalAlpha = a2 * 0.6; g.strokeStyle = col; g.lineWidth = 1.6 + Math.min(3.2, p * 0.4); path(g, pts); g.stroke();
      var gap = 24 - Math.min(11, p * 1.4), dir = P >= 0 ? 1 : -1, off = ((t * 42 * dir) % gap + gap) % gap;
      g.globalCompositeOperation = 'lighter';
      for (var d = off; d < L; d += gap) { var q = along(pts, d); g.globalAlpha = a2 * sm(d / 10) * sm((L - d) / 10); g.drawImage(sp, q[0] - 8, q[1] - 8, 16, 16); }
      g.globalCompositeOperation = 'source-over';
    }
    // unser Speicher von vorne: schwarzes Gehäuse, Leisten, Gewindestangen, blaue Zellen
    function housing(g, x, y, w, h, n) {
      rr(g, x - w / 2, y - h / 2, w, h, 4); g.fillStyle = '#15181E'; g.fill();
      var iw = w - 14, cw2 = iw / n, i;
      for (i = 0; i < n; i++) {
        var cx = x - iw / 2 + i * cw2, gr = g.createLinearGradient(cx, 0, cx + cw2, 0);
        gr.addColorStop(0, '#1C3F9A'); gr.addColorStop(0.5, '#3A78F0'); gr.addColorStop(1, '#1C3F9A');
        g.fillStyle = gr; g.fillRect(cx + 0.8, y - h / 2 + 12, cw2 - 1.6, h - 24);
      }
      g.fillStyle = '#0D0F13'; g.fillRect(x - w / 2, y - h / 2, w, 11); g.fillRect(x - w / 2, y + h / 2 - 11, w, 11);
      g.lineCap = 'round';
      [y - h / 2 + 6, y + h / 2 - 6].forEach(function (ry) {
        g.strokeStyle = '#C4CCD8'; g.lineWidth = 2; g.beginPath(); g.moveTo(x - w / 2 - 6, ry); g.lineTo(x + w / 2 + 6, ry); g.stroke();
        g.fillStyle = '#8A96A8'; g.fillRect(x - w / 2 - 5, ry - 3, 4, 6); g.fillRect(x + w / 2 + 1, ry - 3, 4, 6);
      });
      rr(g, x - w / 2, y - h / 2, w, h, 4); g.strokeStyle = 'rgba(255,255,255,0.16)'; g.lineWidth = 1; g.stroke();
    }
    function draw(g, cw, chh, s) {
      var k = cw / 680, q = s.q, A = s.a, t = s.t, sma = !!s.small, S2 = spr(), i;
      g.setTransform(k, 0, 0, k, 0, 0);
      var font = s.font || 'Arial, sans-serif', fs = Math.max(11, (s.minPx || 10) / (s.pxu || 1)), fv = fs * 0.94;
      var L = sma ? { pv: 78, row: 166, house: 92, wb: 250, sunB: 140, sunT: 26 } : { pv: 96, row: 208, house: 116, wb: 300, sunB: 168, sunT: 36 };
      var h = q.h, sr = SUN[q.sea], dayP = h > sr[0] && h < sr[1] ? (h - sr[0]) / (sr[1] - sr[0]) : -1, alt = dayP >= 0 ? Math.sin(Math.PI * dayP) : 0;
      var night = 1 - sm(alt * 5), dawn = dayP >= 0 ? (1 - sm(alt * 3)) * sm(alt * 12) : 0;
      // Himmel: Nacht dunkler, Morgen und Abend warm, Tag hell
      g.globalAlpha = A * 0.42 * night; g.fillStyle = '#02050F'; g.fillRect(0, 0, 680, 520);
      var gy = g.createLinearGradient(0, 0, 0, L.row);
      gy.addColorStop(0, 'rgba(110,165,255,0.24)'); gy.addColorStop(1, 'rgba(110,165,255,0)');
      g.globalAlpha = A * (1 - night) * (1 - dawn); g.fillStyle = gy; g.fillRect(0, 0, 680, L.row);
      var gd = g.createLinearGradient(0, 0, 0, L.row);
      gd.addColorStop(0, 'rgba(255,150,80,0)'); gd.addColorStop(1, 'rgba(255,150,80,0.2)');
      g.globalAlpha = A * dawn; g.fillStyle = gd; g.fillRect(0, 0, 680, L.row);
      if (night > 0.02) {
        g.fillStyle = '#FFFFFF';
        for (i = 0; i < 42; i++) { var sx = (i * 157.3) % 680, sy = 14 + (i * 61.7) % (L.row - 70); g.globalAlpha = A * night * (0.25 + 0.55 * Math.abs(Math.sin(t * 0.9 + i * 1.7))); g.fillRect(sx, sy, 1.6, 1.6); }
      }
      // Sonne oder Mond auf ihrem Bogen
      if (dayP >= 0) {
        var sxp = 40 + 600 * dayP, syp = L.sunB - (L.sunB - L.sunT) * alt;
        g.globalCompositeOperation = 'lighter'; g.globalAlpha = A * (0.55 + 0.45 * alt); g.drawImage(S2.sun, sxp - 70, syp - 70, 140, 140); g.globalCompositeOperation = 'source-over';
        g.globalAlpha = A; g.fillStyle = dawn > 0.5 ? '#FFC07A' : '#FFE49A'; g.beginPath(); g.arc(sxp, syp, 12, 0, 6.2832); g.fill();
      } else {
        var nh = h >= sr[1] ? h - sr[1] : h + 24 - sr[1], np = nh / (24 - sr[1] + sr[0]), mx = 40 + 600 * np, my = L.sunB - (L.sunB - L.sunT) * Math.sin(Math.PI * np);
        g.globalAlpha = A * 0.9; g.fillStyle = '#E8EEF8'; g.beginPath(); g.arc(mx, my, 10, 0, 6.2832); g.fill();
        g.fillStyle = '#0B1736'; g.beginPath(); g.arc(mx + 5, my - 3, 9, 0, 6.2832); g.fill();
      }
      g.globalAlpha = A;
      // Positionen
      var X = { pv: 110, mp: 110, bat: 272, inv: 432, bus: 516, house: 604, grid: 432, wb: 516, car: 612 };
      var light = q.sun / 8;
      // Leitungen und Energiefluss
      var LN = {
        pv: [[X.pv, L.pv + 26], [X.mp, L.row - 21]],
        mb: [[X.mp + 27, L.row], [X.bat - 60, L.row]],
        bi: [[X.bat + 60, L.row], [X.inv - 28, L.row]],
        ib: [[X.inv + 28, L.row], [X.bus, L.row]],
        bh: [[X.bus, L.row], [X.bus, L.house + 14], [X.house - 47, L.house + 14]],
        bw: [[X.bus, L.row], [X.bus, L.wb - 18]],
        gi: [[X.grid, L.pv - 8], [X.grid, L.row - 33]]
      };
      flow(g, LN.pv, q.pv, '#F5B526', S2.dc, A, t);
      flow(g, LN.mb, q.pv, '#F5B526', S2.dc, A, t);
      flow(g, LN.bi, q.inv, '#F5B526', S2.dc, A, t);
      flow(g, LN.ib, q.hs + q.ev - q.imp + q.exp, '#8FB6FF', S2.ac, A, t);
      flow(g, LN.bh, q.hs, '#8FB6FF', S2.ac, A, t);
      flow(g, LN.bw, q.ev * (q.car > 0.98 ? 1 : 0), '#8FB6FF', S2.ac, A, t);
      if (q.grid) flow(g, LN.gi, q.imp - q.exp, '#C7A5FF', S2.gr, A, t);
      // Solarmodule
      var mw = 30, mh = 19, gp = 3, x0 = X.pv - (4 * mw + 3 * gp) / 2, y0 = L.pv - (2 * mh + gp) / 2, r, c;
      g.strokeStyle = '#5E6B80'; g.lineWidth = 2.2; g.beginPath(); g.moveTo(x0 + 16, y0 + 2 * mh + gp); g.lineTo(x0 + 8, y0 + 2 * mh + gp + 14); g.moveTo(x0 + 4 * mw + 3 * gp - 16, y0 + 2 * mh + gp); g.lineTo(x0 + 4 * mw + 3 * gp - 8, y0 + 2 * mh + gp + 14); g.stroke();
      for (r = 0; r < 2; r++) for (c = 0; c < 4; c++) {
        var px = x0 + c * (mw + gp), py = y0 + r * (mh + gp);
        g.fillStyle = '#16275A'; g.fillRect(px, py, mw, mh);
        g.globalAlpha = A * (0.15 + 0.85 * cl(light)); g.fillStyle = '#2E64E0'; g.fillRect(px, py, mw, mh); g.globalAlpha = A;
        g.strokeStyle = 'rgba(190,210,255,0.28)'; g.lineWidth = 0.6; g.beginPath();
        for (var j = 1; j < 4; j++) { g.moveTo(px + mw * j / 4, py); g.lineTo(px + mw * j / 4, py + mh); }
        g.moveTo(px, py + mh / 2); g.lineTo(px + mw, py + mh / 2); g.stroke();
        g.strokeStyle = '#B5BFCC'; g.lineWidth = 1.1; g.strokeRect(px, py, mw, mh);
      }
      if (light > 0.05) { var shx = x0 + ((t * 30) % 200) - 40; g.save(); g.beginPath(); g.rect(x0, y0, 4 * mw + 3 * gp, 2 * mh + gp); g.clip(); g.globalAlpha = A * 0.18 * cl(light); g.fillStyle = '#FFFFFF'; g.beginPath(); g.moveTo(shx, y0); g.lineTo(shx + 14, y0); g.lineTo(shx + 4, y0 + 2 * mh + gp); g.lineTo(shx - 10, y0 + 2 * mh + gp); g.closePath(); g.fill(); g.restore(); g.globalAlpha = A; }
      // Laderegler
      rr(g, X.mp - 27, L.row - 21, 54, 42, 6); var gm = g.createLinearGradient(0, L.row - 21, 0, L.row + 21); gm.addColorStop(0, '#3A4250'); gm.addColorStop(1, '#232933'); g.fillStyle = gm; g.fill(); g.strokeStyle = 'rgba(255,255,255,0.14)'; g.lineWidth = 1; g.stroke();
      rr(g, X.mp - 19, L.row - 14, 38, 13, 2); g.fillStyle = '#0D2B2A'; g.fill();
      txt(g, 'MPPT', X.mp, L.row - 7.5, 8, 800, q.pv > 0.05 ? '#5BE3BA' : '#2F6B5E', font);
      g.fillStyle = q.pv > 0.05 ? '#3DDC84' : '#3A4252'; g.beginPath(); g.arc(X.mp + 15, L.row + 11, 2.6, 0, 6.2832); g.fill();
      // Speicher
      housing(g, X.bat, L.row, 116, 62, 8);
      rr(g, X.bat - 58, L.row + 40, 116, 7, 3.5); g.fillStyle = '#0E1A33'; g.fill();
      rr(g, X.bat - 58, L.row + 40, Math.max(7, 116 * q.soc), 7, 3.5); g.fillStyle = q.soc < 0.2 ? '#F5B526' : '#3DDC84'; g.fill();
      // Wechselrichter
      rr(g, X.inv - 28, L.row - 32, 56, 64, 7); var gi2 = g.createLinearGradient(0, L.row - 32, 0, L.row + 32); gi2.addColorStop(0, '#E4E8EF'); gi2.addColorStop(1, '#BCC4D1'); g.fillStyle = gi2; g.fill();
      rr(g, X.inv - 18, L.row - 22, 36, 16, 2); g.fillStyle = '#0E1422'; g.fill();
      g.strokeStyle = q.hs + q.ev > 0.05 ? '#8FB6FF' : '#3A4A6A'; g.lineWidth = 1.4; g.beginPath();
      for (i = 0; i <= 24; i++) { var wx = X.inv - 13 + i * 26 / 24, wy = L.row - 14 + Math.sin(i / 24 * 6.2832 + t * 4) * 4; if (i) g.lineTo(wx, wy); else g.moveTo(wx, wy); }
      g.stroke();
      g.strokeStyle = 'rgba(15,29,53,0.35)'; g.lineWidth = 1; g.beginPath(); for (i = 0; i < 4; i++) { g.moveTo(X.inv - 14, L.row + 8 + i * 5); g.lineTo(X.inv + 14, L.row + 8 + i * 5); } g.stroke();
      // Haus mit Verbrauchern
      var hx = X.house, hy = L.house, lit = cl(0.25 + 0.75 * cl((q.hs - 0.2) / 1.2)) * (0.45 + 0.55 * night);
      g.fillStyle = '#1B2640'; g.fillRect(hx - 46, hy - 22, 92, 58); g.strokeStyle = '#3A4C74'; g.lineWidth = 1.2; g.strokeRect(hx - 46, hy - 22, 92, 58);
      g.beginPath(); g.moveTo(hx - 54, hy - 22); g.lineTo(hx, hy - 58); g.lineTo(hx + 54, hy - 22); g.closePath(); g.fillStyle = '#25324F'; g.fill(); g.stroke();
      [[hx - 33, hy - 10], [hx + 13, hy - 10]].forEach(function (w) { g.fillStyle = '#0E1526'; g.fillRect(w[0], w[1], 20, 15); g.globalAlpha = A * lit; g.fillStyle = '#FFD36B'; g.fillRect(w[0], w[1], 20, 15); g.globalAlpha = A; g.strokeStyle = '#3A4C74'; g.strokeRect(w[0], w[1], 20, 15); });
      g.fillStyle = '#121A2E'; g.fillRect(hx - 7, hy + 14, 14, 22);
      if (lit > 0.3) { g.globalCompositeOperation = 'lighter'; g.globalAlpha = A * 0.35 * lit; g.drawImage(S2.sun, hx - 50, hy - 40, 100, 70); g.globalCompositeOperation = 'source-over'; g.globalAlpha = A; }
      // Netz: Mast mit Leitungen
      if (q.grid) {
        var gx = X.grid, gy2 = L.pv - 8;
        g.strokeStyle = '#8D9AB0'; g.lineWidth = 1.4; g.beginPath();
        g.moveTo(gx - 13, gy2); g.lineTo(gx - 3, gy2 - 62); g.moveTo(gx + 13, gy2); g.lineTo(gx + 3, gy2 - 62);
        for (i = 0; i < 4; i++) { var ya = gy2 - i * 15, yb = gy2 - (i + 1) * 15, wa = 13 - i * 2.5, wb2 = 13 - (i + 1) * 2.5; g.moveTo(gx - wa, ya); g.lineTo(gx + wb2, yb); g.moveTo(gx + wa, ya); g.lineTo(gx - wb2, yb); }
        g.moveTo(gx - 22, gy2 - 50); g.lineTo(gx + 22, gy2 - 50); g.moveTo(gx - 17, gy2 - 38); g.lineTo(gx + 17, gy2 - 38); g.stroke();
        g.strokeStyle = 'rgba(141,154,176,0.45)'; g.lineWidth = 0.9; g.beginPath();
        g.moveTo(gx - 22, gy2 - 49); g.quadraticCurveTo(gx - 90, gy2 - 34, gx - 160, gy2 - 46); g.moveTo(gx + 22, gy2 - 49); g.quadraticCurveTo(gx + 60, gy2 - 36, gx + 92, gy2 - 44); g.stroke();
      }
      // Wallbox und E-Auto
      rr(g, X.wb - 11, L.wb - 18, 22, 36, 4); g.fillStyle = '#E3E8EF'; g.fill();
      var chg2 = q.ev > 0.05 && q.car > 0.98;
      g.strokeStyle = chg2 ? '#3DDC84' : '#9AA6B8'; g.lineWidth = 2; g.beginPath(); g.arc(X.wb, L.wb - 5, 5, 0, 6.2832); g.stroke();
      if (chg2) { g.globalCompositeOperation = 'lighter'; g.globalAlpha = A * (0.6 + 0.4 * Math.sin(t * 4)); g.drawImage(S2.ok, X.wb - 18, L.wb - 23, 36, 36); g.globalCompositeOperation = 'source-over'; g.globalAlpha = A; }
      var cx2 = X.car + (1 - q.car) * 170, cy2 = L.wb + 6, ca = A * q.car;
      if (q.car > 0.98) { g.strokeStyle = '#2B313C'; g.lineWidth = 2.6; g.beginPath(); g.moveTo(X.wb + 6, L.wb + 12); g.bezierCurveTo(X.wb + 22, L.wb + 34, cx2 - 64, cy2 + 16, cx2 - 54, cy2 - 2); g.stroke(); }
      if (ca > 0.01) {
        g.globalAlpha = ca;
        g.beginPath(); g.moveTo(cx2 - 56, cy2 + 8); g.lineTo(cx2 - 56, cy2 - 3); g.quadraticCurveTo(cx2 - 54, cy2 - 12, cx2 - 40, cy2 - 13); g.lineTo(cx2 - 22, cy2 - 14);
        g.quadraticCurveTo(cx2 - 11, cy2 - 30, cx2 + 8, cy2 - 30); g.lineTo(cx2 + 22, cy2 - 30); g.quadraticCurveTo(cx2 + 34, cy2 - 29, cx2 + 42, cy2 - 14); g.quadraticCurveTo(cx2 + 56, cy2 - 12, cx2 + 56, cy2 - 2); g.lineTo(cx2 + 56, cy2 + 8); g.closePath();
        var gc = g.createLinearGradient(0, cy2 - 30, 0, cy2 + 8); gc.addColorStop(0, '#E2E7EF'); gc.addColorStop(1, '#8F9BAE'); g.fillStyle = gc; g.fill(); g.strokeStyle = 'rgba(255,255,255,0.35)'; g.lineWidth = 1; g.stroke();
        g.beginPath(); g.moveTo(cx2 - 16, cy2 - 15); g.quadraticCurveTo(cx2 - 8, cy2 - 27, cx2 + 7, cy2 - 27); g.lineTo(cx2 + 20, cy2 - 27); g.quadraticCurveTo(cx2 + 29, cy2 - 26, cx2 + 36, cy2 - 15); g.closePath(); g.fillStyle = '#1E2A40'; g.fill();
        [cx2 - 34, cx2 + 34].forEach(function (wx2) { g.fillStyle = '#11151C'; g.beginPath(); g.arc(wx2, cy2 + 8, 9, 0, 6.2832); g.fill(); g.fillStyle = '#8A96A8'; g.beginPath(); g.arc(wx2, cy2 + 8, 3.6, 0, 6.2832); g.fill(); });
        rr(g, cx2 - 34, cy2 - 46, 68, 7, 3.5); g.fillStyle = '#0E1A33'; g.fill();
        rr(g, cx2 - 34, cy2 - 46, Math.max(7, 68 * q.carSoc), 7, 3.5); g.fillStyle = '#3DDC84'; g.fill();
        g.globalAlpha = A;
      }
      // Beschriftungen mit Werten
      var lab = function (x, y, name, val, col, al) {
        txt(g, name, x, y, fs, 700, '#E8EEF8', font, al); if (val) txt(g, val, x, y + fs * 1.22, fv, 650, col || '#C9D4E8', font, al);
      };
      var kw = function (v) { return num(v) + ' kW'; };
      lab(X.pv + 72, L.pv - 6, 'Solarmodule', q.sun > 0.02 ? (q.cur > 0.05 ? kw(q.pv) + ' von ' + kw(q.sun) : kw(q.pv)) : 'Nacht', '#FFD36B', 'left');
      lab(X.mp, L.row + 21 + fs * 0.9, 'Laderegler', 'MPPT', '#9FB0CC');
      lab(X.bat, L.row + 47 + fs * 0.95, 'Speicher ' + q.socTxt, q.chg > 0.05 ? 'lädt ' + kw(q.chg) : q.dis > 0.05 ? 'liefert ' + kw(q.dis) : 'bereit', q.chg > 0.05 ? '#7EE2A8' : q.dis > 0.05 ? '#FFD36B' : '#9FB0CC');
      lab(X.inv, L.row + 32 + fs * 0.9, 'Wechselrichter', '230 V', '#8FB6FF');
      lab(X.house, L.house + 36 + fs * 0.9, 'Haus', 'braucht ' + kw(q.hs), '#8FB6FF');
      if (q.grid) lab(X.grid + 26, L.pv - 52, 'Netz', q.imp > 0.05 ? 'Bezug ' + kw(q.imp) : q.exp > 0.05 ? 'Einspeisung ' + kw(q.exp) : 'kein Austausch', '#C7A5FF', 'left');
      lab(X.wb, L.wb + 18 + fs * 0.9, 'Wallbox', chg2 ? kw(q.ev) : 'bereit', chg2 ? '#7EE2A8' : '#9FB0CC');
      if (ca > 0.01) {
        g.globalAlpha = ca;
        // auf dem Handy unter dem Auto, damit es nicht mit dem Haus kollidiert
        if (sma) lab(cx2, cy2 + 18 + fs * 0.9, 'E-Auto ' + Math.round(q.carSoc * 100) + ' %', q.recv > 0.3 ? '+' + Math.round(q.recv) + ' kWh' : 'angeschlossen', '#7EE2A8');
        else lab(cx2, cy2 - 46 - fs * 1.9, 'E-Auto ' + Math.round(q.carSoc * 100) + ' %', q.recv > 0.3 ? '+' + Math.round(q.recv) + ' kWh, rund ' + Math.round(q.recv / KM / 5) * 5 + ' km' : 'angeschlossen', '#7EE2A8');
        g.globalAlpha = A;
      }
      else lab(X.car, cy2 - 4, 'E-Auto', 'unterwegs', '#9FB0CC');
      g.globalAlpha = 1;
    }
    // Tagesverlauf fürs Diagramm: Solarstrom, Verbrauch mit E-Auto, Ladestand
    var CH = {};
    function chart(sea, grid) {
      var id = sea + (grid ? 'g' : 'i');
      if (CH[id]) return CH[id];
      var R = sim(sea, grid).R, pv = '0,100 ', use = '', soc = '', sun = '', i;
      for (i = 0; i <= N; i += 2) {
        var x = (i / N * 100).toFixed(2), q = R[i];
        pv += x + ',' + (100 - cl(q.pv / 10) * 100).toFixed(2) + ' ';
        sun += x + ',' + (100 - cl(q.sun / 10) * 100).toFixed(2) + ' ';
        use += x + ',' + (100 - cl((q.hs + q.ev) / 10) * 100).toFixed(2) + ' ';
        soc += x + ',' + (100 - q.soc * 92 - 4).toFixed(2) + ' ';
      }
      pv += '100,100';
      CH[id] = { pv: pv, use: use, soc: soc, sun: sim(sea, grid).T.cur > 0.5 ? sun : '', R: R };
      return CH[id];
    }
    function rows(sea, grid) {
      var T = sim(sea, grid).T, kwh = function (v) { return Math.round(v) + ' kWh'; };
      var R = [['Solarstrom genutzt', kwh(T.pv)], ['Haushalt', kwh(T.hs)], ['E-Auto', kwh(T.ev) + (T.ev > 0.5 ? ', rund ' + Math.round(T.km / 5) * 5 + ' km' : '')]];
      if (grid) R.push(['Aus dem Netz', kwh(T.imp)], ['Ins Netz', kwh(T.exp)]); else R.push(['Abgeregelt', kwh(T.cur)]);
      R.push(['Selbst versorgt', Math.round(T.aut * 100) + ' %']);
      return R;
    }
    function note(sea, grid) {
      return (grid ? (sea === 's' ? 'Im Sommer bleibt viel übrig: Was Haus, Speicher und E-Auto nicht brauchen, geht ins Netz.' : 'Im Winter reicht die Sonne für Haus und Speicher. Das E-Auto lädt nachts aus dem Netz, an Nebeltagen hilft das Netz auch tagsüber.')
        : (sea === 's' ? 'Ohne Netz regelt der Laderegler ab, sobald Speicher und E-Auto voll sind.' : 'Ohne Netz reicht der Ertrag im Winter für den Haushalt. Fürs E-Auto bleibt kaum etwas übrig.'))
        + ' Beispiel: 10\u00a0kWp Solaranlage, 16\u00a0kWh Speicher, Haushalt rund 14\u00a0kWh und E-Auto 15\u00a0kWh pro Tag.';
    }
    return { TC: TC, sim: sim, frame: frame, num: num, draw: draw, chart: chart, rows: rows, note: note, START: 6 / 24 * TC };
  }
  var SYSX = null;
  function sysFx() { if (!SYSX) SYSX = makeSys(); return SYSX; }

  /* Vergleich LiFePO4, AGM und Blei-Nassbatterie. Typische Werte: AGM 600 Zyklen bei 50 % (Victron-Datenblatt),
     Blei-Nass 1'000 bis 1'900 Zyklen bei 50 % (Trojan Solar: Signature meist 1'200, Premium 1'900, Industrial 3'600), Gewicht für 3.6 kWh nutzbar, LiFePO4 aus unserem 12V Solarspeicher 4 kWh. */
  function makeCmp() {
    var TAU = 6.283185307;
    var ORDER = ['use', 'kg', 'life', 'volt'];
    var NAMES = { use: ['Nutzbare Energie', 'bei gleicher Grösse'], kg: ['Gewicht', 'bei gleicher Energie'], life: ['Lebensdauer', 'Zyklen und Jahre'], volt: ['Spannung', 'beim Entladen'] };
    var TXT = {
      use: 'Blei und AGM sollte man nur etwa zur Hälfte entladen, sonst altern sie schnell. Bei LiFePO4 sind 90\u00a0Prozent und mehr nutzbar, fast doppelt so viel.',
      kg: 'Unser 12V Solarspeicher mit 4\u00a0kWh wiegt rund 25\u00a0kg. AGM braucht für gleich viel nutzbare Energie die doppelte Kapazität: rund 180\u00a0kg.',
      life: 'Blei und AGM kosten weniger, halten aber kürzer: AGM schafft bei halber Entladung rund 600\u00a0Zyklen, Blei 1\'000 bis 1\'900, LiFePO4 laut Hersteller 8\'000.',
      volt: 'LiFePO4 hält die Spannung fast bis zum Schluss konstant. Bei Blei und AGM sinkt sie stetig, ein Wechselrichter kann unter Last früher abschalten.'
    };
    var NB = '\u00a0', ROWS = [['Nutzbare Kapazität', '90' + NB + '%', '50' + NB + '%', '50' + NB + '%'], ['Zyklen bis Ersatz', "8'000", '600', "1'500"], ['Gewicht, 3.6 kWh nutzbar', '25' + NB + 'kg', '180' + NB + 'kg', '170' + NB + 'kg'], ['Wirkungsgrad, rund', '95' + NB + '%', '85' + NB + '%', '80' + NB + '%'], ['Wartung', 'keine', 'keine', 'Wasser'], ['Gasung', 'nein', 'kaum', 'ja'], ['Laden unter 0' + NB + '°C', 'nein', 'ja', 'ja']];
    var COLS = [
      { x: 130, n: 'LiFePO4', s: 'unser Speicher', c: '#3DDC84', use: 0.9, kg: 25, cyc: "8'000", life: 8000 / 365, blocks: 1 },
      { x: 340, n: 'AGM', s: 'Blei-Vlies', c: '#F5B526', use: 0.5, kg: 180, cyc: '600', life: 600 / 365, blocks: 3 },
      { x: 550, n: 'Blei', s: 'Nassbatterie', c: '#A9B8D0', use: 0.5, kg: 170, cyc: "1'500", life: 1500 / 365, blocks: 3 }
    ];
    var VOLT = [
      [[0, 13.4], [5, 13.32], [20, 13.27], [50, 13.22], [80, 13.12], [90, 13.0], [95, 12.8], [100, 12.1]],
      [[0, 12.85], [25, 12.55], [50, 12.25], [75, 11.98], [100, 11.75]],
      [[0, 12.72], [25, 12.47], [50, 12.2], [75, 11.95], [100, 11.72]]
    ];
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function rr(g, x, y, w, h, r) { g.beginPath(); g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath(); }
    function txt(g, s, x, y, size, weight, col, font, align) { g.font = weight + ' ' + size.toFixed(1) + 'px ' + font; g.fillStyle = col; g.textAlign = align || 'center'; g.textBaseline = 'middle'; g.fillText(s, x, y); }
    function vAt(K, p) { for (var i = 1; i < K.length; i++) if (p <= K[i][0]) { var u = (p - K[i - 1][0]) / (K[i][0] - K[i - 1][0]); return K[i - 1][1] + (K[i][1] - K[i - 1][1]) * u; } return K[K.length - 1][1]; }
    // Batterien von vorne
    function lfp(g, x, y, w, h) {
      rr(g, x - w / 2, y - h / 2, w, h, 4); g.fillStyle = '#15181E'; g.fill();
      var n = 4, iw = w - 14, cw = iw / n, i;
      for (i = 0; i < n; i++) { var cx = x - iw / 2 + i * cw, gr = g.createLinearGradient(cx, 0, cx + cw, 0); gr.addColorStop(0, '#1C3F9A'); gr.addColorStop(0.5, '#3A78F0'); gr.addColorStop(1, '#1C3F9A'); g.fillStyle = gr; g.fillRect(cx + 1, y - h / 2 + 11, cw - 2, h - 22); }
      g.fillStyle = '#0D0F13'; g.fillRect(x - w / 2, y - h / 2, w, 10); g.fillRect(x - w / 2, y + h / 2 - 10, w, 10);
      [y - h / 2 + 5, y + h / 2 - 5].forEach(function (ry) { g.strokeStyle = '#C4CCD8'; g.lineWidth = 2; g.beginPath(); g.moveTo(x - w / 2 - 6, ry); g.lineTo(x + w / 2 + 6, ry); g.stroke(); g.fillStyle = '#8A96A8'; g.fillRect(x - w / 2 - 5, ry - 3, 4, 6); g.fillRect(x + w / 2 + 1, ry - 3, 4, 6); });
      rr(g, x - w / 2, y - h / 2, w, h, 4); g.strokeStyle = 'rgba(255,255,255,0.16)'; g.lineWidth = 1; g.stroke();
    }
    function agm(g, x, y, w, h) {
      var gr = g.createLinearGradient(0, y - h / 2, 0, y + h / 2); gr.addColorStop(0, '#4A505B'); gr.addColorStop(1, '#262A31');
      rr(g, x - w / 2, y - h / 2 + 6, w, h - 6, 4); g.fillStyle = gr; g.fill();
      rr(g, x - w / 2 - 2, y - h / 2 + 2, w + 4, 9, 3); g.fillStyle = '#353A43'; g.fill();
      g.fillStyle = '#D9483B'; g.fillRect(x + w / 2 - 22, y - h / 2 - 3, 10, 6); g.fillStyle = '#1A1D22'; g.fillRect(x - w / 2 + 12, y - h / 2 - 3, 10, 6);
      rr(g, x - w / 2 + 12, y - 4, w - 24, 16, 2); g.fillStyle = 'rgba(255,255,255,0.12)'; g.fill();
      txt(g, 'AGM 12 V', x, y + 4, 9, 800, '#E3E8EF', 'Arial, sans-serif');
    }
    function lead(g, x, y, w, h, t, gas) {
      rr(g, x - w / 2, y - h / 2 + 6, w, h - 6, 4); g.fillStyle = 'rgba(214,226,242,0.16)'; g.fill(); g.strokeStyle = 'rgba(214,226,242,0.45)'; g.lineWidth = 1; g.stroke();
      g.fillStyle = 'rgba(120,170,255,0.22)'; g.fillRect(x - w / 2 + 3, y - h / 2 + 18, w - 6, h - 24);
      g.fillStyle = 'rgba(70,78,92,0.85)'; for (var i = 0; i < 9; i++) g.fillRect(x - w / 2 + 8 + i * (w - 16) / 8.6, y - h / 2 + 22, 4, h - 32);
      rr(g, x - w / 2 - 2, y - h / 2 + 2, w + 4, 8, 3); g.fillStyle = '#C9D2DE'; g.fill();
      for (i = 0; i < 6; i++) { g.fillStyle = '#58637A'; g.beginPath(); g.arc(x - w / 2 + 12 + i * (w - 24) / 5, y - h / 2 + 6, 3, 0, TAU); g.fill(); }
      if (gas > 0.01) {
        var a0 = g.globalAlpha;
        g.fillStyle = 'rgba(230,240,255,0.8)';
        for (i = 0; i < 8; i++) { var ph = (t * 0.6 + i / 8) % 1, bx = x - w / 2 + 12 + (i % 6) * (w - 24) / 5 + Math.sin(t * 3 + i) * 2, by = y - h / 2 + 2 - ph * 26; g.globalAlpha = a0 * gas * (1 - ph); g.beginPath(); g.arc(bx, by, 1.6 + ph * 1.4, 0, TAU); g.fill(); }
        g.globalAlpha = a0;
      }
    }
    function draw(g, cw, chh, s) {
      var k = cw / 680, A = s.a, ct = s.ct, t = s.t, sma = !!s.small, crit = s.crit, i, j;
      g.setTransform(k, 0, 0, k, 0, 0);
      var font = s.font || 'Arial, sans-serif', fs = Math.max(11, (s.minPx || 10) / (s.pxu || 1)), fb = fs * 1.3;
      var yN = sma ? 34 : 40, yB = sma ? 96 : 104, top = yB + 56, bot = sma ? 500 : 496;
      g.globalAlpha = A;
      // Kopf mit den drei Batterien
      COLS.forEach(function (c, ci) {
        txt(g, c.n, c.x, yN, fb, 800, ci ? '#FFFFFF' : '#7EE2A8', font);
        txt(g, c.s, c.x, yN + fb * 0.95, fs * 0.92, 500, '#9FB0CC', font);
        if (ci === 0) lfp(g, c.x, yB, 104, 56); else if (ci === 1) agm(g, c.x, yB, 100, 58); else lead(g, c.x, yB, 100, 62, t, 0.7);
      });
      var head = function (s1, s2) { txt(g, s1, 340, top, fs * 1.05, 700, '#E8EEF8', font); if (s2) txt(g, s2, 340, top + fs * 1.2, fs * 0.88, 500, '#9FB0CC', font); };
      if (crit === 'use') {
        // Gleich grosse Batterien: wie weit darf man entladen?
        head('Gleiche Nennkapazität: je 4 kWh', 'Wie viel davon nutzbar ist');
        var gt = top + fs * 2.6, gb = bot - fs * 3.4, gh = gb - gt, cyc = ct % 8;
        COLS.forEach(function (c) {
          var lim = 1 - c.use, lv = cyc < 0.6 ? 1 : cyc < 4.4 ? 1 - (1 - lim) * sm((cyc - 0.6) / 3.8) : cyc < 5.6 ? lim : cyc < 7.6 ? lim + (1 - lim) * sm((cyc - 5.6) / 2) : 1;
          var gx = c.x - 28;
          rr(g, gx, gt, 56, gh, 6); g.fillStyle = 'rgba(255,255,255,0.07)'; g.fill(); g.strokeStyle = 'rgba(255,255,255,0.3)'; g.lineWidth = 1; g.stroke();
          g.save(); rr(g, gx, gt, 56, gh, 6); g.clip();
          g.fillStyle = c.c; g.globalAlpha = A * 0.85; g.fillRect(gx, gt + gh * (1 - lv), 56, gh * lv);
          // Reserve, die nicht entladen werden soll
          g.globalAlpha = A * 0.9; g.strokeStyle = 'rgba(11,23,54,0.75)'; g.lineWidth = 3; g.beginPath();
          for (j = -gh * lim - 10; j < 70; j += 9) { g.moveTo(gx + j, gb); g.lineTo(gx + j + gh * lim, gb - gh * lim); }
          g.stroke(); g.restore(); g.globalAlpha = A;
          g.setLineDash([4, 3]); g.strokeStyle = '#FF8A7A'; g.lineWidth = 1.4; g.beginPath(); g.moveTo(gx - 8, gb - gh * lim); g.lineTo(gx + 64, gb - gh * lim); g.stroke(); g.setLineDash([]);
          txt(g, (4 * c.use).toFixed(1) + ' kWh', c.x, gb + fs * 1.15, fb, 800, c.c, font);
          txt(g, 'nutzbar, ' + Math.round(c.use * 100) + ' %', c.x, gb + fs * 2.35, fs * 0.92, 500, '#C9D4E8', font);
          if (cyc > 4.2 && cyc < 5.8 && c.use < 0.6) { g.globalAlpha = A * sm((cyc - 4.2) / 0.3) * sm((5.8 - cyc) / 0.3); txt(g, 'Stopp', c.x + 46, gb - gh * lim, fs * 0.9, 800, '#FF8A7A', font, 'left'); g.globalAlpha = A; }
        });
      } else if (crit === 'kg') {
        head('Gewicht für 3.6 kWh nutzbare Energie', 'AGM und Blei: doppelte Nennkapazität nötig');
        var ground = bot - fs * 3.2;
        g.strokeStyle = 'rgba(255,255,255,0.22)'; g.lineWidth = 1; g.beginPath(); g.moveTo(40, ground); g.lineTo(640, ground); g.stroke();
        COLS.forEach(function (c, ci) {
          var nB = c.blocks, landed = 0, bw = ci ? 84 : 92, bh = ci ? 34 : 40;
          for (j = 0; j < nB; j++) {
            var t0 = 0.3 + ci * 0.25 + j * 0.45, pr = sm((ct - t0) / 0.5), yy = ground - (j + 1) * (bh + 3) + 3 - (1 - pr) * 180;
            if (pr <= 0) continue;
            landed += pr;
            g.globalAlpha = A * Math.min(1, pr * 2);
            if (ci === 0) lfp(g, c.x, yy + bh / 2, bw, bh); else if (ci === 1) agm(g, c.x, yy + bh / 2, bw, bh); else lead(g, c.x, yy + bh / 2, bw, bh, t, 0);
          }
          g.globalAlpha = A;
          var kgv = Math.round(c.kg * landed / nB / 5) * 5;
          txt(g, (ci ? 'rund ' : '') + (ci ? kgv : Math.round(c.kg * landed / nB)) + ' kg', c.x, ground + fs * 1.3, fb, 800, ci ? '#FFFFFF' : '#7EE2A8', font);
          txt(g, ci ? nB + ' Blöcke 12 V' : '12V Solarspeicher 4 kWh', c.x, ground + fs * 2.55, fs * 0.9, 500, '#9FB0CC', font);
        });
      } else if (crit === 'life') {
        head('Batterien in 15 Jahren', 'bei einem Lade- und Entladezyklus pro Tag');
        var yrs = Math.min(15, Math.max(0, ct - 0.4) * 2.6), gy0 = top + fs * 4.1;
        txt(g, 'Jahr ' + Math.floor(yrs), 340, top + fs * 2.6, fs * 1.1, 800, '#FFD36B', font);
        COLS.forEach(function (c, ci) {
          var sets = Math.min(Math.ceil(15 / c.life - 1e-6), 12), cur = Math.min(sets - 1, Math.floor(yrs / c.life)), cols = sets > 1 ? 2 : 1, iw = 34, ih = 20;
          for (j = 0; j <= cur; j++) {
            var col = j % cols, row = Math.floor(j / cols), ix = c.x + (cols === 2 ? (col ? 6 : -6 - iw) : -iw / 2), iy = gy0 + row * (ih + 7);
            var spent = j < cur || (yrs >= 15 && j === cur && (j + 1) * c.life <= 15 + 1e-6);
            g.globalAlpha = A * (j === cur ? sm((yrs - j * c.life) / 0.4 + 0.2) : 1);
            rr(g, ix, iy, iw, ih, 3); g.fillStyle = spent ? '#2A3245' : c.c; g.fill();
            g.fillStyle = spent ? '#2A3245' : c.c; g.fillRect(ix + iw, iy + 6, 3, ih - 12);
            if (spent) { g.strokeStyle = '#FF8A7A'; g.lineWidth = 1.6; g.beginPath(); g.moveTo(ix + 9, iy + 5); g.lineTo(ix + iw - 9, iy + ih - 5); g.moveTo(ix + iw - 9, iy + 5); g.lineTo(ix + 9, iy + ih - 5); g.stroke(); }
          }
          g.globalAlpha = A;
          var used = cur + 1;
          txt(g, used + (used === 1 ? ' Batterie' : ' Batterien'), c.x, bot - fs * 2.2, fb, 800, ci ? '#FFFFFF' : '#7EE2A8', font);
          txt(g, c.cyc + ' Zyklen pro Batterie', c.x, bot - fs * 0.95, fs * 0.9, 500, '#9FB0CC', font);
        });
      } else {
        head('Spannung beim Entladen, 12-V-Batterie', 'typischer Verlauf');
        var cx0 = 96, cx1 = 610, cy0 = top + fs * 2.4, cy1 = bot - fs * 2.6, vlo = 11.6, vhi = 13.6;
        var VX = function (p) { return cx0 + (cx1 - cx0) * p / 100; }, VY = function (v) { return cy1 - (cy1 - cy0) * (v - vlo) / (vhi - vlo); };
        g.strokeStyle = 'rgba(255,255,255,0.12)'; g.lineWidth = 1; g.beginPath();
        [12, 12.5, 13, 13.5].forEach(function (v) { g.moveTo(cx0, VY(v)); g.lineTo(cx1, VY(v)); }); g.stroke();
        [12, 13].forEach(function (v) { txt(g, v + ' V', cx0 - 8, VY(v), fs * 0.86, 600, '#9FB0CC', font, 'right'); });
        txt(g, '0 %', cx0, cy1 + fs * 0.95, fs * 0.86, 600, '#9FB0CC', font); txt(g, '50 %', VX(50), cy1 + fs * 0.95, fs * 0.86, 600, '#9FB0CC', font); txt(g, '100 % entnommen', cx1, cy1 + fs * 0.95, fs * 0.86, 600, '#9FB0CC', font, 'right');
        g.setLineDash([4, 4]); g.strokeStyle = 'rgba(255,138,122,0.7)'; g.beginPath(); g.moveTo(VX(50), cy0 - 6); g.lineTo(VX(50), cy1); g.stroke(); g.setLineDash([]);
        txt(g, 'Grenze für Blei und AGM', VX(50) + 6, cy0 - 2, fs * 0.82, 650, '#FF8A7A', font, 'left');
        var pp = Math.min(100, Math.max(0, ct - 0.3) * 22);
        COLS.forEach(function (c, ci) {
          var K = VOLT[ci], end = ci ? 50 : 100, q;
          if (ci) { g.globalAlpha = A * 0.35; g.setLineDash([3, 4]); g.strokeStyle = c.c; g.lineWidth = 1.4; g.beginPath(); for (q = 50; q <= 100; q += 2) { if (q === 50) g.moveTo(VX(q), VY(vAt(K, q))); else g.lineTo(VX(q), VY(vAt(K, q))); } g.stroke(); g.setLineDash([]); g.globalAlpha = A; }
          var pe = Math.min(pp, end);
          g.strokeStyle = c.c; g.lineWidth = ci ? 2.2 : 2.8; g.beginPath();
          for (q = 0; q <= pe; q += 1) { if (!q) g.moveTo(VX(q), VY(vAt(K, q))); else g.lineTo(VX(q), VY(vAt(K, q))); }
          g.lineTo(VX(pe), VY(vAt(K, pe))); g.stroke();
          g.fillStyle = c.c; g.beginPath(); g.arc(VX(pe), VY(vAt(K, pe)), 4, 0, TAU); g.fill();
          txt(g, c.n, VX(pe) + 8, VY(vAt(K, pe)) + (ci === 1 ? -fs * 0.6 : ci === 2 ? fs * 0.6 : -fs * 0.7), fs * 0.9, 750, c.c, font, 'left');
        });
      }
      g.globalAlpha = 1;
    }
    return { ORDER: ORDER, NAMES: NAMES, TXT: TXT, ROWS: ROWS, draw: draw };
  }
  var CMPX = null;
  function cmpFx() { if (!CMPX) CMPX = makeCmp(); return CMPX; }

  /* Kosten: was ein Speicher spart. Jahresmodell in 15-Minuten-Schritten (Werkzeug cost_model.js): 10 kWp im Mittelland,
     rund 10'000 kWh pro Jahr, Haushalt 4'500 kWh (ElCom-Profil H4), E-Auto 2'500 kWh, lädt abends ab 18 Uhr mit 3.7 kW.
     Speicher nutzbar 4.75 / 9.2 / 13.5 kWh, Wirkungsgrad hin und zurück 92 %. Alterung: Die Ersparnis sinkt um 1 % pro Jahr,
     beim 5-kWh-Speicher um 2 % (Zellen LF105 mit 3'000 Zyklen bis 70 %, rund 300 Zyklen pro Jahr).
     Strompreis 26.5 Rp./kWh (ElCom, Median 2027), Rückliefertarif 6 Rp./kWh (Minimum nach Art. 12 EnV, Anlagen unter 30 kW).
     AGM: Victron 12V 220Ah zu CHF 500 (Digitec), 600 Zyklen bei 50 % Entladung (Victron-Datenblatt). */
  function makeCost() {
    var TAU = 6.283185307, BUY = 26.5, FEED = 6, YRS = 15, NB = '\u00a0';
    var SIZES = ['h5', 'h10', 'h15'];
    var HOME = {
      h5: { kwh: 5, name: '48V Solarspeicher 5 kWh', handle: '48v-lifepo4-solarspeicher-6kwh', price: 1199, age: 0.02, disp: "ab CHF 1'199.–", sim: [[1438, 1560], [1477, 1602]] },
      h10: { kwh: 10, name: '48V Solarspeicher 10 kWh', handle: '10-kwh-solarspeicher', price: 2800, age: 0.01, disp: "CHF 2'800.–", sim: [[1947, 2113], [2580, 2800]] },
      h15: { kwh: 15, name: '48V Solarspeicher 15 kWh', handle: '15kwh-48v-gobelpower-solarspeicher', price: 3500, age: 0.01, disp: "CHF 3'500.–", sim: [[2097, 2276], [3261, 3539]] }
    };
    var LFP = { price: 850, use: 3.6, cyc: 8000, kg: 25 }, AGM = { unit: 500, kwh: 2.64, cyc: 600, kg: 65 };
    var TXT = {
      agm: 'Bei gleich viel nutzbarer Energie ist AGM schon beim Kauf teurer. Bei täglicher Nutzung muss sie zudem rund alle 20' + NB + 'Monate ersetzt werden.'
    };
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function grp(n) { var v = String(Math.round(Math.abs(n))), o = ''; while (v.length > 3) { o = "'" + v.slice(-3) + o; v = v.slice(0, -3); } return v + o; }
    function chf(n) { return 'CHF' + NB + grp(n) + '.–'; }
    function r10(n) { return Math.round(n / 10) * 10; }
    function yrs(y) { var h = Math.round(y * 2) / 2; return (h % 1 ? h.toFixed(1) : String(h)) + NB + 'Jahren'; }
    // Ersparnis bis zum Jahr y, jedes Jahr um den Anteil ag kleiner (Alterung)
    function cum(S, y, ag) { var n = Math.floor(y), f = y - n; return S * (n - ag * n * (n - 1) / 2) + f * S * (1 - ag * n); }
    function payOf(S, p, ag) { if (S <= 0) return 99; for (var y = 0; y <= 40; y += 0.02) if (cum(S, y, ag) >= p) return y; return 99; }
    function home(sz, ev, price) {
      var H = HOME[sz] || HOME.h10, p = price > 0 ? price : H.price, r = H.sim[ev ? 1 : 0], S = (r[0] * BUY - r[1] * FEED) / 100;
      return { H: H, price: p, save: S, more: r[0], pay: payOf(S, p, H.age), gain: cum(S, YRS, H.age) - p };
    }
    function agm(price) {
      var p = price > 0 ? price : LFP.price, set = AGM.unit * LFP.use * 2 / AGM.kwh, days = YRS * 365, kwh = LFP.use * days, n = Math.ceil(days / AGM.cyc - 1e-9);
      return { lfp: p, set: set, n: n, total: n * set, lfpRp: p / kwh * 100, agmRp: n * set / kwh * 100, every: AGM.cyc / 365, kg: AGM.kg * LFP.use * 2 / AGM.kwh };
    }
    function rows(sz, ev, price) {
      var h = home(sz, ev, price);
      return [['Mehr Solarstrom genutzt', grp(r10(h.more)) + NB + 'kWh pro Jahr'], ['Ersparnis pro Jahr', chf(r10(h.save))], ['Bezahlt nach', h.pay > 30 ? 'mehr als 30' + NB + 'Jahren' : 'rund ' + yrs(h.pay)], [h.gain >= 0 ? 'Gewinn nach 15 Jahren' : 'Nach 15 Jahren fehlen', chf(r10(h.gain))]];
    }
    function agmRows(price) {
      var q = agm(price);
      return [['Preis, 3.6 kWh nutzbar', chf(q.lfp), chf(r10(q.set))], ['Ersatz in 15 Jahren', 'keiner', (q.n - 1) + NB + 'Mal'], ['Kosten in 15 Jahren', chf(q.lfp), chf(r10(q.total))], ['Pro kWh gespeichert', Math.round(q.lfpRp) + NB + 'Rp.', Math.round(q.agmRp) + NB + 'Rp.'], ['Gewicht', LFP.kg + NB + 'kg', r10(q.kg) + NB + 'kg']];
    }
    function note(view, ev) {
      if (view === 'agm') return "AGM: Victron 12V 220Ah zu CHF 500.– (Digitec), anteilig für 3.6" + NB + "kWh nutzbar, 600 Zyklen bei 50" + NB + "% Entladung. LiFePO4: Bausatz aus unserem Shop, 8'000 Zyklen laut Zellhersteller.";
      return (ev ? 'Mit E-Auto, das abends lädt, bringt ein grosser Speicher am meisten.' : 'Ohne E-Auto bringt ein kleiner Speicher am meisten pro Franken.')
        + " Beispiel: 10" + NB + "kWp Solaranlage mit Hybridwechselrichter, Haushalt 4'500" + NB + "kWh" + (ev ? " und E-Auto 2'500" + NB + "kWh" : '') + ' pro Jahr, Strompreis 26.5' + NB + 'Rp./kWh (Median 2027), Rückvergütung 6' + NB + 'Rp./kWh (Minimum), Shoppreise ohne Montage.';
    }
    function rr(g, x, y, w, h, r) { g.beginPath(); g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath(); }
    function txt(g, s, x, y, size, weight, col, font, align) { g.font = weight + ' ' + size.toFixed(1) + 'px ' + font; g.fillStyle = col; g.textAlign = align || 'center'; g.textBaseline = 'middle'; g.fillText(s, x, y); }
    function batt(g, x, y, w, h, col) { rr(g, x - w / 2, y - h / 2, w, h, 2.5); g.fillStyle = col; g.fill(); g.fillRect(x + w / 2, y - h / 4, 2.5, h / 2); }
    function draw(g, cw, chh, s) {
      var k = cw / 680, A = s.a, kt = s.kt || 0, sma = !!s.small, i, y, v;
      g.setTransform(k, 0, 0, k, 0, 0);
      var font = s.font || 'Arial, sans-serif', fs = Math.max(11, (s.minPx || 10) / (s.pxu || 1)), fb = fs * 1.3;
      var yr = YRS * cl((kt - 0.7) / 5), x0 = sma ? 108 : 96, x1 = sma ? 642 : 636, ty = sma ? 30 : 34;
      var X = function (yy) { return x0 + (x1 - x0) * yy / YRS; };
      g.globalAlpha = A;
      var axisX = function (yb) {
        [0, 5, 10, 15].forEach(function (yy) { txt(g, yy === 15 ? '15 Jahre' : String(yy), X(yy), yb + fs * 1.15, fs * 0.86, 600, '#9FB0CC', font, yy === 15 ? 'right' : 'center'); });
      };
      var yearTag = function (yt) { if (yr < YRS) txt(g, 'Jahr ' + Math.floor(yr), x0 + 6, yt, fs * 1.05, 800, '#FFD36B', font, 'left'); };
      if (s.view === 'agm') {
        var q = agm(s.p4);
        txt(g, '12V Speicher 4 kWh oder AGM', 340, ty, fb, 800, '#FFFFFF', font);
        txt(g, sma ? '15 Jahre, je 3.6 kWh nutzbar' : '15 Jahre, ein Zyklus pro Tag, je 3.6 kWh nutzbar', 340, ty + fb * 0.95, fs * 0.92, 500, '#9FB0CC', font);
        var a0 = sma ? 120 : 110, a1 = sma ? 446 : 452, vmax = 15000;
        var YA = function (vv) { return a1 - (a1 - a0) * vv / vmax; };
        g.lineWidth = 1;
        [5000, 10000, 15000].forEach(function (vv) { g.strokeStyle = 'rgba(255,255,255,0.09)'; g.beginPath(); g.moveTo(x0, YA(vv)); g.lineTo(x1, YA(vv)); g.stroke(); txt(g, grp(vv), x0 - 8, YA(vv), fs * 0.84, 600, '#9FB0CC', font, 'right'); });
        g.strokeStyle = 'rgba(255,255,255,0.32)'; g.beginPath(); g.moveTo(x0, YA(0)); g.lineTo(x1, YA(0)); g.stroke();
        txt(g, '0', x0 - 8, YA(0), fs * 0.84, 600, '#9FB0CC', font, 'right'); txt(g, 'CHF', x0 - 8, a0 - fs * 1.2, fs * 0.84, 700, '#9FB0CC', font, 'right');
        axisX(a1);
        // AGM: alle 600 Zyklen ein neuer Satz
        var nNow = Math.min(q.n, Math.floor(yr / q.every + 1e-9) + 1), costA = nNow * q.set;
        g.strokeStyle = '#F5B526'; g.lineWidth = 2.4; g.lineJoin = 'round'; g.beginPath(); g.moveTo(X(0), YA(q.set));
        for (i = 1; i < nNow; i++) { g.lineTo(X(i * q.every), YA(i * q.set)); g.lineTo(X(i * q.every), YA((i + 1) * q.set)); }
        g.lineTo(X(yr), YA(costA)); g.stroke();
        for (i = 0; i < nNow; i++) { g.globalAlpha = A * sm((yr - i * q.every) / 0.35 + 0.25); batt(g, X(i * q.every) + 11, YA((i + 1) * q.set) - 9, 14, 9, '#F5B526'); }
        g.globalAlpha = A;
        // LiFePO4: ein Kauf
        g.strokeStyle = '#3DDC84'; g.lineWidth = 2.8; g.beginPath(); g.moveTo(X(0), YA(q.lfp)); g.lineTo(X(Math.max(yr, 0.02)), YA(q.lfp)); g.stroke();
        batt(g, X(0) + 11, YA(q.lfp) + 10, 14, 9, '#3DDC84');
        yearTag(a0 + fs * 0.4);
        if (yr < YRS) {
          txt(g, 'AGM ' + chf(r10(costA)), Math.min(X(yr) + 8, x1 - 4), YA(costA) - fs * 1.05, fs * 0.92, 750, '#F5B526', font, X(yr) + 8 > x1 - 150 ? 'right' : 'left');
          txt(g, 'LiFePO4 ' + chf(q.lfp), Math.min(X(yr) + 8, x1 - 4), YA(q.lfp) - fs * 1.05, fs * 0.92, 750, '#7EE2A8', font, X(yr) + 8 > x1 - 150 ? 'right' : 'left');
        } else {
          var fe = sm((kt - 5.7) / 0.6);
          g.globalAlpha = A * fe;
          txt(g, 'AGM: ' + chf(r10(q.total)), x1, YA(q.total) - fs * 3.3, fb, 800, '#F5B526', font, 'right');
          txt(g, Math.round(q.agmRp) + ' Rp. pro kWh, ' + q.n + ' Batteriesätze', x1, YA(q.total) - fs * 2.0, fs * 0.9, 600, '#E8EEF8', font, 'right');
          txt(g, 'LiFePO4: ' + chf(q.lfp), x1, YA(q.lfp) - fs * 2.3, fb, 800, '#7EE2A8', font, 'right');
          txt(g, Math.round(q.lfpRp) + ' Rp. pro kWh, ein Speicher', x1, YA(q.lfp) - fs * 1.05, fs * 0.9, 600, '#E8EEF8', font, 'right');
          g.globalAlpha = A;
        }
      } else {
        var H = HOME[s.sz] || HOME.h10, S = s.save, P = s.price, AG = H.age;
        txt(g, 'Speicher ' + H.kwh + ' kWh für ' + chf(s.priceT || P), 340, ty, fb, 800, '#FFFFFF', font);
        txt(g, s.ev ? 'Haus mit 10 kWp Solaranlage und E-Auto' : 'Haus mit 10 kWp Solaranlage', 340, ty + fb * 0.95, fs * 0.92, 500, '#9FB0CC', font);
        // Rechnung pro Kilowattstunde aus dem Speicher
        var ey = sma ? 104 : 98, ex = [150, 340, 530], ev = [BUY.toFixed(1) + ' Rp.', FEED + ' Rp.', (BUY - FEED).toFixed(1) + ' Rp.'];
        var el = sma ? ['Netzstrom', 'Rückvergütung', 'gespart'] : ['Strom aus dem Netz', 'Rückvergütung', 'gespart pro kWh'], ec = ['#FFFFFF', '#FFD36B', '#7EE2A8'];
        for (i = 0; i < 3; i++) { txt(g, ev[i], ex[i], ey, fs * 1.7, 800, ec[i], font); txt(g, el[i], ex[i], ey + fs * 1.45, fs * 0.86, 600, '#9FB0CC', font); }
        txt(g, '−', 245, ey, fs * 1.6, 700, '#9FB0CC', font); txt(g, '=', 435, ey, fs * 1.6, 700, '#9FB0CC', font);
        var y0 = sma ? 176 : 164, y1 = sma ? 446 : 452, vmin = -4500, vmax = 7000;
        var Y = function (vv) { return y1 - (y1 - y0) * (vv - vmin) / (vmax - vmin); };
        g.lineWidth = 1;
        [-2000, 2000, 4000, 6000].forEach(function (vv) { g.strokeStyle = 'rgba(255,255,255,0.09)'; g.beginPath(); g.moveTo(x0, Y(vv)); g.lineTo(x1, Y(vv)); g.stroke(); txt(g, (vv < 0 ? '−' : '') + grp(vv), x0 - 8, Y(vv), fs * 0.84, 600, '#9FB0CC', font, 'right'); });
        g.strokeStyle = 'rgba(255,255,255,0.35)'; g.beginPath(); g.moveTo(x0, Y(0)); g.lineTo(x1, Y(0)); g.stroke();
        txt(g, '0', x0 - 8, Y(0), fs * 0.84, 700, '#C9D4E8', font, 'right'); txt(g, 'CHF', x0 - 8, y0 - fs * 1.2, fs * 0.84, 700, '#9FB0CC', font, 'right');
        axisX(y1);
        // Verlauf: Kaufpreis, dann jedes Jahr die Ersparnis
        var pts = [];
        for (y = 0; y < yr; y += 0.1) pts.push([X(y), Y(-P + cum(S, y, AG))]);
        pts.push([X(yr), Y(-P + cum(S, yr, AG))]);
        var area = function () { g.beginPath(); g.moveTo(X(0), Y(0)); pts.forEach(function (p) { g.lineTo(p[0], p[1]); }); g.lineTo(X(yr), Y(0)); g.closePath(); };
        g.save(); g.beginPath(); g.rect(x0, y0 - 30, x1 - x0 + 4, Y(0) - y0 + 30); g.clip(); area(); g.fillStyle = 'rgba(61,220,132,0.24)'; g.fill(); g.restore();
        g.save(); g.beginPath(); g.rect(x0, Y(0), x1 - x0 + 4, y1 - Y(0) + 6); g.clip(); area(); g.fillStyle = 'rgba(255,138,122,0.17)'; g.fill(); g.restore();
        g.strokeStyle = '#3DDC84'; g.lineWidth = 2.8; g.lineJoin = 'round'; g.beginPath();
        pts.forEach(function (p, j) { if (j) g.lineTo(p[0], p[1]); else g.moveTo(p[0], p[1]); }); g.stroke();
        txt(g, 'Kauf ' + chf(s.priceT || P), X(0) + 4, Y(-P) + fs * 1.15, fs * 0.92, 750, '#FF8A7A', font, 'left');
        var pay = payOf(S, P, AG), last = pts[pts.length - 1];
        if (pay <= yr) {
          // Beschriftung rechts vom Punkt: Dort liegt die Kurve schon über null
          var pa = sm((yr - pay) / 0.6), px = X(pay), pl = 'bezahlt nach ' + yrs(pay);
          g.font = '800 ' + (fs * 0.98).toFixed(1) + 'px ' + font;
          var rgt = px + 10 + g.measureText(pl).width <= x1;
          g.globalAlpha = A * pa;
          g.setLineDash([4, 4]); g.strokeStyle = 'rgba(255,211,107,0.8)'; g.lineWidth = 1.2; g.beginPath(); g.moveTo(px, Y(0) - 6); g.lineTo(px, Y(0) + fs * 2.2); g.stroke(); g.setLineDash([]);
          g.fillStyle = '#FFD36B'; g.beginPath(); g.arc(px, Y(0), 5, 0, TAU); g.fill();
          txt(g, pl, rgt ? px + 10 : px - 10, Y(0) + fs * 1.45, fs * 0.98, 800, '#FFD36B', font, rgt ? 'left' : 'right');
          g.globalAlpha = A;
        }
        g.fillStyle = '#3DDC84'; g.beginPath(); g.arc(last[0], last[1], 4.5, 0, TAU); g.fill();
        yearTag(y0 + fs * 0.4);
        if (yr >= YRS) {
          var gn = -P + cum(S, YRS, AG), gy = Math.max(y0 + fs * 1.2, last[1] - fs * 1.6);
          g.globalAlpha = A * sm((kt - 5.7) / 0.6);
          txt(g, (gn >= 0 ? 'Gewinn nach 15 Jahren: ' : 'Nach 15 Jahren fehlen ') + chf(r10(gn)), x1 - 12, gy, fb, 800, gn >= 0 ? '#7EE2A8' : '#FF8A7A', font, 'right');
          g.globalAlpha = A;
        }
      }
      g.globalAlpha = 1;
    }
    return { SIZES: SIZES, HOME: HOME, TXT: TXT, home: home, agm: agm, rows: rows, agmRows: agmRows, note: note, chf: chf, draw: draw };
  }
  var COSTX = null;
  function costFx() { if (!COSTX) COSTX = makeCost(); return COSTX; }

  /* Speicher-Finder: Einsatz, Bedarf und Reserve ergeben Spannung, Grösse und Leistung.
     Verbrauch pro Tag aus typischen Geräten, nutzbar sind 90 % der Nennkapazität (10 kWh: 9.2 kWh laut Hersteller).
     Leistung laut Produktseiten, beim 15-kWh-Speicher 150 A dauernd laut Gobelpower, also rund 7'000 W.
     Haus: Faustregel von Swissolar, rund 1 kWh Speicher pro 1'000 kWh Jahresverbrauch. Mit E-Auto, das abends lädt,
     5 kWh mehr. Das deckt sich mit dem Kapitel «Kosten». */
  function makeFinder() {
    var TAU = 6.283185307, NB = '\u00a0';
    var PROD = {
      f12s: { v: 12, kwh: 2.5, use: 2.4, w: 2400, name: '12V Solarspeicher 2.5 kWh', handle: '12v-lifepo4-solarspeicher-3kwh', disp: 'ab CHF 519.–', vars: [['Zusammengebaut', 609], ['Bausatz', 519]] },
      p4: { v: 12, kwh: 4, use: 3.6, w: 2400, name: '12V Solarspeicher 4 kWh', handle: '12v-lifepo4-solarbatterie-4kwh', disp: 'ab CHF 850.–', vars: [['Zusammengebaut', 935], ['Bausatz', 850]] },
      p4b: { v: 12, kwh: 8, use: 7.2, w: 2400, name: '12V Solarspeicher 8 kWh', handle: '12v-lifepo4-solarspeicher-8kwh-1', disp: "CHF 1'359.–", vars: [['', 1359]] },
      f24s: { v: 24, kwh: 2.5, use: 2.4, w: 2400, name: '24V Solarspeicher 2.5 kWh', handle: '24v-lifepo4-solarspeicher-3kwh', disp: 'ab CHF 539.–', vars: [['Zusammengebaut', 629], ['Bausatz', 539]] },
      f24m: { v: 24, kwh: 5, use: 4.75, w: 4800, name: '24V Solarspeicher 5 kWh', handle: '24v-lifepo4-solarspeicher-6kwh', disp: "ab CHF 1'179.–", vars: [['Zusammengebaut', 1329], ['Bausatz', 1179]] },
      p8: { v: 24, kwh: 8, use: 7.2, w: 4800, name: '24V Solarspeicher 8 kWh', handle: '24v-lifepo4-solarbatterie-8kwh', disp: "ab CHF 1'750.–", vars: [['Zusammengebaut', 1930], ['Bausatz', 1750]] },
      h5: { v: 48, kwh: 5, use: 4.75, w: 4800, name: '48V Solarspeicher 5 kWh', handle: '48v-lifepo4-solarspeicher-6kwh', disp: "ab CHF 1'199.–", vars: [['Zusammengebaut', 1349], ['Bausatz', 1199]] },
      h10: { v: 48, kwh: 10, use: 9.2, w: 6000, name: '48V Solarspeicher 10 kWh', handle: '10-kwh-solarspeicher', disp: "CHF 2'800.–", vars: [['', 2800]] },
      h15: { v: 48, kwh: 15, use: 13.5, w: 7000, name: '48V Solarspeicher 15 kWh', handle: '15kwh-48v-gobelpower-solarspeicher', disp: "CHF 3'500.–", vars: [['', 3500]] }
    };
    var KEYS = ['f12s', 'p4', 'p4b', 'f24s', 'f24m', 'p8', 'h5', 'h10', 'h15'];
    var BYV = { 12: ['f12s', 'p4', 'p4b'], 24: ['f24s', 'f24m', 'p8'], 48: ['h5', 'h10', 'h15'] };
    var ORDER = ['haus', 'wohnung', 'camper', 'boot', 'alp', 'garten'];
    // Bedarfsstufen: Name, Beispiel, Wh pro Tag (Haus: kWh pro Jahr), Spitzenleistung in W
    var USE = {
      haus: { t: 'Haus', s: 'mit Solaranlage', v: 48, opt: 'ev', link: ['Hybridwechselrichter', '/collections/wechselrichter'],
        lv: [['Klein', "bis 3'500 kWh", 3500, 5000], ['Mittel', "bis 6'000 kWh", 4500, 5000], ['Gross', "über 6'000 kWh", 6500, 5000]],
        why: 'Häuser nutzen 48 V. Faustregel von Swissolar, mit E-Auto 5' + NB + 'kWh mehr.' },
      wohnung: { t: 'Wohnung', s: 'Balkonkraftwerk', v: 24, opt: '', link: ['Einspeisewechselrichter', '/collections/wechselrichter-1'],
        lv: [['Grundlast', 'Kühlen, WLAN', 1200, 300], ['Abends', '+ Kochen, TV', 2000, 800], ['Viel', '+ Homeoffice', 3500, 1000]],
        why: '24 V passt zu Einspeisewechselrichtern wie Lumentree, geladen wird vom Balkon.' },
      camper: { t: 'Camper', s: 'Van, Wohnmobil', v: 12, opt: 'days', link: ['Solarladeregler', '/collections/solarladeregler'],
        lv: [['Basis', 'Licht, Handy', 600, 300], ['Komfort', '+ Kühlschrank', 1500, 1000], ['Autark', '+ Kaffee, Induktion', 3000, 2000]],
        why: '12 V wie das Bordnetz im Fahrzeug, die Geräte passen direkt.' },
      boot: { t: 'Boot', s: 'Segel, Motor', v: 12, opt: 'days', link: ['Solarladeregler', '/collections/solarladeregler'],
        lv: [['Wochenende', 'Licht, Navi', 500, 200], ['Törn', '+ Kühlschrank', 1500, 800], ['Langfahrt', '+ Wassermacher', 3000, 2000]],
        why: '12 V wie das Bordnetz der meisten Boote, bei 24-V-Bordnetz den 24V-Speicher.' },
      alp: { t: 'Alphütte', s: 'Ferienhaus, Offgrid', v: 24, opt: 'days', link: ['Solarladeregler', '/collections/solarladeregler'],
        lv: [['Einfach', 'Licht, Kühlen', 1500, 800], ['Komfort', '+ Kaffee, TV', 3500, 2500], ['Ganzjährig', '+ Kochen, Waschen', 7000, 4000]],
        why: 'Bei grossem Bedarf 48 V. In den Bergen mit 2 bis 3 Tagen ohne Sonne rechnen.' },
      garten: { t: 'Gartenhaus', s: 'Werkstatt, Laube', v: 12, opt: 'days', link: ['Solarladeregler', '/collections/solarladeregler'],
        lv: [['Licht', 'Licht, Laden', 300, 200], ['Kühlen', '+ Kühlschrank', 900, 500], ['Werkzeug', '+ Säge, Pumpe', 1500, 1800]],
        why: 'Für kleine Anlagen reicht 12 V, das Zubehör ist günstig.' }
    };
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function grp(n) { var v = String(Math.round(Math.abs(n))), o = ''; while (v.length > 3) { o = "'" + v.slice(-3) + o; v = v.slice(0, -3); } return v + o; }
    function f1(x) { var r = Math.round(x * 10) / 10; return r % 1 ? r.toFixed(1) : String(r); }
    function pick(u, lv, days, ev) {
      var U = USE[u] || USE.haus, key0 = USE[u] ? u : 'haus', li = Math.max(0, Math.min(2, lv == null ? 1 : +lv || 0)), L = U.lv[li], house = key0 === 'haus';
      var d = U.opt === 'days' ? Math.max(1, Math.min(3, +days || 1)) : 1, e = U.opt === 'ev' && !!ev;
      var daily = house ? L[2] / 365 : L[2] / 1000, need = house ? L[2] / 1000 + (e ? 5 : 0) : daily * d, peak = L[3], V = U.v, i;
      // Alphütte: Wird es für 24 V zu gross, auf 48 V wechseln
      if (key0 === 'alp' && (need > PROD.p8.use || peak > PROD.p8.w)) V = 48;
      var list = BYV[V], key = list[list.length - 1];
      // Beim Haus deckt das Netz die Spitzen, dort zählt nur die Grösse
      for (i = 0; i < list.length; i++) { var q = PROD[list[i]]; if (q.use >= need - 1e-9 && (house || q.w >= peak)) { key = list[i]; break; } }
      var P = PROD[key];
      return { u: key0, U: U, li: li, L: L, d: d, ev: e, house: house, V: V, need: need, daily: daily, peak: peak, key: key, P: P, reach: house ? 0 : P.use / daily, short: P.use < need - 1e-9 };
    }
    function unit(r, night) { var one = f1(r) === '1'; return night ? (one ? 'Nacht' : 'Nächte') : (one ? 'Tag' : 'Tage'); }
    function rows(R) {
      var P = R.P, out = [['Spannung und Leistung', P.v + NB + 'V, bis ' + grp(P.w) + NB + 'W'], ['Speicher', f1(P.kwh) + NB + 'kWh, davon ' + f1(P.use) + NB + 'kWh nutzbar']];
      if (R.house) out.push(['Bedarf nach Faustregel', f1(R.need) + NB + 'kWh']);
      else out.push(['Reicht für', 'rund ' + f1(R.reach) + NB + unit(R.reach, R.u === 'wohnung')]);
      return out;
    }
    function sum(R) {
      if (R.house) return "Haus mit " + grp(R.L[2]) + ' kWh pro Jahr' + (R.ev ? ' und E-Auto' : '');
      if (R.u === 'wohnung') return 'Wohnung mit Balkonkraftwerk, ' + R.L[0];
      return R.U.t + ', ' + R.L[0] + ', ' + R.d + (R.d > 1 ? ' Tage' : ' Tag') + ' ohne Sonne';
    }
    // Ausführungen eines Speichers: live aus dem Shop oder die hinterlegten Preise
    function chf(n) { var c = Math.round(n * 100) % 100; return 'CHF' + NB + grp(Math.floor(n + 1e-9)) + (c ? '.' + (c < 10 ? '0' : '') + c : '.–'); }
    function vars(key, live) {
      if (live && live.length) return live;
      return ((PROD[key] || {}).vars || []).map(function (v) { return { id: 0, price: v[1], avail: true, title: v[0] }; });
    }
    function varKey(t, i) { return /zusammen|montiert/i.test(t) ? 'z' : /bausatz/i.test(t) ? 'b' : 'i' + i; }
    // Gewählte Ausführung, sonst zusammengebaut, sonst die erste lieferbare
    function pickVar(list, pref) {
      var i;
      if (pref) for (i = 0; i < list.length; i++) if (varKey(list[i].title, i) === pref) return i;
      for (i = 0; i < list.length; i++) if (list[i].avail && varKey(list[i].title, i) === 'z') return i;
      for (i = 0; i < list.length; i++) if (list[i].avail) return i;
      return 0;
    }
    function varLabel(t) { return /zusammen|montiert/i.test(t) ? ['Montiert', 'mit Garantie'] : /bausatz/i.test(t) ? ['Bausatz', 'ohne Garantie'] : [t, '']; }
    function note(R) { return R.U.why + (R.short ? ' Mehr Reserve: zwei Speicher parallel.' : '') + ' Richtwerte.'; }
    function rr(g, x, y, w, h, r) { r = Math.min(r, h / 2, w / 2); g.beginPath(); g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath(); }
    function txt(g, s, x, y, size, weight, col, font, align) { g.font = weight + ' ' + size.toFixed(1) + 'px ' + font; g.fillStyle = col; g.textAlign = align || 'center'; g.textBaseline = 'middle'; g.fillText(s, x, y); }
    function draw(g, cw, chh, s) {
      var k = cw / 680, A = s.a, sma = !!s.small, i, gr = sm((s.ft || 0) / 0.8);
      g.setTransform(k, 0, 0, k, 0, 0);
      var font = s.font || 'Arial, sans-serif', fs = Math.max(11, (s.minPx || 10) / (s.pxu || 1)), fb = fs * 1.3;
      var R = pick(s.use, s.lv, s.days, s.ev), P = R.P, ty = sma ? 30 : 34;
      g.globalAlpha = A;
      txt(g, P.name, 340, ty, fb, 800, '#FFFFFF', font);
      txt(g, sum(R), 340, ty + fb * 0.95, fs * 0.92, 500, '#9FB0CC', font);
      // Drei Kennzahlen
      var ky = sma ? 106 : 100, kx = [150, 340, 530], kv = [P.v + ' V', f1(P.use) + ' kWh', grp(P.w) + ' W'], kl = ['Spannung', 'nutzbar', 'Leistung bis'], kc = ['#FFD36B', '#7EE2A8', '#FFFFFF'];
      for (i = 0; i < 3; i++) { txt(g, kv[i], kx[i], ky, fs * 1.9, 800, kc[i], font); txt(g, kl[i], kx[i], ky + fs * 1.55, fs * 0.86, 600, '#9FB0CC', font); }
      var lx = sma ? 120 : 112, bx = lx + 12, bw = 600 - bx, bh = Math.max(16, fs * 1.3);
      // Energie: Bedarf gegen nutzbaren Speicher
      var ey = sma ? 188 : 184, segs = [], mx;
      if (R.house) { segs.push([R.L[2] / 1000, 'Haushalt']); if (R.ev) segs.push([5, 'E-Auto']); }
      else for (i = 0; i < R.d; i++) segs.push([R.daily, R.u === 'wohnung' ? 'Nacht' : 'Tag ' + (i + 1)]);
      mx = Math.max(R.need, P.use) / 0.86;
      var X = function (v) { return bx + bw * v / mx; };
      txt(g, R.house ? 'Faustregel: ' + f1(R.need) + ' kWh' : 'Bedarf für ' + (R.u === 'wohnung' ? 'eine Nacht' : R.d + (R.d > 1 ? ' Tage' : ' Tag')) + ': ' + f1(R.need) + ' kWh', 40, ey, fs * 1.02, 800, '#E8EEF8', font, 'left');
      txt(g, R.house ? (R.short ? 'knapp' : 'Reserve ' + f1(P.use - R.need) + ' kWh') : 'reicht rund ' + f1(R.reach) + ' ' + unit(R.reach, R.u === 'wohnung'), 640, ey, fs * 1.02, 800, R.short ? '#FFD36B' : '#7EE2A8', font, 'right');
      var y1 = ey + fs * 1.4 + 6, y2 = y1 + bh + 12, acc = 0;
      txt(g, 'Bedarf', lx, y1 + bh / 2, fs * 0.9, 650, '#C9D4E8', font, 'right');
      txt(g, 'Speicher', lx, y2 + bh / 2, fs * 0.9, 650, '#C9D4E8', font, 'right');
      segs.forEach(function (sg) {
        var x0 = X(acc * gr), x1 = X((acc + sg[0]) * gr);
        rr(g, x0 + 1, y1, Math.max(0, x1 - x0 - 2), bh, 4); g.fillStyle = 'rgba(255,255,255,0.14)'; g.fill(); g.strokeStyle = 'rgba(255,255,255,0.55)'; g.lineWidth = 1.2; g.stroke();
        g.font = '600 ' + (fs * 0.82).toFixed(1) + 'px ' + font;
        if (x1 - x0 > g.measureText(sg[1]).width + 10) txt(g, sg[1], (x0 + x1) / 2, y1 + bh / 2, fs * 0.82, 600, '#E8EEF8', font);
        acc += sg[0];
      });
      rr(g, bx, y2, Math.max(0, X(P.use * gr) - bx), bh, 4); g.fillStyle = 'rgba(61,220,132,0.85)'; g.fill();
      txt(g, f1(P.use) + ' kWh', X(P.use * gr) + 8, y2 + bh / 2, fs * 0.9, 750, '#7EE2A8', font, 'left');
      // Strom bei Spitzenleistung für 12, 24 und 48 V
      var cy = y2 + bh + (sma ? 50 : 62), maxA = Math.max(260, R.peak / 12 * 1.12), wA = bw * 0.86;
      txt(g, 'Strom bei ' + grp(R.peak) + ' W', 40, cy, fs * 1.02, 800, '#E8EEF8', font, 'left');
      var r0 = cy + fs * 1.4 + 14, gap = bh + 12, lim = bx + wA * 200 / maxA;
      g.setLineDash([4, 4]); g.strokeStyle = 'rgba(255,211,107,0.75)'; g.lineWidth = 1.2; g.beginPath(); g.moveTo(lim, r0 - 8); g.lineTo(lim, r0 + 2 * gap + bh + 4); g.stroke(); g.setLineDash([]);
      [12, 24, 48].forEach(function (V, j) {
        var I = R.peak / V, yy = r0 + j * gap, on = V === R.V, col = on ? '#3DDC84' : I > 200 ? '#FF8A7A' : '#5B6B86';
        txt(g, V + ' V', lx, yy + bh / 2, fs * 0.9, on ? 800 : 650, on ? '#7EE2A8' : '#C9D4E8', font, 'right');
        var w = wA * Math.min(I, maxA) / maxA * gr;
        rr(g, bx, yy, Math.max(0, w), bh, 4); g.fillStyle = col; g.globalAlpha = A * (on ? 0.9 : 0.75); g.fill(); g.globalAlpha = A;
        txt(g, Math.round(I) + ' A' + (on ? '  passt' : I > 200 ? '  zu viel' : ''), bx + w + 8, yy + bh / 2, fs * 0.9, 750, on ? '#7EE2A8' : I > 200 ? '#FF8A7A' : '#C9D4E8', font, 'left');
      });
      txt(g, '200 A', lim + 6, r0 - 8, fs * 0.8, 700, '#FFD36B', font, 'left');
      txt(g, sma ? 'Höhere Spannung, kleinerer Strom: dünnere Kabel.' : 'Je höher die Spannung, desto kleiner der Strom: dünnere Kabel und kleinere Sicherungen.', 340, r0 + 2 * gap + bh + (sma ? 30 : 34), fs * 0.86, 500, '#9FB0CC', font);
      g.globalAlpha = 1;
    }
    return { KEYS: KEYS, PROD: PROD, ORDER: ORDER, USE: USE, pick: pick, rows: rows, sum: sum, note: note, chf: chf, vars: vars, varKey: varKey, pickVar: pickVar, varLabel: varLabel, draw: draw };
  }
  var FINDX = null;
  function findFx() { if (!FINDX) FINDX = makeFinder(); return FINDX; }

  function makePackFx() {
    var TAU = 6.283185307;
    function cl(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
    function sm(x) { x = cl(x); return x * x * (3 - 2 * x); }
    function mk(n) { var c = document.createElement('canvas'); c.width = n; c.height = n; return c; }
    function ball(c0, c1, c2) {
      var c = mk(64), g = c.getContext('2d'), gr = g.createRadialGradient(23, 20, 2, 32, 32, 31);
      gr.addColorStop(0, c0); gr.addColorStop(0.42, c1); gr.addColorStop(1, c2);
      g.fillStyle = gr; g.beginPath(); g.arc(32, 32, 30.5, 0, TAU); g.fill();
      return c;
    }
    function glow(rgb, a) {
      var c = mk(96), g = c.getContext('2d'), gr = g.createRadialGradient(48, 48, 0, 48, 48, 48);
      gr.addColorStop(0, 'rgba(' + rgb + ',' + a + ')'); gr.addColorStop(0.32, 'rgba(' + rgb + ',' + (a * 0.32) + ')'); gr.addColorStop(1, 'rgba(' + rgb + ',0)');
      g.fillStyle = gr; g.fillRect(0, 0, 96, 96);
      return c;
    }
    var SPR = null;
    function spr() {
      if (!SPR) SPR = { e: ball('#EEF4FF', '#8FB6FF', '#3A62C4'), eG: glow('143,182,255', 0.9), li: ball('#FFF8DC', '#F7C531', '#AE7908'), liG: glow('247,197,49', 0.85), heat: glow('255,104,36', 0.9), cy: glow('120,226,255', 0.95), wh: glow('214,232,255', 0.8) };
      return SPR;
    }
    function rrect(g, x, y, w, h, r) { g.moveTo(x + r, y); g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r); g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r); g.closePath(); }
    function pill(g, txt, x, y, fs, font, bg, fg) {
      g.font = '650 ' + fs + 'px ' + font;
      var w = g.measureText(txt).width, px = fs * 0.7, h = fs * 1.75, x0 = x - w / 2 - px;
      g.fillStyle = bg || 'rgba(8,18,43,0.84)'; g.beginPath(); rrect(g, x0, y - h / 2, w + 2 * px, h, h / 2); g.fill();
      g.strokeStyle = 'rgba(255,255,255,0.16)'; g.lineWidth = 0.8; g.stroke();
      g.fillStyle = fg || '#E8EEF8'; g.textBaseline = 'middle'; g.textAlign = 'left'; g.fillText(txt, x0 + px, y + fs * 0.04);
    }
    var C = { cy: 1, sy: 0, cp: 1, sp: 0, z: 1, cyy: 260 };
    function setCam(cam) { var b = cam.yaw * Math.PI / 180, a = cam.pitch * Math.PI / 180; C.cy = Math.cos(b); C.sy = Math.sin(b); C.cp = Math.cos(a); C.sp = Math.sin(a); C.z = cam.zoom; C.cyy = cam.cy; }
    function P(p) {
      var x = p[0] * C.cy + p[2] * C.sy, z = -p[0] * C.sy + p[2] * C.cy, y = p[1];
      var ry = y * C.cp - z * C.sp, rz = y * C.sp + z * C.cp;
      var f = 1400 / Math.max(80, 1400 - rz * C.z);
      return [340 + x * C.z * f, 239.2 + (C.cyy + ry * C.z - 239.2) * f, C.z * f];
    }
    function along(s, d) {
      var L = s.cum, i = 1;
      while (i < L.length - 1 && L[i] < d) i++;
      var d0 = L[i - 1], d1 = L[i], u = d1 > d0 ? (d - d0) / (d1 - d0) : 0, a = s.pts[i - 1], b = s.pts[i];
      return [a[0] + (b[0] - a[0]) * u, a[1] + (b[1] - a[1]) * u, a[2] + (b[2] - a[2]) * u];
    }
    function line(g, pp, upto) {
      var m = Math.max(1, Math.round((pp.length - 1) * upto));
      g.beginPath(); g.moveTo(pp[0][0], pp[0][1]);
      for (var i = 1; i <= m; i++) g.lineTo(pp[i][0], pp[i][1]);
    }
    function avgS(pp) { var s = 0; for (var i = 0; i < pp.length; i++) s += pp[i][2]; return s / pp.length; }
    // Linie abschnittsweise: unter dem Deckel ausblenden, äussere Kabelenden auslaufen lassen
    function runs(g, pp, msk, upto, A, L, fade, passes) {
      var m = Math.max(1, Math.round((pp.length - 1) * upto)), k0 = fade ? Math.max(1, m - 6) : m, s = avgS(pp);
      var i = 0;
      while (i < m) {
        var a = A * (msk[i] && msk[i + 1] ? 1 - L : 1) * (i < k0 ? 1 : 1 - (i - k0 + 1) / (m - k0 + 1));
        var j = i + 1;
        while (j < m && j < k0 && i < k0) { var a2 = A * (msk[j] && msk[j + 1] ? 1 - L : 1); if (Math.abs(a2 - a) > 0.004) break; j++; }
        if (a > 0.003) {
          g.globalAlpha = a; g.beginPath(); g.moveTo(pp[i][0], pp[i][1]);
          for (var t = i + 1; t <= j; t++) g.lineTo(pp[t][0], pp[t][1]);
          for (var q = 0; q < passes.length; q++) { g.strokeStyle = passes[q][0]; g.lineWidth = passes[q][1] * s; g.stroke(); }
        }
        i = j;
      }
    }
    function cable(g, pts, msk, upto, col, A, L, fade) {
      if (upto <= 0.001 || A <= 0.003) return;
      g.lineCap = 'round'; g.lineJoin = 'round';
      runs(g, pts.map(P), msk, upto, A, L, fade, [['rgba(4,8,16,0.75)', 10], [col, 7.4], ['rgba(255,255,255,0.24)', 1.8]]);
    }
    function lug(g, p, A) {
      var q = P(p), r = 5.2 * q[2];
      g.globalAlpha = A; g.fillStyle = '#C9D0DA'; g.beginPath(); g.arc(q[0], q[1], r, 0, TAU); g.fill();
      g.fillStyle = '#5E697A'; g.beginPath(); g.arc(q[0], q[1], r * 0.45, 0, TAU); g.fill();
    }
    function blips(g, pts, n, speed, t, A, img, rad, rev) {
      var pp = pts.map(P), m = pp.length - 1;
      for (var j = 0; j < n; j++) {
        var u = ((t * speed + j / n) % 1 + 1) % 1, w = rev ? 1 - u : u, f = w * m, i = Math.min(m - 1, Math.floor(f)), r = f - i;
        var x = pp[i][0] + (pp[i + 1][0] - pp[i][0]) * r, y = pp[i][1] + (pp[i + 1][1] - pp[i][1]) * r, s = pp[i][2] * rad;
        g.globalAlpha = A * sm(u / 0.12) * sm((1 - u) / 0.12);
        g.drawImage(img, x - s, y - s, s * 2, s * 2);
      }
    }

    function draw(g, cw, ch, s) {
      var S = spr(), k = cw / 680, G = s.G, t = s.t, A = s.op, i, j, q;
      g.setTransform(k, 0, 0, k, 0, 0);
      g.clearRect(0, 0, 680, 520);
      setCam(s.cam);
      var fs = Math.max(11, (s.minPx || 10) / (s.pxu || 1)), font = s.font || 'Arial, sans-serif';
      var fv = cl(Math.cos(s.cam.yaw * Math.PI / 180) * 3), tv = cl(-Math.sin(s.cam.pitch * Math.PI / 180) * 4);
      var qw = s.qw, Aw = A * fv * tv, Lid = s.lid || 0;
      // Hauptleitungen und Messleitungen; unter dem geschlossenen Deckel verschwinden sie
      if (G.cX.length) cable(g, G.cX, G.mX, qw, '#2A303B', A * tv, Lid);
      var Bon = s.bon || 0, Af = Aw * (1 - Lid), Bin = sm((Bon - 0.78) / 0.22);
      cable(g, G.cB, G.mB, qw, '#232A36', Af, Lid);
      cable(g, G.cM, G.mM, qw, '#232A36', Af, Lid, true);
      cable(g, G.cP, G.mP, qw, '#C8352A', Aw, Lid, true);
      if (qw > 0.98 && Lid < 0.99) { lug(g, G.cB[G.cB.length - 1], Aw * (1 - Lid)); lug(g, G.cP[0], Aw * (1 - Lid)); }
      g.lineCap = 'round'; g.lineJoin = 'round';
      for (i = 0; i < G.wires.length; i++) {
        var wp = G.wires[i].map(P);
        runs(g, wp, G.mW[i], qw, Af, Lid, false, [['rgba(4,8,16,0.7)', 2.6], [i === 0 ? '#3A4252' : i === G.n ? '#E0483A' : '#DDE3EC', 1.3]]);
        if (qw > 0.98 && Lid < 0.99) { var e = wp[wp.length - 1]; g.globalAlpha = Aw * (1 - Lid); g.fillStyle = '#E7ECF3'; g.beginPath(); g.arc(e[0], e[1], 1.9 * e[2], 0, TAU); g.fill(); }
      }
      // BMS auf dem Deckel: Kabeldurchführungen, Messleitungen und B− verschwinden im Deckel, P− läuft über die Vorderkante
      var Ab = A * tv * Bin;
      if (Ab > 0.003) {
        for (i = 0; i < G.slots.length; i++) {
          var sl = G.slots[i], c0 = sl.c, q1 = P([c0[0] - sl.w / 2, c0[1], c0[2] - sl.d / 2]), q2 = P([c0[0] + sl.w / 2, c0[1], c0[2] - sl.d / 2]), q3 = P([c0[0] + sl.w / 2, c0[1], c0[2] + sl.d / 2]), q4 = P([c0[0] - sl.w / 2, c0[1], c0[2] + sl.d / 2]);
          g.globalAlpha = Ab; g.fillStyle = '#05070A'; g.beginPath(); g.moveTo(q1[0], q1[1]); g.lineTo(q2[0], q2[1]); g.lineTo(q3[0], q3[1]); g.lineTo(q4[0], q4[1]); g.closePath(); g.fill();
          g.strokeStyle = 'rgba(255,255,255,0.12)'; g.lineWidth = 0.8; g.stroke();
        }
        for (i = 0; i < G.hw.length; i++) runs(g, G.hw[i].map(P), G.m0(G.hw[i]), 1, Ab, 0, false, [['rgba(4,8,16,0.7)', 2.6], [i === 0 ? '#3A4252' : i === G.n ? '#E0483A' : '#DDE3EC', 1.3]]);
        cable(g, G.cB2, G.m0(G.cB2), 1, '#232A36', Ab, 0);
        cable(g, G.cM2, G.m0(G.cM2), 1, '#232A36', A * Bin * fv, 0, true);
      }
      // Stromfluss
      var pf = s.pf * A;
      if (pf > 0.003) {
        g.globalCompositeOperation = 'lighter';
        for (i = 0; i < G.chain.length; i++) {
          q = G.chain[i];
          if (!q.e) continue;
          var cp = q.pts.map(P), cs = avgS(cp);
          g.globalAlpha = pf * 0.32 * (q.front ? fv * tv : tv);
          line(g, cp, 1); g.strokeStyle = 'rgb(110,150,255)'; g.lineWidth = 3.2 * cs; g.stroke();
        }
        var dots = [];
        for (i = 0; i < G.chain.length; i++) {
          q = G.chain[i];
          var sp = q.e ? 15 : 13, v = q.e ? 44 : 19, dir = q.e ? 1 : -1, aa = pf * (q.front ? fv * tv : tv);
          var off = (((s.fx == null ? t * s.flow : s.fx) * v * dir) % sp + sp) % sp;
          for (var d = off; d < q.len; d += sp) {
            var pr = P(along(q, d));
            dots.push([pr[0], pr[1], pr[2], aa * sm(d / (q.fa ? 40 : 5)) * sm((q.len - d) / (q.fb ? 40 : 5)), q.e]);
          }
        }
        for (i = 0; i < dots.length; i++) { q = dots[i]; var r1 = (q[4] ? 7 : 8.5) * q[2]; g.globalAlpha = q[3] * 0.9; g.drawImage(q[4] ? S.eG : S.liG, q[0] - r1, q[1] - r1, r1 * 2, r1 * 2); }
        g.globalCompositeOperation = 'source-over';
        for (i = 0; i < dots.length; i++) { q = dots[i]; var r2 = (q[4] ? 2.1 : 2.7) * q[2]; g.globalAlpha = q[3]; g.drawImage(q[4] ? S.e : S.li, q[0] - r2, q[1] - r2, r2 * 2, r2 * 2); }
        // Lockerer Verbinder: Wärme am Übergang
        var ho = pf * s.hot;
        if (ho > 0.003) {
          var hp = P(G.hot), hs = hp[2];
          g.globalCompositeOperation = 'lighter';
          var pulse = 0.85 + 0.15 * Math.sin(t * 5);
          g.globalAlpha = ho * pulse; g.drawImage(S.heat, hp[0] - 46 * hs, hp[1] - 30 * hs, 92 * hs, 60 * hs);
          g.globalCompositeOperation = 'source-over';
          g.lineWidth = 1.4 * hs; g.lineCap = 'round';
          for (j = 0; j < 5; j++) {
            var ph = (t * 0.55 + j / 5) % 1, x0 = hp[0] + (j - 2) * 7 * hs, y0 = hp[1] - 6 * hs - ph * 44 * hs;
            g.globalAlpha = ho * 0.55 * Math.sin(Math.PI * ph);
            g.beginPath(); g.moveTo(x0, y0);
            for (var m = 1; m <= 6; m++) g.lineTo(x0 + Math.sin(t * 3 + j * 1.7 + m * 0.9) * 2.6 * hs, y0 - m * 3 * hs);
            g.strokeStyle = 'rgba(255,170,110,1)'; g.stroke();
          }
          g.globalAlpha = ho; pill(g, '10 W Wärme', hp[0], hp[1] - 62 * hs, fs, font, 'rgba(120,28,10,0.92)', '#FFE2D2');
        }
        if (qw > 0.98) {
          var a1 = P(G.cP[Math.round(G.cP.length * 0.72)]), a2 = P(G.cM[Math.round(G.cM.length * 0.62)]);
          g.globalAlpha = pf * fv;
          pill(g, 'P+', a1[0], a1[1], fs, font, 'rgba(160,32,24,0.95)', '#FFFFFF');
          pill(g, 'P−', a2[0], a2[1], fs, font);
        }
      }
      // BMS: messen und ausgleichen
      var pb = s.pb * A;
      if (pb > 0.003) {
        var bal = s.bal, act = bal ? bal.act : 0, Aa = pb * fv * tv, Ab2 = (s.pbal == null ? s.pb : s.pbal) * A * fv * tv;
        g.globalCompositeOperation = 'lighter';
        for (i = 0; i < G.wires.length; i++) blips(g, G.wires[i], 2, 0.42, t + i * 0.13, Aa * 0.8, S.cy, 4.2, true);
        if (bal && act > 0.01 && Ab2 > 0.003) {
          Aa = Ab2;
          var cH = G.cells[bal.hi], cL = G.cells[bal.lo], pu = 0.8 + 0.2 * Math.sin(t * 6);
          var quad = function (c, col, al) {
            var y = G.top - 0.5, a = P([c.x - G.D / 2, y, c.z - G.Wd / 2]), b = P([c.x + G.D / 2, y, c.z - G.Wd / 2]), d = P([c.x + G.D / 2, y, c.z + G.Wd / 2]), e = P([c.x - G.D / 2, y, c.z + G.Wd / 2]);
            g.globalAlpha = al; g.fillStyle = col; g.beginPath(); g.moveTo(a[0], a[1]); g.lineTo(b[0], b[1]); g.lineTo(d[0], d[1]); g.lineTo(e[0], e[1]); g.closePath(); g.fill();
          };
          quad(cH, 'rgb(245,160,40)', Aa * 0.42 * act * pu);
          blips(g, G.wires[bal.hi], 6, 0.9, t, Aa * act, S.liG, 7, true);
          blips(g, G.wires[bal.hi + 1], 6, 0.9, t + 0.08, Aa * act, S.liG, 7, true);
          var bc = P([G.B.x + 18, G.B.y + 6, G.B.fz + 2]), bs = bc[2];
          if (s.mode === 'a') {
            quad(cL, 'rgb(110,160,255)', Aa * 0.42 * act * pu);
            blips(g, G.wires[bal.lo], 6, 0.9, t + 0.3, Aa * act, S.eG, 7, false);
            blips(g, G.wires[bal.lo + 1], 6, 0.9, t + 0.38, Aa * act, S.eG, 7, false);
            g.globalAlpha = Aa * 0.6 * act * pu; g.drawImage(S.wh, bc[0] - 70 * bs, bc[1] - 50 * bs, 140 * bs, 100 * bs);
          } else {
            g.globalAlpha = Aa * 0.75 * act * pu; g.drawImage(S.heat, bc[0] - 74 * bs, bc[1] - 52 * bs, 148 * bs, 104 * bs);
          }
        }
        g.globalCompositeOperation = 'source-over';
      }
      // BMS-Schutz: Temperaturfühler, Wärme, Frost, überwachte Zelle und Sperre
      var zq = (s.pq || 0) * A, zR = s.pr;
      if (zq > 0.003 && zR && G.ts) {
        var zA = zq * tv, zAf = zq * fv * tv, zpu = 0.82 + 0.18 * Math.sin(t * 5.5), zi;
        var ztop = function (c, col, al) {
          var y = G.top - 0.6, p1 = P([c.x - G.D / 2, y, c.z - G.Wd / 2]), p2 = P([c.x + G.D / 2, y, c.z - G.Wd / 2]), p3 = P([c.x + G.D / 2, y, c.z + G.Wd / 2]), p4 = P([c.x - G.D / 2, y, c.z + G.Wd / 2]);
          g.globalAlpha = al; g.fillStyle = col; g.beginPath(); g.moveTo(p1[0], p1[1]); g.lineTo(p2[0], p2[1]); g.lineTo(p3[0], p3[1]); g.lineTo(p4[0], p4[1]); g.closePath(); g.fill();
        };
        if (zR.cold > 0.01) {
          for (zi = 0; zi < G.n; zi++) ztop(G.cells[zi], 'rgb(200,228,255)', zA * 0.34 * zR.cold);
          g.globalCompositeOperation = 'lighter';
          for (zi = 0; zi < G.ts.length; zi++) { var zc = P([G.ts[zi].p[0], G.top - 12, G.ts[zi].p[2]]); g.globalAlpha = zA * 0.8 * zR.cold; g.drawImage(S.cy, zc[0] - 80 * zc[2], zc[1] - 56 * zc[2], 160 * zc[2], 112 * zc[2]); }
          g.globalCompositeOperation = 'source-over';
          g.strokeStyle = '#EEF6FF'; g.lineCap = 'round';
          var zz0 = G.rowZ(0) - G.Wd / 2, zz1 = G.front;
          for (zi = 0; zi < 30; zi++) {
            var zr1 = (zi * 0.6180339 + 0.13) % 1, zr2 = (zi * 0.4142136 + 0.37) % 1, zr3 = (zi * 0.7548777 + 0.61) % 1, zfy = (t * 0.07 + zr1) % 1;
            var zf = P([-G.hx + 2 * G.hx * zr2 + Math.sin(t * 0.8 + zi) * 8, G.top - 160 + 160 * zfy, zz0 + (zz1 - zz0) * zr3]), zs = (2.4 + 1.6 * zr1) * zf[2];
            g.globalAlpha = zA * zR.cold * 0.9 * Math.sin(Math.PI * zfy); g.lineWidth = 0.9 * zf[2];
            g.beginPath();
            for (j = 0; j < 3; j++) { var zan = j * Math.PI / 3 + t * 0.5 + zi; g.moveTo(zf[0] - Math.cos(zan) * zs, zf[1] - Math.sin(zan) * zs); g.lineTo(zf[0] + Math.cos(zan) * zs, zf[1] + Math.sin(zan) * zs); }
            g.stroke();
          }
        }
        var zcw = zR.key === 'ov' ? G.cells[zR.cOv] : zR.key === 'uv' ? G.cells[zR.cUv] : null;
        if (zcw) ztop(zcw, zR.key === 'ov' ? 'rgb(255,96,72)' : 'rgb(245,160,40)', zA * (0.1 + 0.46 * (zR.key === 'ov' ? zR.hiC : zR.loC) * zpu));
        g.globalCompositeOperation = 'lighter';
        if (zR.heat > 0.01) {
          var zh = G.cells[G.ts[0].c], zhq = P([zh.x, G.top - 6, zh.z]);
          g.globalAlpha = zA * zR.heat * zpu; g.drawImage(S.heat, zhq[0] - 130 * zhq[2], zhq[1] - 86 * zhq[2], 260 * zhq[2], 172 * zhq[2]);
        }
        if (zR.mos > 0.01) {
          var zm = P([G.B.x, G.B.y + 0.22 * G.B.h, G.B.fz + 2]);
          g.globalAlpha = zAf * zR.mos * zpu; g.drawImage(S.heat, zm[0] - 96 * zm[2], zm[1] - 64 * zm[2], 192 * zm[2], 128 * zm[2]);
        }
        if (zR.over > 0.01) {
          g.lineCap = 'round'; g.lineJoin = 'round'; g.strokeStyle = 'rgb(255,112,40)';
          [G.cB, G.cM, G.cP].forEach(function (cc) { var zp = cc.map(P); line(g, zp, 1); g.globalAlpha = zAf * zR.over * 0.6 * zpu; g.lineWidth = 14 * avgS(zp); g.stroke(); });
        }
        g.globalCompositeOperation = 'source-over';
        // Wärmeschlieren über der heissen Stelle
        var zhs = zR.heat > 0.3 ? [P([G.cells[G.ts[0].c].x, G.top - 10, G.cells[G.ts[0].c].z]), zR.heat] : zR.mos > 0.3 ? [P([G.B.x, G.B.ty - 4, G.B.fz]), zR.mos] : null;
        if (zhs) {
          var zhp = zhs[0], zk = zhp[2];
          g.lineWidth = 1.4 * zk; g.lineCap = 'round'; g.strokeStyle = 'rgba(255,170,110,1)';
          for (j = 0; j < 5; j++) {
            var zph = (t * 0.55 + j / 5) % 1, zx0 = zhp[0] + (j - 2) * 9 * zk, zy0 = zhp[1] - 6 * zk - zph * 46 * zk;
            g.globalAlpha = zA * zhs[1] * 0.6 * Math.sin(Math.PI * zph);
            g.beginPath(); g.moveTo(zx0, zy0);
            for (var zm2 = 1; zm2 <= 6; zm2++) g.lineTo(zx0 + Math.sin(t * 3 + j * 1.7 + zm2 * 0.9) * 2.6 * zk, zy0 - zm2 * 3 * zk);
            g.stroke();
          }
        }
        // Temperaturfühler T1 und T2 mit Leitung zum BMS
        g.lineCap = 'round'; g.lineJoin = 'round';
        for (zi = 0; zi < G.ts.length; zi++) {
          var zt = G.ts[zi];
          runs(g, zt.wire.map(P), G.m0(zt.wire), 1, zAf, 0, false, [['rgba(4,8,16,0.75)', 2.8], ['#4FC7B5', 1.4]]);
          var ztq = P(zt.p);
          g.globalAlpha = zA; g.fillStyle = '#0E131B'; g.beginPath(); g.arc(ztq[0], ztq[1], 4.6 * ztq[2], 0, TAU); g.fill();
          g.strokeStyle = '#4FC7B5'; g.lineWidth = 1.3 * ztq[2]; g.stroke();
        }
        // Beschriftungen am Speicher
        for (zi = 0; zi < G.ts.length; zi++) {
          var zlp = P([G.ts[zi].p[0], G.top - 30, G.ts[zi].p[2]]), zth = zi ? zR.t2h : zR.t1h;
          g.globalAlpha = zA * (zR.tEm ? 1 : 0.6);
          pill(g, zi ? zR.t2s : zR.t1s, zlp[0], zlp[1], fs, font, zth > 0 ? 'rgba(150,30,16,0.94)' : zth < 0 ? 'rgba(22,72,150,0.94)' : null, zth > 0 ? '#FFE2D2' : zth < 0 ? '#DDEBFF' : null);
        }
        if (zcw && zR.cs) { var zcl = P([zcw.x, G.top - 58, zcw.z]); g.globalAlpha = zA; pill(g, zR.cs, zcl[0], zcl[1], fs, font, zR.ph === 1 ? 'rgba(150,30,16,0.94)' : null, zR.ph === 1 ? '#FFE2D2' : null); }
        if (zR.bs) { var zbl = P([G.B.x + G.B.w / 2 + 40, G.B.y - G.B.h * 0.3, G.B.fz]); g.globalAlpha = zAf; pill(g, zR.bs, zbl[0], zbl[1], fs, font, zR.ph === 1 ? 'rgba(150,30,16,0.94)' : null, zR.ph === 1 ? '#FFE2D2' : null); }
        if (zR.gs) { var zgl = P([G.B.x, G.B.y + G.B.h / 2 + 20, G.B.fz]); g.globalAlpha = zAf * (0.8 + 0.2 * Math.sin(t * 7)); pill(g, zR.gs, zgl[0], zgl[1], fs, font, 'rgba(190,36,24,0.96)', '#FFFFFF'); }
      }
      g.globalAlpha = 1;
    }
    return { draw: draw };
  }
  var PACKFX = null;
  function packFx() { if (!PACKFX) PACKFX = makePackFx(); return PACKFX; }

  /* ------------------------------------------------------------------ Symbole */
  var I = {
    rotate: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12a9 9 0 0 1 15.5-6.2"/><path d="M19 3v4h-4"/><path d="M21 12a9 9 0 0 1-15.5 6.2"/><path d="M5 21v-4h4"/></svg>',
    close: '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    play: function (fill, size) { return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="' + fill + '" aria-hidden="true"><path d="M8 5.5v13l11-6.5z"/></svg>'; },
    pause: '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6" y="5" width="4" height="14" rx="1"/><rect x="14" y="5" width="4" height="14" rx="1"/></svg>',
    minus: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 12h14"/></svg>',
    plusI: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    rotL: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.3-5.6"/><path d="M4 4v4h4"/></svg>',
    rotR: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 12a8 8 0 1 1-2.3-5.6"/><path d="M20 4v4h-4"/></svg>',
    prev: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>',
    sun: '<svg viewBox="0 0 24 24" fill="none" stroke="#F5B526" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="4"/><path d="M12 2.5v2.5M12 19v2.5M2.5 12H5M19 12h2.5M5.3 5.3l1.8 1.8M16.9 16.9l1.8 1.8M5.3 18.7l1.8-1.8M16.9 7.1l1.8-1.8"/></svg>',
    lamp: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 18h6M10 21h4"/><path d="M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2.1h5c0-.9.4-1.6 1-2.1A6 6 0 0 0 12 3z" fill="#FFC870" fill-opacity=".35"/></svg>',
    check: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1E7F4A" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
    warn: '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#A15C00" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 4l9 16H3z"/><path d="M12 10v4M12 17h.01"/></svg>'
  };

  /* ------------------------------------------------------------------ Vorlagen */
  function tplStage() {
    var f = function (name, side, cls, inner) { return '<div class="bkz-face bkz-f-' + side + ' ' + cls + '" data-face="' + name + '">' + (inner || '') + '</div>'; };
    var gl = function (name) { return '<div class="bkz-gl" data-gl="' + name + '"></div>'; };
    var s4 = ['front', 'back', 'right', 'left'];
    var term = function (id, cls) { return '<div class="bkz-part ' + cls + '" data-part="' + id + '">' + f(id + '-top', 'top', 'bkz-term-top', '<span class="bkz-thread"></span>') + s4.map(function (s) { return f(id + '-' + s, s, 'bkz-term-side'); }).join('') + '</div>'; };
    var sub = function (id, cls, sides, inner) { return '<div class="bkz-part" data-part="' + id + '">' + sides.map(function (s) { return f(id + '-' + s, s, cls + ' ' + cls + '-' + (s === 'top' || s === 'bottom' ? 'tb' : 'side'), inner); }).join('') + '</div>'; };
    var lid = '<span class="bkz-seam"></span><span class="bkz-ins bkz-ins-p" data-ref="insP"></span><span class="bkz-ins bkz-ins-m" data-ref="insM"></span><span class="bkz-plus">+</span><span class="bkz-minus">−</span><span class="bkz-vent"></span><span class="bkz-port"></span><span class="bkz-dm"></span>';
    var cover = '<div class="bkz-part" data-part="cover">' + f('cover-top', 'top', 'bkz-cov-top', lid) + s4.map(function (s) { return f('cover-' + s, s, 'bkz-cov-side'); }).join('') + term('tp', 'bkz-term-plus') + term('tm', 'bkz-term-minus') + sub('cpA', 'bkz-cp-al', ['front', 'back', 'right', 'left', 'bottom']) + sub('cpC', 'bkz-cp-cu', ['front', 'back', 'right', 'left', 'bottom']) + '</div>';
    var can = '<div class="bkz-part" data-part="can">' + f('can-front', 'front', 'bkz-can-fb', gl('can-front')) + f('can-back', 'back', 'bkz-can-fb', gl('can-back')) + f('can-right', 'right', 'bkz-can-lr', gl('can-right')) + f('can-left', 'left', 'bkz-can-lr', gl('can-left')) + f('can-bottom', 'bottom', 'bkz-can-bot') + '</div>';
    var sticker = '<div class="bkz-label"><div class="bkz-label-txt"><span class="bkz-label-name" data-ref="mName">MB31</span><span>3.2 V</span><span class="bkz-tnum"><span data-ref="mAh">314</span> Ah</span><span>LiFePO4</span></div><div class="bkz-qr"><svg viewBox="-1 -1 23 23" aria-hidden="true" shape-rendering="crispEdges"><rect x="-1" y="-1" width="23" height="23" fill="#FFFFFF"/><path d="' + QR + '" fill="#0F1D35"/></svg><div class="bkz-scratch" data-ref="scratch"></div><div class="bkz-scan" data-ref="scan"></div></div></div><div class="bkz-dent" data-ref="dent"></div>';
    var print = '<span class="bkz-print"><span data-ref="pr1">MB31</span> · 3.2 V · <span data-ref="pr2">314</span> Ah · LiFePO4</span>';
    var print2 = '<span class="bkz-print"><span data-ref="pr3">MB31</span> · 3.2 V · <span data-ref="pr4">314</span> Ah · LiFePO4</span>';
    var film = '<div class="bkz-part bkz-filmpart" data-part="film">' + f('film-front', 'front', 'bkz-film-fb bkz-film-front', sticker + gl('film-front')) + f('film-back', 'back', 'bkz-film-fb', gl('film-back')) + f('film-right', 'right', 'bkz-film-lr', print + gl('film-right')) + f('film-left', 'left', 'bkz-film-lr', print2 + gl('film-left')) + f('film-bottom', 'bottom', 'bkz-film-bot') + '</div>';
    var tapes = '<span class="bkz-tape" style="top:16%"></span><span class="bkz-tape" style="top:77%"></span>';
    var jel = '<div class="bkz-part" data-part="jel">' + f('jel-front', 'front', 'bkz-jel-fb', tapes) + f('jel-back', 'back', 'bkz-jel-fb', tapes) + f('jel-right', 'right', 'bkz-jel-lr', SPIRAL) + f('jel-left', 'left', 'bkz-jel-lr', SPIRAL) + f('jel-top', 'top', 'bkz-jel-top', '<span class="bkz-jtab bkz-jtab-al"></span><span class="bkz-jtab bkz-jtab-cu"></span>') + f('jel-bottom', 'bottom', 'bkz-jel-bot') + sub('jtA', 'bkz-tb-al', ['front', 'back', 'right', 'left', 'top']) + sub('jtC', 'bkz-tb-cu', ['front', 'back', 'right', 'left', 'top']) + '</div>';
    var pages = '<div class="bkz-page bkz-page-k" data-page="0"><span class="bkz-page-tab"></span></div><div class="bkz-page bkz-page-s" data-page="1"></div><div class="bkz-page bkz-page-a" data-page="2"><span class="bkz-page-tab"></span></div>';

    var X = function (cls, x, y, w, h) { return '<div class="bkz-abs ' + cls + '" style="left:' + U(x) + ';top:' + U(y) + ';width:' + U(w) + ';height:' + U(h) + '"></div>'; };
    var at = function (x, y) { return 'left:' + U(x) + ';top:' + U(y); };
    var atR = function (x, y) { return 'right:' + U(680 - x) + ';top:' + U(y); };
    var lay = function (x, a, b) { return '<div class="bkz-x-lay" style="' + at(x, 462) + '"><b>' + a + '</b><span>' + b + '</span></div>'; };
    var xsec = '<div class="bkz-abs bkz-x" data-ref="x">' +
      '<div class="bkz-abs bkz-x-sch" data-ref="xSch">' +
      X('bkz-x-el', 50, 150, 362, 300) + X('bkz-x-al', 40, 150, 10, 300) + X('bkz-x-ca', 50, 150, 150, 300) + X('bkz-x-se', 222, 150, 18, 300) + X('bkz-x-an', 262, 150, 150, 300) + X('bkz-x-cu', 412, 150, 10, 300) +
      '<svg class="bkz-x-svg" viewBox="0 0 680 520" aria-hidden="true"><path d="M45 150 V96 H417 V150" fill="none" stroke="#9AA8BD" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<div class="bkz-x-dev" data-ref="xDev" style="' + at(231, 96) + ';width:' + U(46) + '"><span data-ref="xSun">' + I.sun + '</span><span data-ref="xLamp" hidden>' + I.lamp + '</span></div>' +
      '<div class="bkz-x-devl" data-ref="xDevL" style="' + at(231, 134) + '">Solarstrom</div>' +
      '<div data-ref="xLays">' + lay(125, 'Kathode', 'LiFePO4') + lay(231, 'Separator', 'Polymer') + lay(337, 'Anode', 'Graphit') + '</div>' +
      '<div data-ref="xIons"></div><div data-ref="xEls"></div>' +
      '</div>' +
      '<svg class="bkz-x-svg" viewBox="0 0 680 520" aria-hidden="true"><g data-ref="xChart"><path d="M468 330 V440 H652" fill="none" stroke="rgba(201,212,232,.45)" stroke-width="1"/><path d="M468 341.8 H652 M468 377.1 H652 M468 432.1 H652" fill="none" stroke="rgba(201,212,232,.18)" stroke-width="1" stroke-dasharray="3 4"/><path d="' + CURVE + '" fill="none" stroke="#8FB6FF" stroke-width="2.2" stroke-linejoin="round"/><circle data-ref="xDot" cx="468" cy="380" r="5" fill="#F5B526" stroke="#0B1736" stroke-width="2"/></g></svg>' +
      '<div data-ref="xRo">' +
      '<div class="bkz-x-ro bkz-x-mode" data-ref="xMode" style="' + at(468, 112) + '">Laden</div>' +
      '<div class="bkz-x-ro bkz-x-small" style="' + at(468, 150) + '">Ladezustand</div>' +
      '<div class="bkz-x-ro bkz-x-big" data-ref="xSoc" style="' + at(468, 168) + '">42 %</div>' +
      '<div class="bkz-x-ro bkz-x-bar" style="' + at(468, 210) + ';width:' + U(184) + ';height:' + U(8) + '"><span data-ref="xBar"></span></div>' +
      '<div class="bkz-x-ro bkz-x-small" style="' + at(468, 230) + '">Zellspannung</div>' +
      '<div class="bkz-x-ro bkz-x-mid" data-ref="xVolt" style="' + at(468, 252) + '">3.28 V</div>' +
      '<div class="bkz-x-ro bkz-x-ct bkz-hide-sm" style="' + at(468, 312) + '">Spannung je Ladezustand</div>' +
      '<div class="bkz-x-ro bkz-x-ax" style="' + atR(652, 328) + '">3.65 V</div>' +
      '<div class="bkz-x-ro bkz-x-ax" style="' + atR(652, 363) + '">3.2 V</div>' +
      '<div class="bkz-x-ro bkz-x-ax" style="' + atR(652, 418) + '">2.5 V</div>' +
      '<div class="bkz-x-ro bkz-x-ax" style="' + at(468, 446) + '">0 %</div>' +
      '<div class="bkz-x-ro bkz-x-ax" style="' + atR(652, 446) + '">100 %</div>' +
      '<div class="bkz-x-ro bkz-x-leg" style="' + at(468, 474) + ';width:' + U(184) + '"><span><i style="width:max(8px,1.4cqw);background:#F5B526"></i>Lithium-Ion</span><span><i style="width:max(6px,1cqw);background:#8FB6FF"></i>Elektron</span></div>' +
      '</div></div>';

    var marks = FILM.scenes.slice(1).map(function (sc) { return '<span class="bkz-fc-mark" style="left:' + (sc.t / FILM.dur * 100).toFixed(2) + '%"></span>'; }).join('');
    var rb = function (act, label, icon, dark) { return '<button type="button" class="bkz-rbtn' + (dark ? ' bkz-rbtn-dark' : '') + '" data-action="' + act + '" aria-label="' + label + '">' + icon + '</button>'; };

    return [
      '<div class="bkz-abs bkz-grid" data-ref="grid"></div>',
      '<div class="bkz-abs bkz-beam" data-ref="beam"></div>',
      '<div class="bkz-abs bkz-glow" data-ref="glow"></div>',
      '<div class="bkz-abs bkz-view">',
      '<div class="bkz-world" data-ref="world">', cover, can, film, jel, pages, '</div>',
      '<div class="bkz-world bkz-pack" data-ref="pack"></div>',
      '</div>',
      xsec,
      '<canvas class="bkz-abs bkz-micro" data-ref="micro" aria-hidden="true"></canvas>',
      '<svg class="bkz-dims" viewBox="0 0 680 520" aria-hidden="true" data-ref="dims"><path data-ref="dimExt" fill="none" stroke="rgba(201,212,232,.7)" stroke-width="1" stroke-dasharray="3 3"/><path data-ref="dimLine" fill="none" stroke="#FFFFFF" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      '<div class="bkz-dimlbl" data-ref="dimW"></div><div class="bkz-dimlbl" data-ref="dimH"></div><div class="bkz-dimlbl" data-ref="dimD"></div>',
      '<div class="bkz-abs bkz-vig" data-ref="vig"></div>',
      '<svg class="bkz-abs bkz-grain" data-ref="grain" width="680" height="520" aria-hidden="true"><filter id="bkzGrain" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" stitchTiles="stitch"/><feColorMatrix type="saturate" values="0"/></filter><rect width="100%" height="100%" filter="url(#bkzGrain)"/></svg>',
      '<svg class="bkz-leaders" viewBox="0 0 680 520" aria-hidden="true" data-ref="leaders"><path data-ref="lpath" fill="none" stroke="#8FB6FF" stroke-width="1.1" stroke-opacity=".85"/><path data-ref="ldots" fill="#F5B526"/></svg>',
      '<div data-ref="labels"></div>',
      '<div class="bkz-abs bkz-flare" data-ref="flare"></div>',
      '<div class="bkz-abs bkz-flareline" data-ref="flareLine"></div>',
      '<div class="bkz-abs bkz-lb bkz-lb-top" data-ref="lbTop"></div>',
      '<div class="bkz-abs bkz-lb bkz-lb-bot" data-ref="lbBot"></div>',
      '<div class="bkz-abs bkz-fade" data-ref="fade"></div>',
      '<div class="bkz-abs bkz-capshade" data-ref="capShade"></div>',
      '<div class="bkz-abs bkz-cap" data-ref="cap" aria-live="polite"><span class="bkz-cap-eb" data-ref="capEb"></span><span class="bkz-cap-t" data-ref="capT"></span><span class="bkz-cap-x" data-ref="capX"></span></div>',
      '<div class="bkz-pill bkz-hint" data-ref="hint"><span data-ref="hintIcon" style="display:flex">' + I.rotate + '</span><span data-ref="hintTxt">Ziehen zum Drehen</span></div>',
      '<div class="bkz-pill bkz-badge" data-ref="badge">EVE MB31, 314 Ah</div>',
      '<button type="button" class="bkz-close" data-action="unfocus" data-ref="close" hidden>' + I.close + 'Übersicht</button>',
      '<button type="button" class="bkz-filmbtn" data-action="film-start" data-ref="filmBtn"><span class="bkz-filmbtn-ic">' + I.play('#0F1D35', 14) + '</span>Film ansehen<span class="bkz-filmbtn-d">' + fmt(FILM.dur) + '</span></button>',
      '<div class="bkz-packread" data-ref="packRead" hidden><span class="bkz-packread-v" data-ref="packVolt"></span><span class="bkz-packread-s"><b data-ref="packKwh"></b><span data-ref="packCfg"></span></span></div>',
      '<div class="bkz-bench" data-ref="bench" hidden></div>',
      '<div class="bkz-bal" data-ref="bal" hidden><div class="bkz-bal-h"><b>Zellspannungen beim Laden · Beispiel</b><span class="bkz-bal-st"><i data-ref="balDot"></i><span data-ref="balSt"></span></span></div><div class="bkz-bal-bars" data-ref="balBars"></div><div class="bkz-bal-ns" data-ref="balNs"></div><div class="bkz-bal-f"><span>Abweichung <b data-ref="balD"></b></span><span>Mittelwert <b data-ref="balAvg"></b></span></div></div>',
      '<div class="bkz-prot" data-ref="prot" hidden><div class="bkz-prot-h"><span class="bkz-prot-st"><i data-ref="protDot"></i><span data-ref="protSt"></span></span><b class="bkz-prot-v" data-ref="protV"></b></div>' +
        '<div class="bkz-prot-c"><div class="bkz-prot-pl"><svg viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true"><rect data-ref="protBand" x="0" y="0" width="0" height="100" fill="rgba(255,90,74,.18)"/><line data-ref="protRel" x1="0" x2="100" y1="50" y2="50" stroke="#5FD08F" stroke-width="1.1" stroke-dasharray="2 3" vector-effect="non-scaling-stroke"/><line data-ref="protLim" x1="0" x2="100" y1="20" y2="20" stroke="#FF6B5A" stroke-width="1.3" stroke-dasharray="5 3" vector-effect="non-scaling-stroke"/><polyline data-ref="protLine" points="" fill="none" stroke="#FFFFFF" stroke-width="1.8" stroke-linejoin="round" stroke-linecap="round" vector-effect="non-scaling-stroke"/></svg>' +
        '<span class="bkz-prot-wt" data-ref="protWt">Wartezeit</span><span class="bkz-prot-dot" data-ref="protPt"></span></div><span class="bkz-prot-lbl bkz-prot-lim" data-ref="protLimL"></span><span class="bkz-prot-lbl bkz-prot-rel" data-ref="protRelL"></span></div>' +
        '<div class="bkz-prot-f"><span class="bkz-prot-sw" data-ref="protSwC"><i></i>Laden <b></b></span><span class="bkz-prot-sw" data-ref="protSwD"><i></i>Entladen <b></b></span><span class="bkz-prot-ex">Beispiel</span></div></div>',
      '<div class="bkz-sysc" data-ref="sysc" hidden><div class="bkz-sysc-h"><span class="bkz-sysc-l"><b data-ref="sysClk"></b><span data-ref="sysSt"></span></span><span class="bkz-sysc-r">Speicher <b data-ref="sysSoc"></b></span></div>' +
        '<div class="bkz-sysc-c"><svg viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true"><polyline data-ref="sysSun" points="" fill="none" stroke="rgba(245,181,38,.7)" stroke-width="1.1" stroke-dasharray="3 3" vector-effect="non-scaling-stroke"/><polygon data-ref="sysPv" points="0,100 100,100" fill="rgba(245,181,38,.26)" stroke="#F5B526" stroke-width="1.2" vector-effect="non-scaling-stroke"/><polyline data-ref="sysUse" points="" fill="none" stroke="#E8EEF8" stroke-width="1.4" stroke-linejoin="round" vector-effect="non-scaling-stroke"/><polyline data-ref="sysSocL" points="" fill="none" stroke="#3DDC84" stroke-width="1.8" stroke-linejoin="round" vector-effect="non-scaling-stroke"/><line data-ref="sysNow" x1="0" x2="0" y1="0" y2="100" stroke="rgba(255,255,255,.8)" stroke-width="1" vector-effect="non-scaling-stroke"/></svg>' +
        '<span class="bkz-sysc-tk" style="left:25%">6 Uhr</span><span class="bkz-sysc-tk" style="left:50%">12 Uhr</span><span class="bkz-sysc-tk" style="left:75%">18 Uhr</span></div>' +
        '<div class="bkz-sysc-f"><span><i style="background:#F5B526"></i>Solarstrom</span><span data-ref="sysSunL" hidden><i style="background:repeating-linear-gradient(90deg,#F5B526 0 3px,transparent 3px 6px)"></i>möglich</span><span><i style="background:#E8EEF8"></i>Verbrauch</span><span><i style="background:#3DDC84"></i>Ladestand</span><span class="bkz-sysc-ex">Beispielanlage</span></div></div>',
      '<div class="bkz-pill bkz-flowleg" data-ref="flowLeg" hidden><span><i class="bkz-fl-e"></i>Elektron</span><span><i class="bkz-fl-li"></i>Lithium-Ion</span></div>',
      '<div class="bkz-cluster">',
      '<div class="bkz-grp bkz-hide-sm" data-ref="zoomGrp">' + rb('zoom-out', 'Herauszoomen', I.minus) + rb('zoom-in', 'Hineinzoomen', I.plusI) + '</div>',
      '<div class="bkz-grp bkz-hide-sm" data-ref="rotGrp">' + rb('rot-l', 'Nach links drehen', I.rotL) + rb('rot-r', 'Nach rechts drehen', I.rotR) + '</div>',
      '<div class="bkz-grp" data-ref="focusNav" hidden>' + rb('focus-prev', 'Vorheriges Bauteil', I.prev, true) + rb('focus-next', 'Nächstes Bauteil', I.next, true) + '</div>',
      '</div>',
      '<div class="bkz-fc" data-ref="fc" hidden>',
      '<button type="button" class="bkz-fc-play" data-action="film-toggle" data-ref="fcPlay" aria-label="Film anhalten"><span data-ref="icoPause" style="display:flex">' + I.pause + '</span><span data-ref="icoPlay" style="display:flex" hidden>' + I.play('currentColor', 16) + '</span></button>',
      '<div class="bkz-fc-track"><span class="bkz-fc-rail"></span><span class="bkz-fc-fill" data-ref="fcFill"></span>' + marks + '<input type="range" class="bkz-fc-seek" data-ref="fcSeek" min="0" max="' + FILM.dur + '" step="0.05" value="0" aria-label="Position im Film"></div>',
      '<span class="bkz-fc-time bkz-hide-sm" data-ref="fcTime">0:00 / ' + fmt(FILM.dur) + '</span>',
      '<button type="button" class="bkz-fc-skip" data-action="film-skip">Überspringen</button>',
      '</div>'
    ].join('');
  }
  function tplTabs() {
    return '<div class="bkz-tabs" role="group" aria-label="Kapitel">' + CHAPTERS.map(function (c, i) {
      return '<button type="button" class="bkz-tab" data-action="ch" data-v="' + i + '" aria-pressed="' + (i === 0) + '"><span class="bkz-tab-n">' + (i + 1) + '</span><span class="bkz-tab-txt"><span class="bkz-tab-t">' + c.t + '</span><span class="bkz-tab-s">' + c.s + '</span></span></button>';
    }).join('') + '</div>';
  }

  /* ------------------------------------------------------------------ Explorer */
  function Explorer(root, opts) {
    this.root = root;
    this.o = opts;
    this.S = { ch: 0, model: 'mb31', layers: true, pack: 8, grade: 'A', focus: null, film: false, paused: false, lv: 0, dims: false, pv: 0, flow: 1, loose: false, bal: 'p', pcell: 'mb31', lid: false, bmsv: 'prot', prot: 'ot', occ: 'd', sea: 's', grid: true, crit: 'use', cview: 'home', csz: 'h10', cev: false, fuse: 'haus', flv: 1, fdays: 2, fev: false, fkit: '' };
    var reduce = false;
    try { reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); } catch (e) {}
    this.a = { yaw: -32, pitch: -16, zoom: 1.22, cy: 262, tx: 0, ty: 0, tz: 0, e: 0, l: 0, oc: 1, ox: 0, op: 0, dof: 0, peel: 0, uz: 1, soc: 0.42, dir: 1, lastDir: 1, last: 0, t: 0, ft: 0, fr: null, drag: null, ptrs: {}, pinch: null, tap: null, userYaw: null, userPitch: null, resumeAt: 0, packP: PEND, lastPack: '8mb31', lastCh: 0, dims: null, scan: 0, capK: 0, capKey: '', reduce: reduce, visible: true, autoplayed: false, sig: '', lv: 0, dm: 0, pf: 0, pb: 0, lo: 0, bt: 0, lid: 0, pq: 1, pt: 0, fx: 0, os: 0, oq: 0, st: 0, ct: 0, ok: 0, kt: 0, kS: 0, kP: 0, of: 0, fq: 0 };
    this.anchors = [];
    this.pkAnchors = [];
    this.build();
    this.bind();
    this.onState();
    this.start();
  }
  var P = Explorer.prototype;

  P.build = function () {
    var root = this.root, self = this;
    root.classList.add('bkz');
    root.innerHTML = tplTabs() + '<div class="bkz-main"><div class="bkz-stagewrap"><div class="bkz-stage" role="group" aria-label="3D-Ansicht einer LiFePO4-Zelle. Zum Drehen ziehen, zum Hineinzoomen eine Nummer wählen.">' + tplStage() + '</div></div><div class="bkz-panel" data-ref="panel"></div></div>';
    var r = this.r = {};
    root.querySelectorAll('[data-ref]').forEach(function (el) { r[el.getAttribute('data-ref')] = el; });
    r.stage = root.querySelector('.bkz-stage');
    this.faces = {}; this.parts = {}; this.gls = {};
    root.querySelectorAll('[data-face]').forEach(function (el) { self.faces[el.getAttribute('data-face')] = el; });
    root.querySelectorAll('[data-part]').forEach(function (el) { self.parts[el.getAttribute('data-part')] = el; });
    root.querySelectorAll('[data-gl]').forEach(function (el) { self.gls[el.getAttribute('data-gl')] = el; });
    this.pageEls = [].slice.call(root.querySelectorAll('[data-page]'));
    this.tabEls = [].slice.call(root.querySelectorAll('.bkz-tab'));
    // Speicher-Zellen und Verbinder
    var F = box(68.4, 194.8, 165.3);
    var pf = function (side, cls, inner) { var q = F[side]; return '<div class="bkz-face bkz-f-' + side + ' ' + cls + '" style="left:' + q.l + ';top:' + q.t + ';width:' + q.w + ';height:' + q.h + ';transform:' + q.tr + '">' + (inner || '') + '</div>'; };
    var html = '', k;
    for (k = 0; k < 16; k++) html += '<div class="bkz-part bkz-pcell" hidden>' + pf('front', 'bkz-pf-nar') + pf('back', 'bkz-pf-nar') + pf('right', 'bkz-pf-wide') + pf('left', 'bkz-pf-wide') + pf('top', 'bkz-pf-top', '<span class="bkz-pterm bkz-pterm-a"></span><span class="bkz-pterm bkz-pterm-b"></span><span class="bkz-pvent"></span>') + '</div>';
    for (k = 0; k < 15; k++) html += '<div class="bkz-bar" hidden><span class="bkz-bolt"></span><span class="bkz-bolt"></span></div>';
    var BB = box(132, 78, 16);
    var bf = function (side, cls, inner) { var q = BB[side]; return '<div class="bkz-face bkz-f-' + side + ' ' + cls + '" style="left:' + q.l + ';top:' + q.t + ';width:' + q.w + ';height:' + q.h + ';transform:' + q.tr + '">' + (inner || '') + '</div>'; };
    html += '<div class="bkz-part bkz-bmsp" hidden>' + bf('front', 'bkz-bms-front', '<span class="bkz-bms-name">BMS</span><span class="bkz-bms-cfg">8S</span><span class="bkz-bms-led"></span><span class="bkz-bms-fets"></span><span class="bkz-bms-pad bkz-bms-pad-b">B−</span><span class="bkz-bms-pad bkz-bms-pad-p">P−</span>') +
      bf('back', 'bkz-bms-side') + bf('right', 'bkz-bms-side') + bf('left', 'bkz-bms-side') + bf('top', 'bkz-bms-top', '<span class="bkz-bms-con"></span>') + bf('bottom', 'bkz-bms-side') + '</div>';
    r.pack.innerHTML = html;
    // Gehäuse unserer Selbstbauspeicher: je Reihe Bodenplatte, Leisten, Endplatten, Gewindestangen, Deckplatten
    var HP = [['slab', ['front', 'back', 'right', 'left', 'bottom']], ['rtf', SIDES], ['rtb', SIDES], ['rbf', SIDES], ['rbb', SIDES], ['endl', SIDES], ['endr', SIDES], ['rod0', ['front', 'back', 'top', 'bottom']], ['rod1', ['front', 'back', 'top', 'bottom']], ['rod2', ['front', 'back', 'top', 'bottom']], ['rod3', ['front', 'back', 'top', 'bottom']], ['cov0', SIDES], ['cov1', SIDES], ['cov2', SIDES], ['cov3', SIDES]];
    var hh = '';
    for (var hi = 0; hi < 2; hi++) {
      hh += '<div class="bkz-hous" data-h="' + hi + '">' + HP.map(function (pp) {
        var kind = pp[0].slice(0, 3);
        return '<div class="bkz-part bkz-hp" data-hp="' + pp[0] + '" hidden>' + pp[1].map(function (sd) {
          var inner = '';
          if ((pp[0] === 'endl' && sd === 'left') || (pp[0] === 'endr' && sd === 'right')) inner = '<span class="bkz-nut"></span><span class="bkz-nut"></span><span class="bkz-nut"></span><span class="bkz-nut"></span>';
          if ((pp[0] === 'rtf' || pp[0] === 'rtb') && sd === 'top') inner = '<span class="bkz-ins"></span><span class="bkz-ins"></span><span class="bkz-ins"></span><span class="bkz-ins"></span><span class="bkz-ins"></span><span class="bkz-ins"></span><span class="bkz-ins"></span><span class="bkz-ins"></span>';
          if (kind === 'cov' && sd === 'top') inner = '<span class="bkz-scr" style="left:6%;top:12%"></span><span class="bkz-scr" style="right:6%;top:12%"></span><span class="bkz-scr" style="left:6%;bottom:12%"></span><span class="bkz-scr" style="right:6%;bottom:12%"></span>';
          return '<div class="bkz-face bkz-f-' + sd + ' bkz-hs bkz-hs-' + (kind === 'rod' ? 'rod' : kind === 'cov' ? 'cov' : 'blk') + '" data-sd="' + sd + '">' + inner + '</div>';
        }).join('') + '</div>';
      }).join('') + '</div>';
    }
    r.pack.insertAdjacentHTML('afterbegin', hh);
    this.hous = [].slice.call(r.pack.querySelectorAll('.bkz-hous')).map(function (hel) {
      var parts = {};
      [].slice.call(hel.querySelectorAll('[data-hp]')).forEach(function (pe) {
        var faces = {};
        [].slice.call(pe.children).forEach(function (f) { faces[f.getAttribute('data-sd')] = f; });
        parts[pe.getAttribute('data-hp')] = { el: pe, faces: faces };
      });
      return { el: hel, parts: parts };
    });
    this.housKey = '';
    var bmEl = r.pack.querySelector('.bkz-bmsp');
    this.bms = { el: bmEl, cfg: bmEl.querySelector('.bkz-bms-cfg'), led: bmEl.querySelector('.bkz-bms-led'), faces: [].slice.call(bmEl.children), n: 0 };
    var bh = '', bn = '';
    for (k = 0; k < 16; k++) { bh += '<div class="bkz-bal-col"><span class="bkz-bal-v"></span><span class="bkz-bal-bar"></span></div>'; bn += '<span>' + (k + 1) + '</span>'; }
    r.balBars.innerHTML = bh; r.balNs.innerHTML = bn;
    this.balCols = [].slice.call(r.balBars.children).map(function (el) { return { el: el, v: el.children[0], bar: el.children[1] }; });
    this.balNums = [].slice.call(r.balNs.children);
    this.pcells = [].slice.call(r.pack.querySelectorAll('.bkz-pcell')).map(function (el) { return { el: el, a: el.querySelector('.bkz-pterm-a'), b: el.querySelector('.bkz-pterm-b'), faces: [].slice.call(el.children) }; });
    this.pcellType = 'mb31';
    this.pbars = [].slice.call(r.pack.querySelectorAll('.bkz-bar')).map(function (el) { return { el: el, b1: el.children[0], b2: el.children[1] }; });
    // Ionen und Elektronen
    var ih = ''; for (k = 0; k < 16; k++) ih += '<span class="bkz-ion"></span>';
    r.xIons.innerHTML = ih;
    var eh = ''; for (k = 0; k < 10; k++) eh += '<span class="bkz-el"></span>';
    r.xEls.innerHTML = eh;
    this.ionEls = [].slice.call(r.xIons.children);
    this.elEls = [].slice.call(r.xEls.children);
    // Beschriftungen
    var lh = '';
    for (k = 0; k < 10; k++) lh += '<div class="bkz-lbl" hidden><button type="button" class="bkz-lbl-btn" data-action="focus" data-v=""><span class="bkz-lbl-num"></span></button><span class="bkz-lbl-dot"></span><span class="bkz-lbl-txt"></span></div>';
    r.labels.innerHTML = lh;
    this.lblEls = [].slice.call(r.labels.children).map(function (el) { return { el: el, btn: el.children[0], num: el.children[0].firstChild, dot: el.children[1], txt: el.children[2] }; });
    // Mikrowelt
    this.mctx = r.micro.getContext ? r.micro.getContext('2d') : null;
    this.mw = 0; this.mh = 0; this.mClear = true;
    try { this.font = (window.getComputedStyle(root).fontFamily || '').replace(/"/g, "'") || 'Arial, sans-serif'; } catch (e) { this.font = 'Arial, sans-serif'; }
  };

  P.sizeMicro = function () {
    var st = this.r.stage, cv = this.r.micro;
    var w = st.clientWidth || 680, h = st.clientHeight || 520, dpr = Math.min(2, window.devicePixelRatio || 1);
    var pw = Math.round(w * dpr), ph = Math.round(h * dpr);
    this.cssW = w;
    if (pw !== this.mw || ph !== this.mh) { this.mw = pw; this.mh = ph; cv.width = pw; cv.height = ph; this.mClear = true; }
  };

  P.bind = function () {
    var self = this, root = this.root, st = this.r.stage;
    this.h = {
      click: function (ev) {
        var t = ev.target && ev.target.closest ? ev.target.closest('[data-action]') : null;
        if (!t || !root.contains(t)) return;
        self.act(t.getAttribute('data-action'), t.getAttribute('data-v'), t);
      },
      input: function (ev) { if (ev.target === self.r.fcSeek) self.seek(+ev.target.value); },
      down: function (ev) { self.pDown(ev); },
      move: function (ev) { self.pMove(ev); },
      up: function (ev) { self.pUp(ev); },
      wheel: function (ev) {
        if (!ev.ctrlKey) return;
        var S = self.S;
        if (S.film || S.ch === 2) return;
        ev.preventDefault();
        self.a.uz = Math.max(0.7, Math.min(3.2, self.a.uz * Math.exp(-ev.deltaY * 0.01)));
      }
    };
    root.addEventListener('click', this.h.click);
    root.addEventListener('input', this.h.input);
    st.addEventListener('pointerdown', this.h.down);
    st.addEventListener('pointermove', this.h.move);
    st.addEventListener('pointerup', this.h.up);
    st.addEventListener('pointercancel', this.h.up);
    st.addEventListener('lostpointercapture', this.h.up);
    st.addEventListener('wheel', this.h.wheel, { passive: false });
    try {
      this.io = new IntersectionObserver(function (ents) {
        var en = ents[ents.length - 1], a = self.a;
        a.visible = !!en.isIntersecting;
        if (en.isIntersecting && en.intersectionRatio >= 0.5 && !a.autoplayed) {
          a.autoplayed = true;
          if (!a.reduce && self.o.autoplay && self.S.ch === 0 && !self.S.film) self.startFilm();
        }
      }, { threshold: [0, 0.5, 0.75] });
      this.io.observe(st);
    } catch (e) { this.a.visible = true; }
    this.h.resize = function () { self.sizeMicro(); };
    try {
      this.ro = new ResizeObserver(this.h.resize);
      this.ro.observe(st);
    } catch (e) { window.addEventListener('resize', this.h.resize); this.roFallback = true; }
    this.sizeMicro();
  };

  P.destroy = function () {
    this.dead = true;
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.io) { try { this.io.disconnect(); } catch (e) {} }
    if (this.ro) { try { this.ro.disconnect(); } catch (e) {} }
    if (this.roFallback) window.removeEventListener('resize', this.h.resize);
    var st = this.r.stage, h = this.h, root = this.root;
    root.removeEventListener('click', h.click);
    root.removeEventListener('input', h.input);
    st.removeEventListener('pointerdown', h.down);
    st.removeEventListener('pointermove', h.move);
    st.removeEventListener('pointerup', h.up);
    st.removeEventListener('pointercancel', h.up);
    st.removeEventListener('lostpointercapture', h.up);
    st.removeEventListener('wheel', h.wheel);
    root.innerHTML = '';
    root.classList.remove('bkz');
  };

  P.set = function (patch) {
    for (var k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) this.S[k] = patch[k];
    this.onState();
  };

  P.act = function (act, v, el) {
    var S = this.S, a = this.a, fromPanel = !!(el && el.closest && el.closest('.bkz-panel'));
    var order = S.ch === 4 ? PARTS4 : PARTS1;
    var idx = Math.max(0, order.indexOf(S.focus));
    switch (act) {
      case 'ch': this.goChapter(+v); break;
      case 'next': this.goChapter((S.ch + 1) % CHAPTERS.length); break;
      case 'model': this.set({ model: v }); break;
      case 'layers': {
        var on = !S.layers, patch = { layers: on };
        if (!on && S.focus && S.focus.indexOf('page') === 0) patch.focus = null;
        this.set(patch);
        break;
      }
      case 'mode': {
        var d = +v;
        if (d > 0 && a.soc > 0.95) a.soc = 0.1;
        if (d < 0 && a.soc < 0.1) a.soc = 0.95;
        a.dir = d; a.lastDir = d;
        this.onState();
        break;
      }
      case 'pack': this.set({ pack: +v, pcell: 'mb31' }); break;
      case 'kit': if (KITS[v]) this.set({ pack: KITS[v].n, pcell: KITS[v].cell }); break;
      case 'lid': this.set({ lid: !S.lid }); break;
      case 'grade': this.set({ grade: v }); break;
      case 'focus': this.pickFocus(v); if (fromPanel) this.revealStage(); break;
      case 'unfocus': a.uz = 1; a.userYaw = null; a.userPitch = null; this.set({ focus: null }); break;
      case 'focus-prev': this.pickFocus(order[(idx - 1 + order.length) % order.length]); break;
      case 'focus-next': this.pickFocus(order[(idx + 1) % order.length]); break;
      case 'zoom-in': if (S.ch === 2) this.set({ lv: Math.min(2, S.lv + 1) }); else a.uz = Math.min(3.2, a.uz * 1.3); break;
      case 'zoom-out': if (S.ch === 2) this.set({ lv: Math.max(0, S.lv - 1) }); else a.uz = Math.max(0.7, a.uz / 1.3); break;
      case 'level': this.set({ lv: +v }); if (fromPanel) this.revealStage(); break;
      case 'dims': this.set({ dims: !S.dims }); break;
      case 'pview': this.set({ pv: +v }); if (fromPanel) this.revealStage(); break;
      case 'flow': this.set({ flow: +v }); break;
      case 'loose': this.set({ loose: !S.loose }); break;
      case 'bal': if (S.bal !== v) a.bt = 0; this.set({ bal: v }); break;
      case 'bmsv': if (S.bmsv !== v) { a.pt = 0; a.bt = 0; } this.set({ bmsv: v }); break;
      case 'prot': if (S.prot !== v) a.pt = 0; this.set({ prot: v }); if (fromPanel) this.revealStage(); break;
      case 'occ': if (S.occ !== v) a.pt = 0; this.set({ occ: v }); break;
      case 'sea': this.set({ sea: v === 'w' ? 'w' : 's' }); break;
      case 'gridm': this.set({ grid: v === '1' }); break;
      case 'crit': if (S.crit !== v) a.ct = 0; this.set({ crit: v }); if (fromPanel) this.revealStage(); break;
      case 'cview': if (S.cview !== v) a.kt = 0; this.set({ cview: v === 'agm' ? 'agm' : 'home' }); if (fromPanel) this.revealStage(); break;
      case 'csz': if (costFx().HOME[v]) this.set({ csz: v }); break;
      case 'cev': this.set({ cev: v === '1' }); break;
      case 'fuse': if (findFx().USE[v] && S.fuse !== v) { a.fq = 0; this.cart = null; this.set({ fuse: v }); } break;
      case 'flv': a.fq = 0; this.cart = null; this.set({ flv: Math.max(0, Math.min(2, +v || 0)) }); break;
      case 'fdays': a.fq = 0; this.cart = null; this.set({ fdays: Math.max(1, Math.min(3, +v || 1)) }); break;
      case 'fev': a.fq = 0; this.cart = null; this.set({ fev: v === '1' }); break;
      case 'fkit': this.cart = null; this.set({ fkit: String(v || '') }); break;
      case 'fcart': this.addToCart(+v); break;
      case 'rot-l': case 'rot-r':
        a.userYaw = (a.userYaw == null ? a.yaw : a.userYaw) + (act === 'rot-l' ? -40 : 40);
        a.userPitch = a.userPitch == null ? a.pitch : a.userPitch;
        a.resumeAt = performance.now() + 4000;
        if (a.reduce) a.yaw = a.userYaw;
        break;
      case 'film-start': this.startFilm(); if (fromPanel) this.revealStage(); break;
      case 'film-toggle': this.set({ paused: !S.paused }); break;
      case 'film-skip': case 'film-end': this.endFilm(true); break;
      case 'scene': {
        var sc = FILM.scenes[+v];
        if (sc) { a.ft = sc.t; if (S.paused) this.set({ paused: false }); }
        if (fromPanel) this.revealStage();
        break;
      }
    }
    a.sig = '';
  };

  P.goChapter = function (i) {
    var a = this.a;
    a.userYaw = null; a.userPitch = null; a.uz = 1;
    this.set({ ch: i, focus: null, film: false, paused: false });
  };

  P.pickFocus = function (key) {
    if (!key) return;
    var a = this.a;
    a.uz = 1; a.userYaw = null; a.userPitch = null;
    var patch = { focus: this.S.focus === key ? null : key };
    if (key.indexOf('page') === 0) patch.layers = true;
    this.set(patch);
  };

  P.revealStage = function () {
    var el = this.r.stage;
    try {
      var r = el.getBoundingClientRect();
      var vh = window.innerHeight || 800;
      if (r.top < 0 || r.bottom > vh) el.scrollIntoView({ behavior: this.a.reduce ? 'auto' : 'smooth', block: 'center' });
    } catch (e) {}
  };

  P.seek = function (t) {
    this.a.ft = Math.max(0, Math.min(FILM.dur - 0.05, t));
  };

  P.startFilm = function () {
    var a = this.a;
    a.ft = 0; a.userYaw = null; a.userPitch = null; a.uz = 1; a.drag = null; a.pinch = null;
    a.dims = dimsOf(this.S.model);
    a.fr = filmFrame(0, a.dims);
    this.set({ film: true, paused: false, focus: null });
  };

  P.endFilm = function (snap) {
    var a = this.a;
    a.userYaw = null; a.userPitch = null; a.fr = null; a.uz = 1;
    if (snap) {
      var T = this.targets({ film: false, focus: null });
      a.zoom = T.zoom; a.cy = T.cy; a.tx = 0; a.ty = 0; a.tz = 0; a.dof = 0; a.peel = 0;
      a.e = T.e; a.l = T.l; a.ox = 0; a.oc = T.scene === 'cell' ? 1 : 0;
      if (T.yaw != null) a.yaw = near(a.yaw, T.yaw);
      a.pitch = T.pitch;
    }
    this.set({ film: false, paused: false });
  };

  P.targets = function (over) {
    var S = this.S, a = this.a;
    var focus = over && 'focus' in over ? over.focus : S.focus;
    var ch = S.ch, mk = S.model, dims = dimsOf(mk), wide = mk === 'mb56', pack = S.pack, T;
    if (ch === 0) T = { scene: 'cell', yaw: null, sway: 0, pitch: -16, zoom: wide ? 1.05 : 1.22, cy: 262, e: 0, l: 0 };
    else if (ch === 1) T = { scene: 'cell', yaw: 34, sway: 6, pitch: -20, zoom: wide ? 0.58 : 0.76, cy: 254, e: 1, l: S.layers ? 1 : 0 };
    else if (ch === 2) T = { scene: 'x', yaw: 34, sway: 0, pitch: -20, zoom: wide ? 0.6 : 0.8, cy: 252, e: 1, l: 0 };
    else if (ch === 3) T = { scene: 'pack', yaw: 24, sway: 5, pitch: S.pv === 2 ? -30 : -36, zoom: KITS[kitKey(S)].zoom * (S.pv === 2 ? (this.cssW < 520 ? 0.84 : 0.9) : 1), cy: S.pv === 2 ? (this.cssW < 520 ? 198 : 222) : 286, e: 0, l: 0 };
    else if (ch >= 5) T = { scene: ch === 5 ? 'sys' : ch === 6 ? 'cmp' : ch === 7 ? 'cost' : 'find', yaw: 24, sway: 0, pitch: -24, zoom: 0.7, cy: 262, e: 0, l: 0 };
    else T = { scene: 'cell', yaw: -16, sway: 3, pitch: -6, zoom: wide ? 0.85 : 1.3, cy: 196, e: 0, l: 0 };
    T.dims = dims; T.target = [0, 0, 0]; T.dof = 0; T.peel = 0;
    var Pr = focus && (ch === 1 || ch === 4) ? PRESETS[focus] : null;
    if (Pr) {
      if (focus.indexOf('page') === 0) { T.l = 1; T.peel = focus === 'page1' ? 1 : focus === 'page2' ? 2 : 0; }
      var g = geo(a.dims || dims, a.e, a.l);
      T.target = partPos(Pr.part, g);
      T.yaw = Pr.yaw; T.sway = 1.5; T.pitch = Pr.pitch; T.zoom = Pr.zoom * zf(dims); T.cy = ch === 4 ? 200 : 250; T.dof = 1;
    }
    return T;
  };

  /* Zeiger: Drehen, Zwei-Finger-Zoom, Tippen pausiert den Film */
  P.pDown = function (ev) {
    var a = this.a, S = this.S;
    try { if (ev.target && ev.target.closest && ev.target.closest('button, input, a')) return; } catch (e) {}
    a.ptrs[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
    try { this.r.stage.setPointerCapture(ev.pointerId); } catch (e) {}
    if (S.film) { a.tap = { x: ev.clientX, y: ev.clientY, t: performance.now() }; return; }
    if (S.ch === 2 || S.ch >= 5) return;
    var ids = Object.keys(a.ptrs);
    if (ids.length >= 2) {
      var p1 = a.ptrs[ids[0]], p2 = a.ptrs[ids[1]];
      a.pinch = { d0: Math.hypot(p1.x - p2.x, p1.y - p2.y) || 1, uz0: a.uz };
      a.drag = null;
    } else {
      a.drag = { x: ev.clientX, y: ev.clientY, yaw: a.yaw, pitch: a.pitch };
      this.r.stage.classList.add('is-drag');
    }
  };
  P.pMove = function (ev) {
    var a = this.a;
    if (!a.ptrs[ev.pointerId]) return;
    a.ptrs[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
    if (a.pinch) {
      var ids = Object.keys(a.ptrs);
      if (ids.length >= 2) {
        var p1 = a.ptrs[ids[0]], p2 = a.ptrs[ids[1]];
        a.uz = Math.max(0.7, Math.min(3.2, a.pinch.uz0 * Math.hypot(p1.x - p2.x, p1.y - p2.y) / a.pinch.d0));
      }
      return;
    }
    if (!a.drag) return;
    a.yaw = a.drag.yaw + (ev.clientX - a.drag.x) * 0.45;
    a.pitch = Math.max(-75, Math.min(10, a.drag.pitch - (ev.clientY - a.drag.y) * 0.3));
    a.userYaw = a.yaw; a.userPitch = a.pitch;
  };
  P.pUp = function (ev) {
    var a = this.a, S = this.S;
    if (!a.ptrs[ev.pointerId]) return;
    delete a.ptrs[ev.pointerId];
    if (S.film && a.tap) {
      var moved = Math.hypot(ev.clientX - a.tap.x, ev.clientY - a.tap.y);
      if (ev.type === 'pointerup' && moved < 8 && performance.now() - a.tap.t < 450) this.set({ paused: !S.paused });
      a.tap = null;
    }
    if (Object.keys(a.ptrs).length < 2) a.pinch = null;
    if (a.drag) { a.drag = null; a.resumeAt = performance.now() + 3000; this.r.stage.classList.remove('is-drag'); }
  };

  /* Ablauf pro Bild */
  P.start = function () {
    var self = this;
    var loop = function (now) {
      if (self.dead) return;
      self.raf = requestAnimationFrame(loop);
      try { self.frame(now); } catch (err) { if (!self.errLogged) { self.errLogged = true; if (window.console) console.error('[BK Zellen-Explorer]', err); } }
    };
    this.raf = requestAnimationFrame(loop);
  };

  P.frame = function (now) {
    var a = this.a, S = this.S;
    var hidden = false;
    try { hidden = !!document.hidden; } catch (e) {}
    if (!a.visible || hidden) { a.last = now; return; }
    var dt = a.last ? Math.min(0.05, (now - a.last) / 1000) : 0.016;
    a.last = now;
    var ch = S.ch, T = this.targets();
    if (ch !== a.lastCh) { a.lastCh = ch; if (ch === 3) a.packP = 0; if (ch === 5) a.st = sysFx().START; if (ch === 6) a.ct = 0; if (ch === 7) a.kt = 0; if (ch === 8) a.fq = 0; }
    if (S.pack + S.pcell !== a.lastPack) { a.lastPack = S.pack + S.pcell; a.packP = 0; }
    var lidT = ch === 3 && S.pv === 0 && S.lid ? 1 : 0;
    if (!a.dims) a.dims = { w: T.dims.w, h: T.dims.h, d: T.dims.d };
    var ease = function (r) { return 1 - Math.exp(-dt * r); };
    var step = function (v, g, sp) { return v < g ? Math.min(g, v + sp) : Math.max(g, v - sp); };
    var ck = (S.focus || '') + '|' + S.grade + '|' + (S.film ? 'f' : '');
    if (ck !== a.capKey) { a.capKey = ck; a.capK = 0; }
    a.capK = Math.min(1, a.capK + dt / 0.8);
    if (S.film) {
      a.dims = { w: T.dims.w, h: T.dims.h, d: T.dims.d };
      if (!S.paused) { a.ft = Math.min(FILM.dur, a.ft + dt); a.t += dt; }
      var fr = filmFrame(a.ft, a.dims);
      a.fr = fr;
      a.yaw = fr.yaw; a.pitch = fr.pitch; a.zoom = fr.zoom; a.cy = fr.cy; a.tx = fr.tx; a.ty = fr.ty; a.tz = fr.tz;
      a.e = fr.e; a.l = fr.l; a.oc = fr.oc; a.ox = 0; a.op = 0; a.dof = fr.dof; a.dir = 1; a.peel = fr.peel; a.dm = 0; a.pf = 0; a.pb = 0; a.os = 0; a.oq = 0; a.ok = 0; a.of = 0;
      a.scan = (a.scan + dt * 0.5) % 1;
      if (a.ft >= FILM.dur) { this.endFilm(false); return; }
      this.draw();
      return;
    }
    a.fr = null;
    if (a.reduce) {
      a.pitch = a.userPitch == null ? T.pitch : a.userPitch;
      a.zoom = T.zoom * a.uz; a.cy = T.cy; a.e = T.e; a.l = T.l;
      a.yaw = a.userYaw == null ? (T.yaw == null ? -32 : T.yaw) : a.userYaw;
      a.tx = T.target[0]; a.ty = T.target[1]; a.tz = T.target[2]; a.dof = T.dof; a.peel = T.peel;
      a.oc = T.scene === 'cell' ? 1 : 0; a.ox = T.scene === 'x' ? 1 : 0; a.op = T.scene === 'pack' ? 1 : 0;
      a.os = T.scene === 'sys' ? 1 : 0; a.oq = T.scene === 'cmp' ? 1 : 0; a.st = sysFx().TC * (S.sea === 'w' ? 12.5 : 12.75) / 24; a.ct = S.crit === 'life' ? 8 : 5;
      var kc0 = this.costT(); a.ok = T.scene === 'cost' ? 1 : 0; a.kt = 99; a.kS = kc0.save; a.kP = kc0.price; a.of = T.scene === 'find' ? 1 : 0; a.fq = 99;
      a.packP = PEND; a.dims = { w: T.dims.w, h: T.dims.h, d: T.dims.d }; a.scan = 0.5; a.capK = 1;
      a.lv = S.lv; a.dm = ch === 0 && S.dims ? 1 : 0;
      a.pf = ch === 3 && S.pv === 1 ? 1 : 0; a.pb = ch === 3 && S.pv === 2 ? 1 : 0; a.lo = S.loose ? 1 : 0; a.bt = 3.2; a.lid = lidT;
      a.pq = S.bmsv === 'prot' ? 1 : 0; a.pt = prot().TC * 0.5;
      var sig = [ch, S.model, S.pack, S.pcell, S.lid, S.layers, S.grade, S.focus, a.dir, S.lv, S.dims, S.pv, S.flow, S.loose, S.bal, S.bmsv, S.prot, S.occ, S.sea, S.grid, S.crit, S.cview, S.csz, S.cev, S.fuse, S.flv, S.fdays, S.fev, this.cssW, a.uz.toFixed(2), a.yaw.toFixed(1), a.pitch.toFixed(1)].join('|');
      if (sig !== a.sig) { a.sig = sig; this.draw(); }
      return;
    }
    a.t += dt;
    if (!a.drag) {
      if (ch === 0 && !S.focus && a.userYaw != null && now > a.resumeAt) { a.userYaw = null; a.userPitch = null; }
      if (a.userYaw != null) a.yaw += (near(a.yaw, a.userYaw) - a.yaw) * ease(6);
      else if (T.yaw == null) a.yaw += 15 * dt;
      else { var ty = near(a.yaw, T.yaw + T.sway * Math.sin(a.t * 0.55)); a.yaw += (ty - a.yaw) * ease(2.4); }
      a.pitch += ((a.userPitch == null ? T.pitch : a.userPitch) - a.pitch) * ease(2.6);
    }
    a.zoom += (T.zoom * a.uz - a.zoom) * ease(2.8);
    a.cy += (T.cy - a.cy) * ease(2.8);
    a.tx += (T.target[0] - a.tx) * ease(3.2);
    a.ty += (T.target[1] - a.ty) * ease(3.2);
    a.tz += (T.target[2] - a.tz) * ease(3.2);
    a.dof += (T.dof - a.dof) * ease(3);
    a.peel += (T.peel - a.peel) * ease(3.5);
    a.e = step(a.e, T.e, dt / 1.3);
    a.l = step(a.l, T.l, dt / 1.1);
    a.oc = step(a.oc, T.scene === 'cell' ? 1 : 0, dt / 0.55);
    a.ox = step(a.ox, T.scene === 'x' ? 1 : 0, dt / 0.55);
    a.op = step(a.op, T.scene === 'pack' ? 1 : 0, dt / 0.55);
    a.os = step(a.os, T.scene === 'sys' ? 1 : 0, dt / 0.55);
    a.oq = step(a.oq, T.scene === 'cmp' ? 1 : 0, dt / 0.55);
    if (ch === 5) a.st += dt;
    if (ch === 6) a.ct += dt;
    a.ok = step(a.ok, T.scene === 'cost' ? 1 : 0, dt / 0.55);
    if (ch === 7) { a.kt += dt; var kc = this.costT(); if (!a.kP) { a.kS = kc.save; a.kP = kc.price; } a.kS += (kc.save - a.kS) * ease(5); a.kP += (kc.price - a.kP) * ease(5); }
    a.of = step(a.of, T.scene === 'find' ? 1 : 0, dt / 0.55);
    if (ch === 8) a.fq += dt;
    if (T.scene === 'pack' && a.op > 0.5) a.packP = step(a.packP, PEND, dt / 1.5);
    a.pf = step(a.pf, ch === 3 && S.pv === 1 ? 1 : 0, dt / 0.45);
    a.pb = step(a.pb, ch === 3 && S.pv === 2 ? 1 : 0, dt / 0.45);
    a.pq = step(a.pq, S.bmsv === 'prot' ? 1 : 0, dt / 0.45);
    a.lo = step(a.lo, S.loose ? 1 : 0, dt / 0.5);
    a.lid = step(a.lid, lidT, dt / 1.2);
    var bmsOn = ch === 3 && S.pv === 2, prOn = bmsOn && S.bmsv === 'prot';
    if (bmsOn && !prOn) a.bt += dt; else a.bt = 0;
    if (prOn) a.pt += dt; else a.pt = 0;
    // Teilchen im Stromfluss und im Schutz-Ablauf: Richtung und Tempo je nach Strom
    var prA = this.prF, fsp = ch === 3 && S.pv === 1 ? S.flow : prOn && prA ? prA.dir * Math.max(0.35, Math.min(2.4, prA.amps / 100)) : 0;
    a.fx += dt * fsp;
    a.dims.w += (T.dims.w - a.dims.w) * ease(5);
    a.dims.h += (T.dims.h - a.dims.h) * ease(5);
    a.dims.d += (T.dims.d - a.dims.d) * ease(5);
    a.lv += (S.lv - a.lv) * ease(2.6);
    if (Math.abs(S.lv - a.lv) < 0.002) a.lv = S.lv;
    a.dm = step(a.dm, ch === 0 && S.dims && !S.focus ? 1 : 0, dt / 0.4);
    if (ch === 2) {
      a.soc += a.dir * dt * 0.075;
      if (a.soc >= 1) { a.soc = 1; a.dir = -1; } else if (a.soc <= 0.06) { a.soc = 0.06; a.dir = 1; }
      if (a.dir !== a.lastDir) { a.lastDir = a.dir; this.renderPanel(); }
    }
    a.scan = (a.scan + dt * 0.5) % 1;
    this.draw();
  };

  P.draw = function () {
    if (this.S.film && !this.a.fr) this.a.fr = filmFrame(this.a.ft, this.a.dims);
    this.drawCell();
    this.drawPack();
    this.drawX();
    this.drawCanvas();
    this.drawBal();
    this.drawProt();
    this.drawSys();
    this.drawDims();
    this.drawLabels();
    this.drawCap();
    this.drawFx();
    this.drawFilmUI();
  };

  P.layoutCell = function (g) {
    var F = this.faces;
    var put = function (prefix, b, sides) {
      sides.forEach(function (s) {
        var el = F[prefix + '-' + s], q = b[s];
        if (!el) return;
        el.style.left = q.l; el.style.top = q.t; el.style.width = q.w; el.style.height = q.h; el.style.transform = q.tr;
      });
    };
    var five = ['top', 'front', 'back', 'right', 'left'];
    put('cover', box(g.W, g.Hc, g.D), five);
    var tb = box(g.tw, g.th, g.tw);
    put('tp', tb, five); put('tm', tb, five);
    this.parts.tp.style.transform = T3(-0.28 * g.W, -g.Hc / 2 - g.th / 2, 0);
    this.parts.tm.style.transform = T3(0.28 * g.W, -g.Hc / 2 - g.th / 2, 0);
    put('can', box(g.W - 0.5, g.Hb - 0.5, g.D - 0.5), ['front', 'back', 'right', 'left', 'bottom']);
    put('film', box(g.W + 1.5, g.Hb, g.D + 1.5), ['front', 'back', 'right', 'left', 'bottom']);
    put('jel', box(g.Wj, g.Hj, g.Dj), SIDES);
    this.pageEls.forEach(function (p) { p.style.left = U(-g.Wp / 2); p.style.top = U(-g.Hp / 2); p.style.width = U(g.Wp); p.style.height = U(g.Hp); });
    var ins = U(g.tw * 1.4), r = this.r;
    r.insP.style.width = ins; r.insP.style.height = ins; r.insM.style.width = ins; r.insM.style.height = ins;
    var tbH = 7, tb5 = box(g.tw * 1.1, tbH, g.Dj * 0.42), tbs = ['front', 'back', 'right', 'left', 'top'];
    put('jtA', tb5, tbs); put('jtC', tb5, tbs);
    this.parts.jtA.style.transform = T3(-0.28 * g.W, -g.Hj / 2 - tbH / 2, 0);
    this.parts.jtC.style.transform = T3(0.28 * g.W, -g.Hj / 2 - tbH / 2, 0);
    var cpH = 2.6, cp5 = box(g.tw * 1.45, cpH, g.D * 0.55), cps = ['front', 'back', 'right', 'left', 'bottom'];
    put('cpA', cp5, cps); put('cpC', cp5, cps);
    this.parts.cpA.style.transform = T3(-0.28 * g.W, g.Hc / 2 + cpH / 2, 0);
    this.parts.cpC.style.transform = T3(0.28 * g.W, g.Hc / 2 + cpH / 2, 0);
  };

  P.blurPart = function (prefix, Pc, w, h, d, cam, dof, sides, alsoTerminals) {
    var F = this.faces;
    for (var i = 0; i < sides.length; i++) {
      var s = sides[i], n = NORM[s];
      var val = dof <= 0.01 ? '0px' : blurAt([Pc[0] + n[0] * w / 2, Pc[1] + n[1] * h / 2, Pc[2] + n[2] * d / 2], cam, dof);
      var el = F[prefix + '-' + s];
      if (el) setV(el, '--bkz-blur', val);
      if (alsoTerminals) { if (F['tp-' + s]) setV(F['tp-' + s], '--bkz-blur', val); if (F['tm-' + s]) setV(F['tm-' + s], '--bkz-blur', val); }
    }
  };

  P.drawCell = function () {
    var S = this.S, a = this.a, r = this.r, Pt = this.parts;
    var ch = S.ch, filmOn = S.film;
    var g = geo(a.dims, a.e, a.l);
    var oc = a.oc, zm = 1 + 0.55 * (1 - oc);
    var cam = { yaw: a.yaw, pitch: a.pitch, zoom: a.zoom * zm, cy: a.cy, tx: a.tx, ty: a.ty, tz: a.tz };
    this.cam = cam;
    var w = r.world;
    setS(w, 'visibility', oc > 0.001 ? 'visible' : 'hidden');
    this.anchors = [];
    if (oc <= 0.001) { setS(r.glow, 'opacity', '0'); return; }
    var z = cam.zoom.toFixed(4);
    setS(w, 'top', U(cam.cy));
    setS(w, 'transform', 'scale3d(' + z + ',' + z + ',' + z + ') rotateX(' + cam.pitch.toFixed(2) + 'deg) rotateY(' + cam.yaw.toFixed(2) + 'deg) translate3d(' + U(-cam.tx) + ',' + U(-cam.ty) + ',' + U(-cam.tz) + ')');
    for (var i = 0; i < 6; i++) setV(w, '--bkz-b-' + SIDES[i], shade(NORM[SIDES[i]], cam.yaw, cam.pitch));
    var dk = g.W.toFixed(2) + '|' + g.H.toFixed(2) + '|' + g.D.toFixed(2);
    if (dk !== this.dk) { this.dk = dk; this.layoutCell(g); }
    var inside = clamp01(a.e / 0.05), dof = a.dof;
    var W = g.W, D = g.D, Hc = g.Hc, Hb = g.Hb;
    var Pc = [0, g.coverY, 0], Pk = [0, g.canY, 0], Pj = [0, g.jy, g.jz];
    setS(Pt.cover, 'transform', T3(0, g.coverY, 0));
    setV(Pt.cover, '--bkz-op', (oc * nearFade(Pc, W, Hc + 2 * g.th, D, cam)).toFixed(3));
    setS(Pt.can, 'transform', T3(0, g.canY, 0));
    setV(Pt.can, '--bkz-op', (oc * inside * nearFade(Pk, W, Hb, D, cam)).toFixed(3));
    var fw = (W + 1.5) * g.fsx, fd = (D + 1.5) * g.fsz;
    var fop = 1 - 0.74 * g.pF;
    if (!filmOn && ch === 1 && S.focus === 'film') fop = Math.max(fop, 0.88 * clamp01(dof));
    setS(Pt.film, 'transform', T3(0, g.canY, 0) + ' scale3d(' + g.fsx.toFixed(3) + ',1.004,' + g.fsz.toFixed(3) + ')');
    setV(Pt.film, '--bkz-op', (oc * fop * nearFade(Pk, fw, Hb, fd, cam)).toFixed(3));
    setS(Pt.jel, 'transform', T3(0, g.jy, g.jz));
    setV(Pt.jel, '--bkz-op', (oc * inside * nearFade(Pj, g.Wj, g.Hj, g.Dj, cam)).toFixed(3));
    this.blurPart('cover', Pc, W, Hc, D, cam, dof, ['top', 'front', 'back', 'right', 'left'], true);
    this.blurPart('can', Pk, W, Hb, D, cam, dof, ['front', 'back', 'right', 'left', 'bottom']);
    this.blurPart('film', Pk, fw, Hb, fd, cam, dof, ['front', 'back', 'right', 'left', 'bottom']);
    this.blurPart('jel', Pj, g.Wj, g.Hj, g.Dj, cam, dof, SIDES);
    var tyy = g.jy - g.Hj / 2 - 3.5, cyy = g.coverY + Hc / 2 + 1.3;
    setV(Pt.jtA, '--bkz-blur', blurAt([-0.28 * W, tyy, g.jz], cam, dof)); setV(Pt.jtC, '--bkz-blur', blurAt([0.28 * W, tyy, g.jz], cam, dof));
    setV(Pt.cpA, '--bkz-blur', blurAt([-0.28 * W, cyy, 0], cam, dof)); setV(Pt.cpC, '--bkz-blur', blurAt([0.28 * W, cyy, 0], cam, dof));
    this.geo = g;
    var peel = a.peel || 0;
    for (var k = 0; k < 3; k++) {
      var q = g.pages[k], el = this.pageEls[k];
      var nf = nearFade(q.center, g.Wp, g.Hp, 4, cam);
      var pf = k === 0 ? 1 - 0.84 * clamp01(peel) : k === 1 ? 1 - 0.84 * clamp01(peel - 1) : 1;
      setS(el, 'transform', T3(q.center[0], q.center[1], q.center[2]) + ' rotateY(' + q.th.toFixed(2) + 'deg)');
      setS(el, 'opacity', (oc * inside * clamp01(q.lp * 4) * nf * pf).toFixed(3));
      setS(el, 'filter', 'brightness(' + shade([Math.sin(q.rad), 0, Math.cos(q.rad)], cam.yaw, cam.pitch) + ') blur(' + blurAt(q.center, cam, dof) + ')');
    }
    var sides4 = ['front', 'back', 'right', 'left'];
    for (var j = 0; j < 4; j++) {
      var s = sides4[j];
      var gc = glint(NORM[s], cam, j < 2 ? 0.85 : 0.8), gf = glint(NORM[s], cam, j < 2 ? 0.5 : 0.45);
      var ec = this.gls['can-' + s], ef = this.gls['film-' + s];
      setS(ec, 'backgroundPosition', gc.x); setS(ec, 'opacity', gc.o);
      setS(ef, 'backgroundPosition', gf.x); setS(ef, 'opacity', gf.o);
    }
    var q4 = ch === 4 && !filmOn;
    setS(r.scan, 'opacity', q4 ? '1' : '0');
    if (q4) setS(r.scan, 'top', (a.scan * 100).toFixed(1) + '%');
    var gpt = proj([0, g.H / 2 + 6, 0], cam);
    var gop = oc * (1 - a.e) * 0.85 * clamp01((2.2 - cam.zoom) / 0.8);
    setS(r.glow, 'opacity', gop.toFixed(3));
    if (gop > 0.001) {
      setS(r.glow, 'left', U(gpt[0])); setS(r.glow, 'top', U(gpt[1]));
      setS(r.glow, 'width', U(W * cam.zoom * 1.3 + 40)); setS(r.glow, 'height', U(26 + D * 0.3));
    }
    if (!filmOn && ch === 1) {
      var an = this.anchors, pK = g.pages[0], pS = g.pages[1], pA = g.pages[2];
      an.push({ key: 'film', num: 1, text: 'Isolierfolie', side: 'l', p: [-fw / 2, g.canY - 0.1 * Hb, 0] });
      an.push({ key: 'cover', num: 2, text: 'Deckel mit Polen', side: 'r', p: [0.28 * W, g.coverY - Hc / 2 - g.th, 0] });
      an.push({ key: 'vent', num: 3, text: 'Sicherheitsventil', side: 'l', p: [0, g.coverY - Hc / 2, 0] });
      an.push({ key: 'tabs', num: 4, text: 'Stromableiter', side: 'r', p: [0.28 * W + g.tw * 0.3, g.jy - g.Hj / 2 - 7, g.jz], op: clamp01((a.e - 0.8) * 5) });
      an.push({ key: 'can', num: 5, text: 'Aluminiumgehäuse', side: 'r', p: [0.3 * W, g.canY + 0.22 * Hb, (D - 0.5) / 2] });
      an.push({ key: 'jelly', num: 6, text: 'Elektrodenwickel', side: 'l', p: [-g.Wj / 2, g.jy - 0.22 * g.Hj, g.jz] });
      an.push({ key: 'page0', num: 7, text: 'Kathode', side: 'r', p: [pK.center[0] + 0.25 * g.Wp, pK.center[1] - 0.22 * g.Hp, pK.center[2]], op: clamp01((pK.lp - 0.55) * 4) });
      an.push({ key: 'page1', num: 8, text: 'Separator', side: 'l', p: [pS.left + 7, pS.center[1] + 0.04 * g.Hp, pS.center[2]], op: clamp01((pS.lp - 0.55) * 4) });
      an.push({ key: 'page2', num: 9, text: 'Anode', side: 'l', p: [pA.left + 7, pA.center[1] + 0.3 * g.Hp, pA.center[2]], op: clamp01((pA.lp - 0.55) * 4) });
    } else if (q4) {
      var B = S.grade === 'B';
      this.anchors.push({ key: 'qr', num: 1, text: B ? 'QR neu gelasert' : 'Original-QR-Code', side: 'r', p: partPos('qr', g) });
      this.anchors.push({ key: 'term', num: 2, text: 'Pole mit Gewinde', side: 'l', p: partPos('termPlus', g) });
      this.anchors.push({ key: 'dent', num: 3, text: B ? 'Delle im Gehäuse' : 'Keine Dellen', side: 'l', p: partPos('dent', g) });
    }
  };

  P.drawPack = function () {
    var S = this.S, a = this.a, w = this.r.pack;
    var op = a.op;
    this.pkAnchors = [];
    setS(w, 'visibility', op > 0.001 ? 'visible' : 'hidden');
    if (op <= 0.001) return;
    var n = S.pack, cell = S.pcell === 'mb56' ? 'mb56' : 'mb31', G = packGeo(n, cell);
    var D = G.D, H = G.H, Wd = G.Wd, stepX = D + 4, bw = 24, tz = G.tz;
    var zm = 0.85 + 0.15 * op;
    var cam = { yaw: a.yaw, pitch: a.pitch, zoom: a.zoom * zm, cy: a.cy, tx: 0, ty: 0, tz: 0 };
    this.pkCam = cam;
    var z = cam.zoom.toFixed(4);
    setS(w, 'top', U(cam.cy));
    setS(w, 'transform', 'scale3d(' + z + ',' + z + ',' + z + ') rotateX(' + cam.pitch.toFixed(2) + 'deg) rotateY(' + cam.yaw.toFixed(2) + 'deg)');
    for (var i = 0; i < 6; i++) setV(w, '--bkz-b-' + SIDES[i], shade(NORM[SIDES[i]], cam.yaw, cam.pitch));
    var topB = parseFloat(shade(NORM.top, cam.yaw, cam.pitch));
    var rows = G.rows, per = G.per, rowZ = G.rowZ;
    var pos = function (k) { return k < per ? { r: 0, c: k } : { r: 1, c: per - 1 - (k - per) }; };
    var cx = function (c) { return (c - (per - 1) / 2) * stepX; };
    var side = function (k) { return rows === 1 || k < per - 1 ? (k % 2 === 0 ? -1 : 1) : ((k - per) % 2 === 0 ? 1 : -1); };
    var Pp = a.packP, lastK = n - 1;
    var minusZ = G.cells[0].m[2], plusZ = G.cells[lastK].p[2];
    // Zellen: Masse je nach Zelltyp
    if (this.pcellType !== cell) {
      this.pcellType = cell;
      var fb = box(D, H, Wd), FS = ['front', 'back', 'right', 'left', 'top'];
      this.pcells.forEach(function (c) { c.faces.forEach(function (f, j) { var q = fb[FS[j]]; f.style.left = q.l; f.style.top = q.t; f.style.width = q.w; f.style.height = q.h; f.style.transform = q.tr; }); });
    }
    for (var k = 0; k < 16; k++) {
      var c = this.pcells[k];
      if (k >= n) { setH(c.el, true); continue; }
      setH(c.el, false);
      var q = pos(k);
      var s0 = 0.5 * k / Math.max(1, n - 1);
      var pk = eio(win(Pp, s0, s0 + 0.42));
      var zc = rowZ(q.r);
      var ra = '#7D8898', rbc = '#7D8898';
      if (k === 0) { if (minusZ < zc) ra = '#0B0F16'; else rbc = '#0B0F16'; }
      if (k === lastK) { if (plusZ < zc) ra = '#E0483A'; else rbc = '#E0483A'; }
      setS(c.el, 'transform', T3(cx(q.c), -150 * (1 - pk), zc));
      setV(c.el, '--bkz-op', (op * pk).toFixed(3));
      setS(c.a, 'backgroundColor', ra);
      setS(c.b, 'backgroundColor', rbc);
    }
    var nb = n - 1, jm = rows === 2 ? per - 2 : nb - 1, mid = { x: 0, z: 0 };
    var ph = (a.t * 5.5) % (nb + 6);
    var v0 = clamp01(1 - a.pf - a.pb), hotA = a.pf * a.lo;
    for (var j = 0; j < 15; j++) {
      var b = this.pbars[j];
      // zwischen den beiden Gehäusen verbindet ein Kabel, kein Kupferverbinder
      if (j >= nb || j === G.cross) { setH(b.el, true); continue; }
      setH(b.el, false);
      var a1 = pos(j), a2 = pos(j + 1);
      var t0 = 0.6 + 0.3 * j / Math.max(1, nb);
      var qv = eio(win(Pp, t0, t0 + 0.12));
      var xA = cx(a1.c), xB = cx(a2.c);
      var xc = (xA + xB) / 2, zc2 = rowZ(a1.r) + side(j) * tz;
      var bx = Math.abs(xB - xA) + bw, bz = bw;
      var ex = (bw / 2) / bx * 100;
      if (j === jm) mid = { x: xc, z: zc2 };
      var gg = Pp >= PEND ? Math.max(0, 1 - Math.abs(ph - j) / 1.3) * v0 : 0;
      var hot = j === G.hotJ ? hotA : 0, glw = Math.max(gg, 0.32 * a.pf);
      setS(b.el, 'left', U(-bx / 2)); setS(b.el, 'top', U(-bz / 2)); setS(b.el, 'width', U(bx)); setS(b.el, 'height', U(bz));
      setS(b.el, 'transform', T3(xc, -H / 2 - 2 - 26 * (1 - qv), zc2) + ' rotateX(90deg)');
      setS(b.el, 'opacity', (op * qv).toFixed(3));
      setS(b.el, 'filter', 'brightness(' + (topB * (1 + 0.75 * gg + 0.18 * a.pf + 0.55 * hot)).toFixed(3) + ')' + (hot > 0.02 ? ' saturate(' + (1 + 0.9 * hot).toFixed(2) + ') hue-rotate(' + (-16 * hot).toFixed(1) + 'deg)' : ''));
      setS(b.el, 'boxShadow', hot > 0.02 ? '0 0 ' + U(26 * hot) + ' rgba(255,92,36,' + (0.9 * hot).toFixed(2) + ')' : glw > 0.02 ? '0 0 ' + U(14 * glw) + ' rgba(245,181,38,' + (0.85 * glw).toFixed(2) + ')' : 'none');
      setS(b.b1, 'left', ex.toFixed(2) + '%'); setS(b.b1, 'top', '50%'); setS(b.b2, 'left', (100 - ex).toFixed(2) + '%'); setS(b.b2, 'top', '50%');
    }
    this.drawHousing(G, Pp, op);
    // BMS an der Front, Messleitungen und Stromfluss zeichnet drawCanvas
    var Bm = G.B, bq = eio(win(Pp, 1.0, 1.22)), bm = this.bms;
    setH(bm.el, false);
    if (bm.n !== n) {
      bm.n = n;
      var bb = box(Bm.w, Bm.h, Bm.d);
      bm.faces.forEach(function (f, i) { var q = bb[SIDES6[i]]; f.style.left = q.l; f.style.top = q.t; f.style.width = q.w; f.style.height = q.h; f.style.transform = q.tr; });
    }
    var tb = eio(clamp01((a.lid - 0.45) / 0.55)), arc = Math.sin(Math.PI * tb), BLp = G.BL;
    var z0 = Bm.z + 70 * (1 - bq);
    var bxp = Bm.x + (BLp.x - Bm.x) * tb, byp = Bm.y + (BLp.y - Bm.y) * tb - 70 * arc, bzp = z0 + (BLp.z - z0) * tb + 40 * arc;
    setS(bm.el, 'transform', T3(bxp, byp, bzp) + ' rotateX(' + (90 * tb).toFixed(2) + 'deg)');
    // liegend zeigt die Beschriftung nach oben: Helligkeit der vier gedrehten Seiten mitführen
    var sv = function (k) { return parseFloat(shade(NORM[k], cam.yaw, cam.pitch)); }, lr = function (p, q) { return (p + (q - p) * tb).toFixed(3); };
    var shF = sv('front'), shT = sv('top'), shB = sv('bottom'), shK = sv('back');
    setV(bm.el, '--bkz-b-front', lr(shF, shT)); setV(bm.el, '--bkz-b-bottom', lr(shB, shF));
    setV(bm.el, '--bkz-b-top', lr(shT, shK)); setV(bm.el, '--bkz-b-back', lr(shK, shB));
    setV(bm.el, '--bkz-op', (op * bq).toFixed(3));
    setT(bm.cfg, n + 'S · LiFePO4');
    this.pkBon = tb;
    var bs = S.ch === 3 ? balState(a.bt, n, S.bal) : null;
    this.balS = bs;
    var pr = this.prF = S.ch === 3 ? prot().frame(S.prot, S.occ, a.pt, n) : null;
    var alarm = !!pr && a.pb * a.pq > 0.5 && pr.ph === 1;
    var blink = !!bs && a.pb * (1 - a.pq) > 0.5 && bs.act > 0.3, lc = alarm ? '#FF5A4A' : blink ? '#F5B526' : '#3DDC84';
    setS(bm.led, 'background', lc);
    setS(bm.led, 'boxShadow', '0 0 1cqw ' + lc);
    setS(bm.led, 'opacity', alarm || blink ? (Math.sin(a.t * (alarm ? 7 : 9)) > 0 ? '1' : '0.35') : (0.78 + 0.22 * Math.sin(a.t * 2)).toFixed(2));
    this.pkG = G;
    this.pkQw = clamp01((Pp - 1.12) / 0.28);
    var inner = 1 - eio(clamp01(a.lid / 0.6));
    this.pkAnchors = [
      { num: 1, text: 'Minuspol B−', side: 'l', p: [cx(pos(0).c), -H / 2 - 2, minusZ], op: inner },
      { num: 2, text: 'Pluspol B+', side: rows === 2 ? 'l' : 'r', p: [cx(pos(lastK).c), -H / 2 - 2, plusZ], op: inner },
      { num: 3, text: 'Zellverbinder', side: 'r', p: [mid.x, -H / 2 - 2, mid.z], op: inner },
      { num: 4, text: 'BMS', side: 'l', p: [G.bmsTag[0] + (G.bmsTagL[0] - G.bmsTag[0]) * tb, G.bmsTag[1] + (G.bmsTagL[1] - G.bmsTag[1]) * tb, G.bmsTag[2] + (G.bmsTagL[2] - G.bmsTag[2]) * tb] },
      { num: 5, text: 'Messleitungen', side: 'r', p: G.wireMid, op: inner },
      { num: 6, text: 'Gewindestange', side: 'l', p: G.rodTag }
    ];
  };

  /* Gehäuse: fährt beim Zusammenbau ein, Deckplatten nur bei geschlossenem Deckel */
  P.drawHousing = function (G, Pp, op) {
    var a = this.a, key = G.n + G.cell;
    if (this.housKey !== key) {
      this.housKey = key;
      for (var h = 0; h < 2; h++) {
        var HO = this.hous[h], gh = G.hous[h];
        setH(HO.el, !gh);
        if (!gh) continue;
        gh.parts.forEach(function (pt) {
          var P2 = HO.parts[pt.id], bb = box(pt.s[0], pt.s[1], pt.s[2]);
          for (var sd in P2.faces) { var f = P2.faces[sd], q = bb[sd]; f.style.left = q.l; f.style.top = q.t; f.style.width = q.w; f.style.height = q.h; f.style.transform = q.tr; }
          if (pt.kind === 'endl' || pt.kind === 'endr') {
            var nf = P2.faces[pt.kind === 'endl' ? 'left' : 'right'], ns = nf.children;
            gh.nuts.forEach(function (nu, i) { ns[i].style.left = ((0.5 + (pt.kind === 'endl' ? nu.z : -nu.z)) * 100).toFixed(2) + '%'; ns[i].style.top = (nu.t * 100).toFixed(2) + '%'; });
          }
          if (pt.id === 'rtf' || pt.id === 'rtb') {
            var ins = P2.faces.top.children;
            for (var i = 0; i < ins.length; i++) { var on = i < gh.inserts.length; ins[i].hidden = !on; if (on) ins[i].style.left = (gh.inserts[i] * 100).toFixed(2) + '%'; }
          }
        });
        for (var c = 0; c < 4; c++) {
          var cv = gh.covers[c], CP = HO.parts['cov' + c];
          CP.on = !!cv;
          if (!cv) { setH(CP.el, true); continue; }
          var cb = box(cv.s[0], cv.s[1], cv.s[2]);
          for (var sd2 in CP.faces) { var f2 = CP.faces[sd2], q2 = cb[sd2]; f2.style.left = q2.l; f2.style.top = q2.t; f2.style.width = q2.w; f2.style.height = q2.h; f2.style.transform = q2.tr; }
        }
      }
    }
    var qb = eio(win(Pp, 0, 0.3)), qr = eio(win(Pp, 0.55, 0.8)), qe = eio(win(Pp, 0.62, 0.86)), qd = eio(win(Pp, 0.82, 1.02)), ql = eio(clamp01(a.lid / 0.6));
    for (var h2 = 0; h2 < G.hous.length; h2++) {
      var HO2 = this.hous[h2], gh2 = G.hous[h2];
      gh2.parts.forEach(function (pt) {
        var P3 = HO2.parts[pt.id], c3 = pt.c, x = c3[0], y = c3[1], z = c3[2], q = 1;
        if (pt.kind === 'base') { q = qb; y += 50 * (1 - q); }
        else if (pt.kind === 'rail') { q = qr; y -= 70 * (1 - q); }
        else if (pt.kind === 'endl') { q = qe; x -= 60 * (1 - q); }
        else if (pt.kind === 'endr') { q = qe; x += 60 * (1 - q); }
        else if (pt.kind === 'rod') { q = qd; x += 240 * (1 - q); }
        setH(P3.el, q <= 0.002);
        setS(P3.el, 'transform', T3(x, y, z));
        setV(P3.el, '--bkz-op', (op * Math.min(1, q * 1.6)).toFixed(3));
      });
      for (var c4 = 0; c4 < 4; c4++) {
        var CP2 = HO2.parts['cov' + c4], cv2 = gh2.covers[c4];
        if (!cv2) continue;
        setH(CP2.el, ql <= 0.002);
        if (ql <= 0.002) continue;
        setS(CP2.el, 'transform', T3(cv2.c[0], cv2.c[1] - 90 * (1 - ql), cv2.c[2]));
        setV(CP2.el, '--bkz-op', (op * Math.min(1, ql * 2)).toFixed(3));
      }
    }
  };

  P.drawX = function () {
    var S = this.S, a = this.a, r = this.r, x = r.x;
    var op = a.ox;
    setS(x, 'visibility', op > 0.001 ? 'visible' : 'hidden');
    if (op <= 0.001) return;
    var soc = a.soc, dir = a.dir, lv = clamp01(a.lv), so = 1 - smooth(lv);
    setS(x, 'opacity', op.toFixed(3));
    setS(x, 'transform', 'scale(' + (1.12 - 0.12 * op).toFixed(3) + ')');
    setS(r.xSch, 'opacity', so.toFixed(3));
    setS(r.xSch, 'visibility', so > 0.002 ? 'visible' : 'hidden');
    setS(r.xSch, 'transform', 'scale(' + (1 + 0.18 * smooth(lv)).toFixed(3) + ')');
    for (var i = 0; i < 16; i++) {
      var rr = i % 4, cC = 3 - Math.floor(i / 4), cA = Math.floor(i / 4);
      var x0 = 72 + cC * 35, y0 = 190 + rr * 68, x2 = 284 + cA * 35, y2 = 196 + rr * 68;
      var p = eio(clamp01((soc - (i + 0.5) / 16) / 0.085 + 0.5));
      var mx = 231, my = (y0 + y2) / 2 + (rr - 1.5) * 8, q = 1 - p;
      var ion = this.ionEls[i];
      setS(ion, 'left', U(q * q * x0 + 2 * q * p * mx + p * p * x2));
      setS(ion, 'top', U(q * q * y0 + 2 * q * p * my + p * p * y2));
    }
    for (var k = 0; k < 10; k++) {
      var u = (k / 10 + a.t * 0.16 * dir) % 1;
      if (u < 0) u += 1;
      var d = u * 480, X, Y;
      if (d < 54) { X = 45; Y = 150 - d; } else if (d < 426) { X = 45 + (d - 54); Y = 96; } else { X = 417; Y = 96 + (d - 426); }
      setS(this.elEls[k], 'left', U(X)); setS(this.elEls[k], 'top', U(Y));
    }
    var charge = dir > 0, col = charge ? '#F5B526' : '#6E9BFF';
    var V = Math.max(2.5, Math.min(3.65, ocv(soc) + (charge ? 0.03 : -0.03)));
    setT(r.xMode, charge ? 'Laden' : 'Entladen');
    setS(r.xMode, 'background', col);
    setT(r.xSoc, Math.round(soc * 100) + ' %');
    setS(r.xBar, 'width', (soc * 100).toFixed(1) + '%');
    setS(r.xBar, 'background', col);
    setT(r.xVolt, V.toFixed(2) + ' V');
    setA(r.xDot, 'cx', (468 + soc * 184).toFixed(1));
    setA(r.xDot, 'cy', (440 - (ocv(soc) - 2.4) / 1.4 * 110).toFixed(1));
    setA(r.xDot, 'fill', col);
    setH(r.xSun, !charge); setH(r.xLamp, charge);
    setT(r.xDevL, charge ? 'Solarstrom' : 'Verbraucher');
    setS(r.xDev, 'boxShadow', '0 0 2.6cqw rgba(255,200,112,' + (charge ? '0' : '0.9') + ')');
  };

  /* Mikroskop und Kristallgitter auf dem Canvas */
  P.microState = function () {
    var S = this.S, a = this.a, st = null, M = micro();
    if (S.film && a.fr) {
      var fr = a.fr;
      if (fr.m1 > 0.003 || fr.m3 > 0.003) {
        st = { t: a.t, dir: 1, soc: fr.s1, socC: fr.sC, socA: fr.sA, film: true, lab: 0,
          m1: fr.m1, a1: [340, 262], k1: 1.65 * fr.z1, c1: [fr.c1x, fr.c1y],
          m3: fr.m3, a3: [340, 262], k3: 1.45 * fr.z3, c3: [fr.c3x, 0], g3: fr.g3, sb: [640, 76] };
      }
    } else if (a.ox > 0.003 && a.lv > 0.002) {
      var lv = a.lv, u1 = smooth(clamp01((lv - 1) / 0.6)), T = M.target;
      var m1 = smooth(clamp01(lv)) * (1 - smooth(clamp01((lv - 1) / 0.55)));
      var z1 = lv <= 1 ? 0.8 + 0.2 * smooth(lv) : 1 + 4.6 * u1;
      var m3 = smooth(clamp01((lv - 1.3) / 0.6)), z3 = 0.55 + 0.45 * smooth(clamp01((lv - 1.2) / 0.8));
      var lab = clamp01(1 - Math.abs(lv - Math.round(lv)) * 3);
      st = { t: a.t, dir: a.dir, soc: a.soc, film: false, win: [32.7, 80.8, 404.7, 410.4], lab: lab, small: this.cssW < 520,
        m1: m1 * a.ox, a1: [236, 286], k1: 0.95 * z1, c1: [T[0] * u1, T[1] * u1],
        m3: m3 * a.ox, a3: [236, 286], k3: 0.95 * z3, c3: [0, 0], sb: [370, 128], sbA: lab };
    }
    return st;
  };

  /* Ein Canvas für Mikroskop, Kristallgitter und die Leitungen am Speicher */
  P.drawCanvas = function () {
    var S = this.S, a = this.a, cv = this.r.micro, g = this.mctx;
    if (!g) return;
    var st = this.microState(), pk = null;
    if (!st && !S.film && S.ch === 3 && a.op > 0.003 && this.pkG && this.pkCam) {
      var pr = this.prF, pqv = a.pb * a.pq;
      pk = { t: a.t, cam: this.pkCam, op: a.op, G: this.pkG, qw: this.pkQw, pf: Math.max(a.pf, pr ? pr.fa * pqv : 0), pb: a.pb, pbal: a.pb * (1 - a.pq), pq: pqv, pr: pr, fx: a.fx, flow: S.flow, hot: a.lo * a.pf, bal: this.balS, mode: S.bal, lid: eio(clamp01(a.lid / 0.6)), bon: this.pkBon || 0 };
    }
    var small = (this.cssW || 680) < 520, pxu = (this.cssW || 680) / 680;
    var sy = !S.film && a.os > 0.003 ? { t: a.t, a: a.os, q: sysFx().frame(S.sea, S.grid, a.st), small: small } : null;
    var cq = !S.film && a.oq > 0.003 ? { t: a.t, a: a.oq, ct: a.ct, crit: S.crit, small: small } : null;
    var kq = !S.film && a.ok > 0.003 ? { t: a.t, a: a.ok, kt: a.kt, view: S.cview, sz: S.csz, ev: S.cev, save: a.kS, price: a.kP, priceT: this.costT().price, p4: this.costAmt('p4'), small: small } : null;
    var fq = !S.film && a.of > 0.003 ? { t: a.t, a: a.of, ft: a.fq, use: S.fuse, lv: S.flv, days: S.fdays, ev: S.fev, small: small } : null;
    if (!st && !pk && !sy && !cq && !kq && !fq) {
      if (!this.mClear) { g.setTransform(1, 0, 0, 1, 0, 0); g.clearRect(0, 0, cv.width, cv.height); this.mClear = true; }
      setS(cv, 'visibility', 'hidden');
      return;
    }
    setS(cv, 'visibility', 'visible');
    var q = st || pk;
    if (q) {
      q.font = this.font; q.pxu = pxu; q.minPx = 10;
      if (st) micro().draw(g, cv.width, cv.height, st); else packFx().draw(g, cv.width, cv.height, pk);
    } else { g.setTransform(1, 0, 0, 1, 0, 0); g.clearRect(0, 0, cv.width, cv.height); }
    if (sy) { sy.font = this.font; sy.pxu = pxu; sy.minPx = small ? 9 : 10; sysFx().draw(g, cv.width, cv.height, sy); }
    if (cq) { cq.font = this.font; cq.pxu = pxu; cq.minPx = small ? 9 : 10; cmpFx().draw(g, cv.width, cv.height, cq); }
    if (kq) { kq.font = this.font; kq.pxu = pxu; kq.minPx = small ? 9 : 10; costFx().draw(g, cv.width, cv.height, kq); }
    if (fq) { fq.font = this.font; fq.pxu = pxu; fq.minPx = small ? 9 : 10; findFx().draw(g, cv.width, cv.height, fq); }
    this.mClear = false;
  };

  /* Zellspannungen im BMS-Modus */
  P.drawBal = function () {
    var S = this.S, a = this.a, r = this.r, st = this.balS;
    var kb = a.pb * (1 - a.pq), on = !S.film && S.ch === 3 && kb > 0.01 && !!st;
    setH(r.bal, !on);
    if (!on) return;
    var n = S.pack, base = 3.36, span = 0.1, act = S.bal === 'a';
    setS(r.bal, 'opacity', kb.toFixed(3));
    for (var k = 0; k < 16; k++) {
      var c = this.balCols[k], nb = this.balNums[k];
      if (k >= n) { setH(c.el, true); setH(nb, true); continue; }
      setH(c.el, false); setH(nb, false);
      var v = st.v[k], h = Math.max(4, clamp01((v - base) / span) * 100);
      var isHi = k === st.hi && st.act > 0.05, isLo = act && k === st.lo && st.act > 0.05;
      setS(c.bar, 'height', h.toFixed(1) + '%');
      setS(c.bar, 'background', isHi ? '#F5B526' : isLo ? '#8FB6FF' : '#3DDC84');
      var showV = n <= 8 || isHi || isLo;
      setH(c.v, !showV);
      if (showV) { setT(c.v, v.toFixed(3)); setS(c.v, 'bottom', (h + 3).toFixed(1) + '%'); setS(c.v, 'color', isHi ? '#FFD36B' : isLo ? '#C4D7FF' : '#C9D4E8'); }
    }
    var busy = st.act > 0.3, col = busy ? '#F5B526' : '#3DDC84';
    setT(r.balSt, busy ? (act ? 'Ausgleich: Zelle ' + (st.hi + 1) + ' → Zelle ' + (st.lo + 1) : 'Ausgleich: Zelle ' + (st.hi + 1) + ' gibt Energie ab') : 'Alle Zellen ausgeglichen');
    setS(r.balDot, 'background', col);
    setS(r.balDot, 'color', col);
    setT(r.balD, st.dmv + ' mV');
    setT(r.balAvg, st.avg.toFixed(3) + ' V');
  };

  /* Schutz-Ablauf: Messwert, Grenzwerte und Schalter für Laden und Entladen */
  P.drawProt = function () {
    var S = this.S, a = this.a, r = this.r, fr = this.prF;
    var k = !S.film && S.ch === 3 && fr ? a.pb * a.pq : 0;
    setH(r.prot, k <= 0.01);
    if (k <= 0.01) return;
    setS(r.prot, 'opacity', k.toFixed(3));
    var C = fr.C, D = C.D, N = C.N, span = D.hi - D.lo;
    var Y = function (v) { return 100 - (v - D.lo) / span * 100; };
    var m = Math.min(N, Math.floor(fr.u * N)), pts = '';
    for (var i = 0; i <= m; i++) pts += (i / N * 100).toFixed(2) + ',' + Y(C.vs[i]).toFixed(2) + ' ';
    pts += (fr.u * 100).toFixed(2) + ',' + Y(fr.v).toFixed(2);
    setA(r.protLine, 'points', pts);
    var bw = fr.u > C.trip ? (Math.min(fr.u, C.rel) - C.trip) * 100 : 0;
    setA(r.protBand, 'x', (C.trip * 100).toFixed(2)); setA(r.protBand, 'width', Math.max(0, bw).toFixed(2));
    // Beschriftungen rechts neben dem Diagramm, bei nahen Linien auseinandergeschoben
    var yl = Y(D.lim), yr = D.oc ? yl : Y(D.rel), sep = (this.cssW || 680) < 520 ? 30 : 19, la = yl, lb = yr;
    if (!D.oc && Math.abs(yr - yl) < sep) { var mid = (yl + yr) / 2, sg = yr >= yl ? 1 : -1; la = mid - sg * sep / 2; lb = mid + sg * sep / 2; }
    var lo2 = Math.min(la, D.oc ? la : lb), hi2 = Math.max(la, D.oc ? la : lb), sh = lo2 < 8 ? 8 - lo2 : hi2 > 92 ? 92 - hi2 : 0;
    setA(r.protLim, 'y1', yl.toFixed(2)); setA(r.protLim, 'y2', yl.toFixed(2));
    setA(r.protRel, 'y1', yr.toFixed(2)); setA(r.protRel, 'y2', yr.toFixed(2));
    setS(r.protRel, 'display', D.oc ? 'none' : '');
    setT(r.protLimL, fr.limL); setS(r.protLimL, 'top', (la + sh).toFixed(2) + '%');
    setH(r.protRelL, D.oc); if (!D.oc) { setT(r.protRelL, fr.relL); setS(r.protRelL, 'top', (lb + sh).toFixed(2) + '%'); }
    setH(r.protWt, !D.oc);
    if (D.oc) { setS(r.protWt, 'left', ((C.trip + C.rel) * 50).toFixed(2) + '%'); setS(r.protWt, 'opacity', Math.max(0, Math.min(1, (fr.u - C.trip - 0.02) / 0.05)).toFixed(3)); }
    setS(r.protPt, 'left', (fr.u * 100).toFixed(2) + '%'); setS(r.protPt, 'top', Y(fr.v).toFixed(2) + '%');
    var col = fr.ph === 1 ? '#FF5A4A' : '#3DDC84';
    setS(r.protDot, 'background', col); setS(r.protDot, 'color', col);
    setT(r.protSt, fr.st); setT(r.protV, fr.rd);
    var sw = function (el, off) { if (el.__off !== off) { el.__off = off; el.classList.toggle('is-off', off); el.lastChild.textContent = off ? 'gesperrt' : 'frei'; } };
    sw(r.protSwC, fr.offC); sw(r.protSwD, fr.offD);
  };

  /* Anlage: Uhrzeit, was gerade passiert, Tagesverlauf */
  P.drawSys = function () {
    var S = this.S, a = this.a, r = this.r, k = !S.film && S.ch === 5 ? a.os : 0;
    setH(r.sysc, k <= 0.01);
    if (k <= 0.01) return;
    setS(r.sysc, 'opacity', k.toFixed(3));
    var SY = sysFx(), q = SY.frame(S.sea, S.grid, a.st), C = SY.chart(S.sea, S.grid), x = (q.u * 100).toFixed(2);
    setA(r.sysPv, 'points', C.pv); setA(r.sysUse, 'points', C.use); setA(r.sysSocL, 'points', C.soc); setA(r.sysSun, 'points', C.sun);
    setA(r.sysNow, 'x1', x); setA(r.sysNow, 'x2', x);
    setT(r.sysClk, q.clock); setT(r.sysSt, q.st); setT(r.sysSoc, q.socTxt); setH(r.sysSunL, !C.sun);
  };

  /* Masslinien um die Zelle */
  P.drawDims = function () {
    var S = this.S, a = this.a, r = this.r, k = a.dm * a.oc;
    var on = k > 0.01 && !S.film && S.ch === 0 && this.geo && this.cam;
    setS(r.dims, 'opacity', on ? k.toFixed(3) : '0');
    setH(r.dimW, !on); setH(r.dimH, !on); setH(r.dimD, !on);
    if (!on) return;
    var g = this.geo, cam = this.cam, M = MODELS[S.model];
    var hx = (g.W + 1.5) / 2, hz = (g.D + 1.5) / 2, y0 = -g.H / 2, y1 = g.H / 2;
    var b = cam.yaw * Math.PI / 180, cb = Math.cos(b), sb = Math.sin(b);
    var fz = cb >= 0 ? hz : -hz, fx = sb <= 0 ? hx : -hx, sx = fx > 0 ? 1 : -1, sz = fz > 0 ? 1 : -1;
    var off = 16, ext = '', line = '';
    var P2 = function (p) { return proj(p, cam); };
    var seg = function (A, B) { return 'M' + A[0].toFixed(1) + ' ' + A[1].toFixed(1) + 'L' + B[0].toFixed(1) + ' ' + B[1].toFixed(1); };
    var arrow = function (A, B) {
      var dx = B[0] - A[0], dy = B[1] - A[1], L = Math.sqrt(dx * dx + dy * dy) || 1, ux = dx / L, uy = dy / L, s = 5;
      var tip = function (P, dir) { return 'M' + (P[0] + (dir * ux * s) - uy * s * 0.55).toFixed(1) + ' ' + (P[1] + (dir * uy * s) + ux * s * 0.55).toFixed(1) + 'L' + P[0].toFixed(1) + ' ' + P[1].toFixed(1) + 'L' + (P[0] + (dir * ux * s) + uy * s * 0.55).toFixed(1) + ' ' + (P[1] + (dir * uy * s) - ux * s * 0.55).toFixed(1); };
      return seg(A, B) + tip(A, 1) + tip(B, -1);
    };
    var lbl = function (el, A, B, txt, alpha) {
      setT(el, txt);
      setS(el, 'left', U((A[0] + B[0]) / 2)); setS(el, 'top', U((A[1] + B[1]) / 2));
      setS(el, 'opacity', alpha.toFixed(3));
    };
    var aW = clamp01((Math.abs(cb) - 0.18) / 0.25), aD = clamp01((Math.abs(sb) - 0.18) / 0.25), aH = Math.min(aW, aD);
    // Breite: untere Kante der sichtbaren Längsseite
    var w0 = [-hx, y1, fz], w1 = [hx, y1, fz], wo0 = [-hx, y1 + off, fz], wo1 = [hx, y1 + off, fz];
    // Tiefe: untere Kante der sichtbaren Schmalseite
    var d0 = [fx, y1, -hz], d1 = [fx, y1, hz], do0 = [fx, y1 + off, -hz], do1 = [fx, y1 + off, hz];
    // Höhe: vordere senkrechte Kante, nach aussen versetzt
    var h0 = [fx + sx * off * 0.8, y0, fz + sz * off * 0.8], h1 = [fx + sx * off * 0.8, y1, fz + sz * off * 0.8];
    var W0 = P2(wo0), W1 = P2(wo1), D0 = P2(do0), D1 = P2(do1), H0 = P2(h0), H1 = P2(h1);
    if (aW > 0.02) { ext += seg(P2(w0), P2([-hx, y1 + off + 5, fz])) + seg(P2(w1), P2([hx, y1 + off + 5, fz])); line += arrow(W0, W1); }
    if (aD > 0.02) { ext += seg(P2(d0), P2([fx, y1 + off + 5, -hz])) + seg(P2(d1), P2([fx, y1 + off + 5, hz])); line += arrow(D0, D1); }
    if (aH > 0.02) { ext += seg(P2([fx, y0, fz]), P2([fx + sx * (off * 0.8 + 4), y0, fz + sz * (off * 0.8 + 4)])) + seg(P2([fx, y1, fz]), P2([fx + sx * (off * 0.8 + 4), y1, fz + sz * (off * 0.8 + 4)])); line += arrow(H0, H1); }
    setA(r.dimExt, 'd', ext); setA(r.dimLine, 'd', line);
    lbl(r.dimW, W0, W1, M.w + ' mm', aW);
    lbl(r.dimD, D0, D1, M.t + ' mm', aD);
    lbl(r.dimH, H0, H1, M.h + ' mm', aH);
  };

  P.drawLabels = function () {
    var S = this.S, a = this.a, r = this.r, ch = S.ch;
    var defs = [], cam = null, show = 0, maxY = 440;
    if (!S.film) {
      if (ch === 1 || ch === 4) { defs = this.anchors; cam = this.cam; show = a.oc * (ch === 1 ? clamp01((a.e - 0.7) / 0.3) : 1); if (ch === 4) maxY = 318; }
      else if (ch === 3) { defs = this.pkAnchors; cam = this.pkCam; show = a.op * clamp01((a.packP - (PEND - 0.06)) * 14) * (1 - a.pf) * (1 - a.pb); }
      if (S.focus && (ch === 1 || ch === 4)) show *= clamp01(1 - a.dof * 1.5);
    }
    var items = [];
    if (cam && show > 0.001) {
      defs.forEach(function (d) {
        var pr = proj(d.p, cam);
        var on = pr[0] > 8 && pr[0] < 672 && pr[1] > 8 && pr[1] < 512 ? 1 : 0;
        var wgt = (d.op == null ? 1 : d.op) * on;
        if (wgt > 0.01) items.push({ key: d.key, num: d.num, text: d.text, side: d.side, ax: pr[0], ay: pr[1], w: wgt });
      });
      var place = function (sd, bx) {
        var L = items.filter(function (q) { return q.side === sd; }).sort(function (m, o) { return m.ay - o.ay; });
        var y = 62;
        L.forEach(function (q) { q.ly = Math.max(q.ay, y); y = q.ly + 34; });
        var lim = maxY;
        for (var i = L.length - 1; i >= 0; i--) { if (L[i].ly > lim) L[i].ly = lim; lim = L[i].ly - 34; }
        L.forEach(function (q) { q.bx = bx; });
      };
      place('l', 30); place('r', 650);
    }
    var path = '', dots = '';
    for (var i = 0; i < this.lblEls.length; i++) {
      var L = this.lblEls[i], q = items[i];
      if (!q) { setH(L.el, true); continue; }
      setH(L.el, false);
      if (q.w > 0.3) {
        path += 'M' + q.bx.toFixed(1) + ' ' + q.ly.toFixed(1) + 'L' + q.ax.toFixed(1) + ' ' + q.ay.toFixed(1);
        dots += 'M' + (q.ax - 3).toFixed(1) + ' ' + q.ay.toFixed(1) + 'a3 3 0 1 0 6 0a3 3 0 1 0 -6 0';
      }
      var left = q.side === 'l';
      setS(L.el, 'left', left ? U(q.bx - 12) : 'auto');
      setS(L.el, 'right', left ? 'auto' : U(680 - q.bx - 12));
      setS(L.el, 'top', U(q.ly));
      setS(L.el, 'flexDirection', left ? 'row' : 'row-reverse');
      setS(L.el, 'opacity', (q.w * show).toFixed(3));
      var clickable = ch !== 3;
      setH(L.btn, !clickable); setH(L.dot, clickable);
      setT(clickable ? L.num : L.dot, String(q.num));
      setT(L.txt, q.text);
      if (clickable) { setA(L.btn, 'data-v', q.key); setA(L.btn, 'aria-label', 'Hineinzoomen: ' + q.text); }
      var compact = ch === 1;
      if (L.compact !== compact) { L.compact = compact; L.el.classList.toggle('bkz-compact', compact); }
    }
    setA(r.lpath, 'd', path);
    setA(r.ldots, 'd', dots);
    setS(r.leaders, 'opacity', show.toFixed(3));
  };

  P.drawCap = function () {
    var S = this.S, a = this.a, r = this.r, ch = S.ch;
    var M = MODELS[S.model], gi = S.grade === 'A' ? 0 : 1;
    var c = null, k = 0, prog = 1;
    if (S.film) {
      for (var i = 0; i < FILM.caps.length; i++) {
        var cc = FILM.caps[i];
        if (a.ft >= cc.t0 && a.ft <= cc.t1) {
          var kin = smooth((a.ft - cc.t0) / 0.6), kout = smooth((cc.t1 - a.ft) / 0.45);
          k = Math.min(kin, kout); prog = kin;
          c = { pos: cc.pos || 'lower', eyebrow: cc.eyebrow === 'model' ? 'EVE ' + M.name + ' · ' + M.ah + ' Ah · 3.2 V' : cc.eyebrow, title: cc.title, text: '' };
          break;
        }
      }
    } else if (S.focus && (ch === 1 || ch === 4)) {
      var Pr = PRESETS[S.focus];
      if (Pr) {
        k = smooth((a.capK - 0.15) / 0.85) * clamp01(a.dof * 1.4); prog = k;
        c = { pos: 'lower', eyebrow: Pr.n + ' · ' + Pr.name, title: Array.isArray(Pr.title) ? Pr.title[gi] : Pr.title, text: Array.isArray(Pr.text) ? Pr.text[gi] : Pr.text };
      }
    }
    if (!c || k <= 0.001) { setS(r.cap, 'opacity', '0'); setS(r.capShade, 'opacity', '0'); return; }
    var center = c.pos === 'center', low = c.pos === 'low', wide = center || low;
    setS(r.cap, 'left', wide ? '8%' : '5.5%');
    setS(r.cap, 'right', wide ? '8%' : 'auto');
    setS(r.cap, 'bottom', center ? '42%' : low ? '15%' : (S.film ? '16%' : '6%'));
    setS(r.cap, 'alignItems', wide ? 'center' : 'flex-start');
    setS(r.cap, 'textAlign', wide ? 'center' : 'left');
    setS(r.cap, 'opacity', k.toFixed(3));
    setS(r.cap, 'transform', 'translateY(' + U((1 - prog) * 14) + ')');
    setS(r.cap, 'filter', 'blur(' + U((1 - prog) * 4) + ')');
    setT(r.capEb, c.eyebrow);
    setT(r.capT, c.title);
    setS(r.capT, 'fontSize', center ? 'max(20px,5cqw)' : low ? 'max(18px,4.2cqw)' : 'max(16px,3.3cqw)');
    setS(r.capT, 'maxWidth', wide ? '100%' : '64cqw');
    setT(r.capX, c.text || '');
    setH(r.capX, !c.text);
    setS(r.capShade, 'opacity', (center ? 0 : k * 0.95).toFixed(3));
  };

  P.drawFx = function () {
    var S = this.S, a = this.a, r = this.r;
    var fr = S.film ? a.fr : null;
    var k = fr ? fr.lb : 0;
    setS(r.grid, 'opacity', (1 - 0.8 * k).toFixed(3));
    setS(r.beam, 'opacity', (0.45 + 0.55 * k).toFixed(3));
    setS(r.vig, 'opacity', (0.55 + 0.45 * k).toFixed(3));
    setS(r.lbTop, 'height', (10 * k).toFixed(2) + '%');
    setS(r.lbBot, 'height', (10 * k).toFixed(2) + '%');
    setS(r.fade, 'opacity', fr ? fr.fade.toFixed(3) : '0');
    setS(r.grain, 'opacity', (0.16 * k).toFixed(3));
    setS(r.grain, 'visibility', k > 0.01 ? 'visible' : 'hidden');
    if (k > 0.01) setS(r.grain, 'transform', 'translate(' + U((Math.random() - 0.5) * 40) + ',' + U((Math.random() - 0.5) * 40) + ')');
    var fp = fr ? clamp01((a.ft - 1.2) / 3.0) : 0;
    var flO = fr ? 0.85 * Math.sin(Math.PI * fp) : 0;
    var flX = (-10 + 120 * fp).toFixed(1) + '%';
    setS(r.flare, 'opacity', flO.toFixed(3));
    setS(r.flareLine, 'opacity', flO.toFixed(3));
    if (flO > 0.001) {
      setS(r.flare, 'left', flX);
      setS(r.flareLine, 'background', 'linear-gradient(90deg, rgba(150,190,255,0), rgba(205,225,255,.95) ' + flX + ', rgba(150,190,255,0))');
    }
  };

  P.drawFilmUI = function () {
    var S = this.S, a = this.a, r = this.r;
    if (!S.film) return;
    var t = a.ft;
    setS(r.fcFill, 'width', (t / FILM.dur * 100).toFixed(2) + '%');
    if (document.activeElement !== r.fcSeek) { var v = t.toFixed(2); if (r.fcSeek.__v !== v) { r.fcSeek.__v = v; r.fcSeek.value = v; } }
    setT(r.fcTime, fmt(t) + ' / ' + fmt(FILM.dur));
    var sc = this.sceneEls;
    if (!sc) return;
    for (var i = 0; i < sc.length; i++) {
      var t0 = FILM.scenes[i].t, t1 = i + 1 < FILM.scenes.length ? FILM.scenes[i + 1].t : FILM.dur + 1;
      var cur = t >= t0 && t < t1;
      var prog = cur ? clamp01((t - t0) / (Math.min(t1, FILM.dur) - t0)) : (t >= t1 ? 1 : 0);
      var el = sc[i];
      if (el.__cur !== cur) { el.__cur = cur; el.btn.classList.toggle('is-cur', cur); if (cur) el.btn.setAttribute('aria-current', 'step'); else el.btn.removeAttribute('aria-current'); }
      setS(el.bar, 'width', (prog * 100).toFixed(1) + '%');
    }
  };

  /* Zustand: Kapitel, Bedienelemente, Seitenleiste */
  P.onState = function () {
    var S = this.S, a = this.a, r = this.r, ch = S.ch, filmOn = S.film;
    var focusOn = !filmOn && !!S.focus && (ch === 1 || ch === 4);
    var M = MODELS[S.model];
    this.tabEls.forEach(function (b, i) { b.setAttribute('aria-pressed', String(i === ch)); });
    setT(r.mName, M.name);
    setT(r.mAh, String(M.ah));
    setT(r.pr1, M.name); setT(r.pr2, String(M.ah)); setT(r.pr3, M.name); setT(r.pr4, String(M.ah));
    var qB = ch === 4 && !filmOn && S.grade === 'B';
    setS(r.scratch, 'opacity', qB ? '1' : '0');
    setS(r.dent, 'opacity', qB ? '1' : '0');
    setH(r.hint, filmOn || ch >= 5);
    setT(r.hintTxt, ch === 2 ? ['Querschnitt, schematisch', 'Mikroskop-Ansicht, vereinfacht', 'Kristallgitter, vereinfacht'][S.lv] : 'Ziehen zum Drehen');
    setH(r.hintIcon, ch === 2);
    setH(r.badge, filmOn || focusOn || ch === 2 || ch >= 5 || (ch === 3 && S.pv > 0));
    setH(r.flowLeg, !(!filmOn && ch === 3 && S.pv === 1));
    setT(r.badge, ch === 3 ? KITS[kitKey(S)].name : 'EVE ' + M.name + ', ' + M.ah + ' Ah');
    setH(r.close, !focusOn);
    setH(r.filmBtn, !(!filmOn && !focusOn && !a.reduce && (ch === 1 || (ch === 0 && !S.dims))));
    setH(r.zoomGrp, !(!filmOn && ch < 5 && !(ch === 4 && !focusOn)));
    setH(r.rotGrp, !(!filmOn && !focusOn && (ch === 0 || ch === 1 || ch === 3)));
    setH(r.focusNav, !focusOn);
    setH(r.packRead, !(!filmOn && ch === 3 && S.pv !== 2));
    if (S.pv === 1) {
      setT(r.packVolt, '100 A');
      setT(r.packKwh, S.flow > 0 ? 'Laden' : 'Entladen');
      setT(r.packCfg, (S.pack * 3.2).toFixed(1) + ' V · ' + (S.pack * 0.32).toFixed(1) + ' kW');
    } else {
      setT(r.packVolt, (S.pack * 3.2).toFixed(1) + ' V');
      setT(r.packKwh, (S.pack * 3.2 * PCELL[S.pcell === 'mb56' ? 'mb56' : 'mb31'].ah / 1000).toFixed(1) + ' kWh');
      setT(r.packCfg, S.pack + ' × ' + PCELL[S.pcell === 'mb56' ? 'mb56' : 'mb31'].name + ' in Serie (' + S.pack + 'S)');
    }
    var benchOn = !filmOn && ch === 4 && !focusOn;
    setH(r.bench, !benchOn);
    if (benchOn) r.bench.innerHTML = this.benchHTML();
    setH(r.fc, !filmOn);
    setH(r.icoPause, !!S.paused);
    setH(r.icoPlay, !S.paused);
    r.fcPlay.setAttribute('aria-label', S.paused ? 'Film fortsetzen' : 'Film anhalten');
    r.stage.classList.toggle('is-film', filmOn);
    r.stage.classList.toggle('is-x', !filmOn && ch === 2);
    r.stage.classList.toggle('is-flat', !filmOn && ch >= 5);
    r.stage.classList.toggle('is-ctop', !filmOn && ch === 3 && S.pv === 2);
    this.renderPanel();
    this.a.sig = '';
  };

  P.benchHTML = function () {
    var M = MODELS[this.S.model], A = this.S.grade === 'A';
    var capF = A ? [1.022, 1.026, 1.021, 1.029] : [0.949, 0.984, 0.927, 0.971];
    var lo = 0.88, hi = 1.05, ir = A ? M.ir : M.irB, irTop = Math.max.apply(null, M.irB) * 1.18;
    var groups = [
      { title: 'Kapazität', unit: 'Ah', ref: (1 - lo) / (hi - lo) * 100, note: 'Linie: Nennwert ' + M.ah + ' Ah', bars: capF.map(function (f) { return { h: (f - lo) / (hi - lo) * 100, c: f >= 1 ? '#3DDC84' : '#F5B526', v: String(Math.round(M.ah * f)) }; }) },
      { title: 'Innenwiderstand', unit: 'mΩ', ref: M.irMax / irTop * 100, note: 'Linie: Richtwert laut Datenblatt', bars: ir.map(function (x) { return { h: x / irTop * 100, c: x <= M.irMax ? '#3DDC84' : '#F5B526', v: x.toFixed(2) }; }) }
    ];
    return '<div class="bkz-bench-h"><b>Prüfstand: vier Zellen im Vergleich</b><span>Beispielwerte</span></div><div class="bkz-bench-gs">' + groups.map(function (g) {
      return '<div class="bkz-bench-g"><div class="bkz-bench-gh"><b>' + g.title + '</b><span>' + g.unit + '</span></div><div class="bkz-bench-bars"><span class="bkz-bench-ref" style="bottom:' + g.ref.toFixed(1) + '%"></span>' +
        g.bars.map(function (b) { return '<span class="bkz-bench-bar" style="height:' + b.h.toFixed(1) + '%;background:' + b.c + '"></span>'; }).join('') +
        '</div><div class="bkz-bench-vals">' + g.bars.map(function (b) { return '<span>' + b.v + '</span>'; }).join('') + '</div><div class="bkz-bench-note bkz-hide-sm">' + g.note + '</div></div>';
    }).join('') + '</div>';
  };

  P.renderPanel = function () {
    var panel = this.r.panel, fa = document.activeElement, sig = null;
    if (fa && panel.contains(fa) && fa.getAttribute) sig = [fa.getAttribute('data-action'), fa.getAttribute('data-v')];
    panel.innerHTML = this.panelHTML();
    if (sig && sig[0]) {
      var sel = '[data-action="' + sig[0] + '"]' + (sig[1] != null ? '[data-v="' + sig[1] + '"]' : '');
      var el = panel.querySelector(sel);
      if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    }
    this.sceneEls = null;
    if (this.S.film) {
      this.sceneEls = [].slice.call(panel.querySelectorAll('.bkz-scene')).map(function (btn) { return { btn: btn, bar: btn.querySelector('.bkz-scene-bar'), __cur: null }; });
    }
  };

  /* Warenkorb: im Shop direkt über /cart/add.js, ausserhalb des Shops führt der Knopf zur Produktseite */
  function inShop() { try { return !!(window.Shopify && window.Shopify.shop); } catch (e) { return false; } }
  function shopRoot() { try { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; } catch (e) { return '/'; } }
  P.addToCart = function (id) {
    var self = this;
    if (!id || (this.cart && this.cart.st === 'busy')) return;
    this.cart = { id: id, st: 'busy' }; this.renderPanel();
    var done = function (st, msg) { if (self.dead || !self.cart || self.cart.id !== id) return; self.cart = { id: id, st: st, msg: msg || '' }; self.renderPanel(); };
    try {
      fetch(shopRoot() + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || 'Das hat nicht geklappt.'); return j; }); })
        .then(function () {
          done('ok');
          try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true })); } catch (e) {}
        })
        .catch(function (err) { done('err', String((err && err.message) || 'Das hat nicht geklappt.')); });
    } catch (e) { done('err', 'Das hat nicht geklappt.'); }
  };

  P.costAmt = function (k) { var c = (this.o.cost || {})[k]; return c && c.amount > 0 ? c.amount : 0; };
  P.costT = function () { var S = this.S; return costFx().home(S.csz, S.cev, this.costAmt(S.csz)); };

  P.panelHTML = function () {
    var S = this.S, a = this.a, o = this.o, h = '';
    var row = function (k, v) { return '<div><dt>' + k + '</dt><dd>' + v + '</dd></div>'; };
    var filmChip = function (label) { return a.reduce ? '' : '<button type="button" class="bkz-chip" data-action="film-start"><span class="bkz-chip-ic">' + I.play('#F5B526', 13) + '</span>' + label + '</button>'; };
    if (S.film) {
      h += '<div class="bkz-pblock"><div class="bkz-filmkicker"><span class="bkz-rec"></span>Film</div><h3 class="bkz-h3">Kamerafahrt durch die Zelle</h3><p class="bkz-p">Vom Etikett über die Schichten bis zu den Atomen. Wählen Sie eine Szene, um direkt dorthin zu springen.</p><ol class="bkz-scenes">';
      FILM.scenes.forEach(function (sc, i) { h += '<li><button type="button" class="bkz-scene" data-action="scene" data-v="' + i + '"><span class="bkz-scene-n">' + (i + 1) + '</span><span class="bkz-scene-t">' + sc.name + '</span><span class="bkz-scene-time">' + fmt(sc.t) + '</span><span class="bkz-scene-bar"></span></button></li>'; });
      h += '</ol><div class="bkz-row"><button type="button" class="bkz-dark" data-action="film-toggle">' + (S.paused ? 'Weiter abspielen' : 'Pause') + '</button><button type="button" class="bkz-light" data-action="film-end">Film beenden</button></div></div>';
      return h;
    }
    if (S.ch === 0) {
      var M = MODELS[S.model], price = o.prices[S.model];
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">Eine Zelle, 3.2 Volt</h3><p class="bkz-p">Prismatische LiFePO4-Zellen wie diese sind die Bausteine jedes Speichers. Drehen Sie die Zelle mit Maus oder Finger und vergleichen Sie die drei Modelle, die wir führen.</p>';
      h += '<div class="bkz-row">' + filmChip('Kamerafahrt ansehen') + '<button type="button" class="bkz-chip" role="switch" aria-checked="' + !!S.dims + '" data-action="dims"><span class="bkz-sw"></span>Masse einblenden</button></div>';
      h += '<div class="bkz-seg bkz-seg3" role="group" aria-label="Zellmodell wählen">';
      ['lf105', 'mb31', 'mb56'].forEach(function (k) { h += '<button type="button" class="bkz-segbtn" data-action="model" data-v="' + k + '" aria-pressed="' + (k === S.model) + '"><span class="bkz-seg-t">' + MODELS[k].name + '</span><span class="bkz-seg-s">' + MODELS[k].ah + ' Ah</span></button>'; });
      h += '</div><dl class="bkz-specs">' + row('Kapazität', M.ah + ' Ah') + row('Energie', M.wh) + row('Abmessungen', M.dims) + row('Gewicht', M.kg) + row('Zyklen', M.cyc) + '</dl>';
      if (price) h += '<div class="bkz-price"><b>' + esc(price) + '</b><span>' + esc(o.notes[S.model]) + '</span></div>';
      h += '<a class="bkz-link" href="' + esc(o.urls[S.model]) + '">' + M.name + ' im Shop ansehen</a></div>';
    } else if (S.ch === 1) {
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">Was in der Zelle steckt</h3><p class="bkz-p">Unter der blauen Folie sitzt ein Aluminiumgehäuse. Darin steckt der Elektrodenwickel aus hauchdünnen Schichten, getränkt mit flüssigem Elektrolyt.</p>';
      h += '<div class="bkz-row"><button type="button" class="bkz-chip" role="switch" aria-checked="' + !!S.layers + '" data-action="layers"><span class="bkz-sw"></span>Schichten auffächern</button>' + filmChip('Kamerafahrt') + '</div>';
      h += '<div class="bkz-pblock" style="gap:8px"><span class="bkz-kicker">Bauteil wählen und hineinzoomen</span><ol class="bkz-parts">';
      PARTS1.forEach(function (k) { h += '<li><button type="button" class="bkz-partbtn" data-action="focus" data-v="' + k + '" aria-pressed="' + (S.focus === k) + '"><span class="bkz-num">' + PRESETS[k].n + '</span><span>' + PRESETS[k].name + '</span></button></li>'; });
      h += '</ol></div><p class="bkz-note">Dazu kommt der Elektrolyt, ein gelöstes Lithiumsalz. Er transportiert die Ionen zwischen den Schichten.</p></div>';
    } else if (S.ch === 2) {
      var chg = a.dir > 0, lv = S.lv;
      var LV = [['Übersicht', 'Stromkreis'], ['Mikroskop', 'Teilchen'], ['Atome', 'Kristallgitter']];
      var leg = function (items) { return '<ul class="bkz-legend">' + items.map(function (it) { return '<li><i class="bkz-ico bkz-ico-' + it[0] + '"></i><span>' + it[1] + '</span></li>'; }).join('') + '</ul>'; };
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">So speichert die Zelle Energie</h3>';
      h += '<div class="bkz-seg bkz-seg3" role="group" aria-label="Ansicht wählen">' + LV.map(function (o, i) { return '<button type="button" class="bkz-segbtn" data-action="level" data-v="' + i + '" aria-pressed="' + (i === lv) + '"><span class="bkz-seg-t">' + o[0] + '</span><span class="bkz-seg-s">' + o[1] + '</span></button>'; }).join('') + '</div>';
      h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="Vorgang wählen"><button type="button" class="bkz-segbtn" data-action="mode" data-v="1" aria-pressed="' + chg + '">Laden</button><button type="button" class="bkz-segbtn" data-action="mode" data-v="-1" aria-pressed="' + !chg + '">Entladen</button></div>';
      if (lv === 0) {
        h += '<p class="bkz-p">' + (chg ? 'Beim Laden wandern Lithium-Ionen aus dem Eisenphosphat durch den Separator und lagern sich zwischen den Graphitschichten ein. Die Elektronen fliessen aussen herum, angetrieben vom Solarstrom.' : 'Beim Entladen wandern die Ionen zurück ins Eisenphosphat. Die Elektronen fliessen dabei durch Ihren Verbraucher und liefern Strom.') + '</p>';
        h += '<dl class="bkz-specs">' + row('Nennspannung', '3.2 V') + row('Spannungsfenster', '2.5 bis 3.65 V') + row('Spannungskurve', 'lange flach bei 3.2 bis 3.3 V') + row('Selbsterwärmung', 'erst ab 150 bis 170 °C') + '</dl>';
        h += '<p class="bkz-note">Mit «Mikroskop» und «Atome» zoomen Sie bis zu den einzelnen Atomen hinein.</p>';
      } else if (lv === 1) {
        h += '<p class="bkz-p">' + (chg ? 'Die Kathode besteht aus winzigen Körnern aus Lithium-Eisenphosphat, die Anode aus Graphit-Flocken. Beim Laden wandern Lithium-Ionen durch den Elektrolyt und die Poren des Separators zum Graphit. Die Elektronen nehmen den Weg über die Metallfolien und den äusseren Stromkreis.' : 'Beim Entladen kehren die Lithium-Ionen in die Eisenphosphat-Körner zurück. Die Elektronen fliessen über die Metallfolien und den äusseren Stromkreis durch Ihren Verbraucher.') + '</p>';
        h += leg([['core', 'Korn mit Lithium (LiFePO₄)'], ['grain', 'Korn ohne Lithium (FePO₄)'], ['li', 'Lithium-Ion'], ['e', 'Elektron']]);
        h += '<dl class="bkz-specs">' + row('Separator', 'dünner als ein Haar') + row('Metallfolien', 'rund 0.01 mm') + row('Elektrolyt', 'Lithiumsalz in Lösungsmittel') + '</dl>';
        h += '<p class="bkz-note">Warum die Spannung so flach bleibt: In jedem Korn wandelt sich LiFePO₄ direkt in FePO₄ um. Solange beide Formen nebeneinander bestehen, ändert sich die Spannung kaum.</p>';
      } else {
        h += '<p class="bkz-p">' + (chg ? 'Im Eisenphosphat sitzen die Lithium-Ionen in schmalen Kanälen. Beim Laden verlassen sie das Kristallgitter, das Eisen gibt dabei ein Elektron ab. Im Graphit schieben sich die Ionen zwischen die Kohlenstoffschichten.' : 'Beim Entladen verlassen die Ionen den Graphit und kehren in die Kanäle des Eisenphosphats zurück. Das Eisen nimmt dabei wieder ein Elektron auf.') + '</p>';
        h += '<div class="bkz-eq"><div><span class="bkz-eq-k">Kathode</span><span class="bkz-eq-f">' + (chg ? 'LiFePO₄ → FePO₄ + Li⁺ + e⁻' : 'FePO₄ + Li⁺ + e⁻ → LiFePO₄') + '</span></div><div><span class="bkz-eq-k">Anode</span><span class="bkz-eq-f">' + (chg ? 'C₆ + Li⁺ + e⁻ → LiC₆' : 'LiC₆ → C₆ + Li⁺ + e⁻') + '</span></div></div>';
        h += leg([['li', 'Lithium-Ion'], ['fe2', 'Eisen mit Lithium (Fe²⁺)'], ['fe3', 'Eisen ohne Lithium (Fe³⁺)'], ['po4', 'Phosphat'], ['c', 'Kohlenstoff']]);
        h += '<p class="bkz-note">Die Phosphatgruppen halten den Sauerstoff fest im Gitter. Deshalb ist LiFePO₄ thermisch so stabil. Darstellung vereinfacht.</p>';
      }
      h += '</div>';
    } else if (S.ch === 3) {
      var n = S.pack, pv = S.pv;
      var PV = [['Aufbau', 'Zellen in Serie'], ['Stromfluss', 'Verbinder'], ['BMS', 'Schutz, Ausgleich']];
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">Vom Baustein zum Speicher</h3>';
      h += '<div class="bkz-seg bkz-seg3" role="group" aria-label="Ansicht wählen">' + PV.map(function (o, i) { return '<button type="button" class="bkz-segbtn" data-action="pview" data-v="' + i + '" aria-pressed="' + (i === pv) + '"><span class="bkz-seg-t">' + o[0] + '</span><span class="bkz-seg-s">' + o[1] + '</span></button>'; }).join('') + '</div>';
      if (pv === 0) {
        var kk = kitKey(S), K = KITS[kk], kd = o.kits[kk] || {};
        h += '<p class="bkz-p">In Serie addieren sich die Spannungen der Zellen. In unseren Selbstbauspeichern sitzen sie in einem schwarzen Kunststoffgehäuse, verpresst mit Gewindestangen.</p>';
        h += '<div class="bkz-seg bkz-seg4" role="group" aria-label="Speicher wählen">' + KIT_ORDER.map(function (k2) { var K2 = KITS[k2]; return '<button type="button" class="bkz-segbtn" data-action="kit" data-v="' + k2 + '" aria-pressed="' + (k2 === kk) + '"><span class="bkz-seg-t">' + K2.seg[0] + '</span><span class="bkz-seg-s">' + K2.seg[1] + '</span></button>'; }).join('') + '</div>';
        h += '<div class="bkz-kit"><span class="bkz-kicker">' + (kk === 'p16' ? 'Aus unseren Selbstbauspeichern' : 'Unser Selbstbauspeicher') + '</span><b class="bkz-kit-n">' + K.name + '</b><span class="bkz-kit-m">' + K.meta + '</span><span class="bkz-kit-m">Passt für ' + K.use + '</span>';
        h += '<div class="bkz-kit-row">' + (kd.price ? '<span class="bkz-kit-p"><b>' + esc(kd.price) + '</b>' + (K.sub ? '<span>' + K.sub + '</span>' : '') + '</span>' : '') + '<span class="bkz-kit-l"><a class="bkz-link" href="' + esc(kd.url || '#') + '">' + K.link + '</a><a class="bkz-link" href="' + esc(o.storeUrl) + '">Alle Speicher</a></span></div></div>';
        h += '<div class="bkz-row"><button type="button" class="bkz-chip" role="switch" aria-checked="' + !!S.lid + '" data-action="lid"><span class="bkz-sw"></span>Deckel schliessen</button></div>';
      } else if (pv === 1) {
        var chg = S.flow > 0;
        h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="Vorgang wählen"><button type="button" class="bkz-segbtn" data-action="flow" data-v="1" aria-pressed="' + chg + '">Laden</button><button type="button" class="bkz-segbtn" data-action="flow" data-v="-1" aria-pressed="' + !chg + '">Entladen</button></div>';
        h += '<p class="bkz-p">' + (chg ? 'Über P+ und P− hängt der Speicher am Wechselrichter. Beim Laden fliesst derselbe Strom nacheinander durch jede Zelle und jeden Zellverbinder: In Kabeln und Verbindern bewegen sich Elektronen, in den Zellen wandern Lithium-Ionen zum Graphit.' : 'Über P+ und P− hängt der Speicher am Wechselrichter. Beim Entladen kehrt sich alles um: Die Lithium-Ionen wandern zurück ins Eisenphosphat, die Elektronen fliessen in die Gegenrichtung, und der Wechselrichter versorgt Ihre Verbraucher.') + '</p>';
        h += '<div class="bkz-row"><button type="button" class="bkz-chip" role="switch" aria-checked="' + !!S.loose + '" data-action="loose"><span class="bkz-sw"></span>Lockerer Verbinder</button></div>';
        h += '<dl class="bkz-specs">' + row(chg ? 'Ladestrom im Beispiel' : 'Entladestrom im Beispiel', '100 A') + row('Strom durch jeden Verbinder', '100 A') + row('Leistung bei ' + (n * 3.2).toFixed(1) + ' V', (n * 0.32).toFixed(1) + ' kW') + '</dl>';
        h += '<p class="bkz-note">' + (S.loose ? 'Ein lockerer Verbinder mit 1 Milliohm Übergangswiderstand setzt bei 100 A rund 10 Watt Wärme frei. Darum Kontaktflächen sauber halten und die Schrauben mit dem vorgeschriebenen Drehmoment anziehen.' : 'Weil jeder Verbinder den vollen Strom trägt, müssen die Kontaktflächen sauber sein und die Schrauben mit dem vorgeschriebenen Drehmoment angezogen werden.') + '</p>';
      } else {
        var act = S.bal === 'a', PR = prot(), isP = S.bmsv === 'prot';
        h += '<p class="bkz-p">Das BMS überwacht jede Zelle, den Strom und die Temperatur.</p>';
        h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="Funktion des BMS wählen"><button type="button" class="bkz-segbtn" data-action="bmsv" data-v="prot" aria-pressed="' + isP + '">Schutz</button><button type="button" class="bkz-segbtn" data-action="bmsv" data-v="bal" aria-pressed="' + !isP + '">Ausgleich</button></div>';
        if (isP) {
          h += '<div class="bkz-seg bkz-seg4" role="group" aria-label="Schutzfunktion wählen">' + PR.ORDER.map(function (k3) { var D3 = PR.DEF[k3]; return '<button type="button" class="bkz-segbtn" data-action="prot" data-v="' + k3 + '" aria-pressed="' + (k3 === S.prot) + '"><span class="bkz-seg-t">' + D3.t + '</span><span class="bkz-seg-s">' + D3.s + '</span></button>'; }).join('') + '</div>';
          if (S.prot === 'oc') h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="Richtung wählen"><button type="button" class="bkz-segbtn" data-action="occ" data-v="d" aria-pressed="' + (S.occ !== 'c') + '">Entladen über 200 A</button><button type="button" class="bkz-segbtn" data-action="occ" data-v="c" aria-pressed="' + (S.occ === 'c') + '">Laden über 100 A</button></div>';
          h += '<p class="bkz-p">' + PR.TXT[S.prot] + '</p>';
          if (!PR.DEF[S.prot].own) h += '<p class="bkz-note">Die Grenzwerte sind typische Beispielwerte und lassen sich je nach BMS einstellen.</p>';
        } else {
          h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="Art des Ausgleichs wählen"><button type="button" class="bkz-segbtn" data-action="bal" data-v="p" aria-pressed="' + !act + '">Passiver Ausgleich</button><button type="button" class="bkz-segbtn" data-action="bal" data-v="a" aria-pressed="' + act + '">Aktiver Ausgleich</button></div>';
          h += '<p class="bkz-p">' + (act ? 'Gegen Ende der Ladung steigt die Spannung steil an. Ist eine Zelle früher voll, verschiebt das BMS Energie von ihr zur leersten Zelle, über Kondensatoren oder Spulen. Das geht schneller, und kaum Energie geht verloren.' : 'Gegen Ende der Ladung steigt die Spannung steil an. Ist eine Zelle früher voll, entlädt das BMS sie über einen Widerstand. Die überschüssige Energie wird zu Wärme, bis die anderen Zellen aufgeholt haben.') + '</p>';
          h += '<p class="bkz-note">Ohne Ausgleich wäre die vollste Zelle zuerst bei 3.65 V, und das BMS müsste die Ladung stoppen, bevor die anderen voll sind. Werte typisch, je nach BMS einstellbar.</p>';
        }
      }
      h += '</div>';
    } else if (S.ch === 4) {
      var A = S.grade === 'A';
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">Gute Zellen erkennen</h3><p class="bkz-p">Zwei Zellen können gleich aussehen und sich trotzdem stark unterscheiden. Vergleichen Sie Grade A mit Grade B und zoomen Sie über die Nummern an die Details heran.</p>';
      h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="Qualitätsstufe wählen"><button type="button" class="bkz-segbtn" data-action="grade" data-v="A" aria-pressed="' + A + '">Grade A</button><button type="button" class="bkz-segbtn" data-action="grade" data-v="B" aria-pressed="' + !A + '">Grade B</button></div><ul class="bkz-checks">';
      (A ? CHECK_A : CHECK_B).forEach(function (t) { h += '<li>' + (A ? I.check : I.warn) + '<span>' + t + '</span></li>'; });
      h += '</ul><p class="bkz-note">Wir verbauen nur neue Zellen in Grade A. Die Messwerte im Prüfstand sind Beispiele.</p></div>';
    } else if (S.ch === 5) {
      var SY = sysFx();
      var seg2 = function (aria, act2, items, cur2) { return '<div class="bkz-seg bkz-seg2" role="group" aria-label="' + aria + '">' + items.map(function (it) { return '<button type="button" class="bkz-segbtn" data-action="' + act2 + '" data-v="' + it[0] + '" aria-pressed="' + (it[0] === cur2) + '">' + it[1] + '</button>'; }).join('') + '</div>'; };
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">Vom Solarmodul bis zum <span class="bkz-nw">E-Auto</span></h3>';
      h += '<p class="bkz-p">Die Solarmodule liefern Gleichstrom. Der Laderegler lädt damit den Speicher, der Wechselrichter macht daraus 230&nbsp;Volt für Haus und Wallbox. Beides gibt es auch in einem Gerät, als Hybridwechselrichter.</p>';
      h += '<div class="bkz-segrow">' + seg2('Jahreszeit wählen', 'sea', [['s', 'Sommertag'], ['w', 'Wintertag']], S.sea) + seg2('Netzanschluss wählen', 'gridm', [['1', 'Mit Netz'], ['0', 'Ohne Netz']], S.grid ? '1' : '0') + '</div>';
      h += '<dl class="bkz-specs">' + SY.rows(S.sea, S.grid).map(function (rw) { return row(rw[0], rw[1]); }).join('') + '</dl>';
      h += '<p class="bkz-note">' + SY.note(S.sea, S.grid) + '</p>';
      h += '<a class="bkz-link" href="' + esc(o.kits.p16.url) + '">Passender Speicher: 48 V aus zwei 24V-Gehäusen</a></div>';
    } else if (S.ch === 6) {
      var CM = cmpFx(), cr = S.crit;
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">LiFePO4, AGM oder Blei?</h3>';
      h += '<div class="bkz-seg bkz-seg4" role="group" aria-label="Vergleich wählen">' + CM.ORDER.map(function (k5) { return '<button type="button" class="bkz-segbtn" data-action="crit" data-v="' + k5 + '" aria-pressed="' + (k5 === cr) + '"><span class="bkz-seg-t">' + CM.NAMES[k5][0] + '</span><span class="bkz-seg-s">' + CM.NAMES[k5][1] + '</span></button>'; }).join('') + '</div>';
      h += '<p class="bkz-p">' + CM.TXT[cr] + '</p>';
      h += '<table class="bkz-cmpt"><thead><tr><th scope="col"><span class="bkz-sr">Eigenschaft</span></th><th scope="col" class="is-us">LiFePO4</th><th scope="col">AGM</th><th scope="col">Blei</th></tr></thead><tbody>' + CM.ROWS.map(function (rw) { return '<tr><th scope="row">' + rw[0] + '</th><td class="is-us">' + rw[1] + '</td><td>' + rw[2] + '</td><td>' + rw[3] + '</td></tr>'; }).join('') + '</tbody></table>';
      h += '<p class="bkz-note">Typische Werte, AGM und Blei bei 50&nbsp;% Entladung. Blei je nach Typ 1\'000 bis 1\'900 Zyklen, Industriezellen bis 3\'600.</p>';
      h += '<a class="bkz-link" href="' + esc(o.storeUrl) + '">Zu unseren LiFePO4-Speichern</a></div>';
    } else if (S.ch === 7) {
      var CO = costFx(), cvw = S.cview === 'agm' ? 'agm' : 'home', oc = o.cost || {};
      h += '<div class="bkz-pblock"><h3 class="bkz-h3">Rechnet sich ein Speicher?</h3>';
      h += '<div class="bkz-seg bkz-seg2 bkz-segtall" role="group" aria-label="Rechnung wählen">' + [['home', 'Haus mit Solaranlage', 'Ersparnis pro Jahr'], ['agm', 'Statt AGM', 'Kosten in 15 Jahren']].map(function (it) { return '<button type="button" class="bkz-segbtn" data-action="cview" data-v="' + it[0] + '" aria-pressed="' + (it[0] === cvw) + '"><span class="bkz-seg-t">' + it[1] + '</span><span class="bkz-seg-s">' + it[2] + '</span></button>'; }).join('') + '</div>';
      if (cvw === 'home') {
        var hz = CO.HOME[S.csz] ? S.csz : 'h10', hc = oc[hz] || {};
        h += '<div class="bkz-seg bkz-seg3" role="group" aria-label="Speicher wählen">' + CO.SIZES.map(function (k6) { var c6 = oc[k6] || {}; return '<button type="button" class="bkz-segbtn" data-action="csz" data-v="' + k6 + '" aria-pressed="' + (k6 === hz) + '"><span class="bkz-seg-t">' + CO.HOME[k6].kwh + ' kWh</span><span class="bkz-seg-s">' + esc(c6.price || CO.HOME[k6].disp) + '</span></button>'; }).join('') + '</div>';
        h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="E-Auto wählen"><button type="button" class="bkz-segbtn" data-action="cev" data-v="0" aria-pressed="' + !S.cev + '">Ohne E-Auto</button><button type="button" class="bkz-segbtn" data-action="cev" data-v="1" aria-pressed="' + !!S.cev + '">Mit E-Auto</button></div>';
        h += '<dl class="bkz-specs">' + CO.rows(hz, S.cev, this.costAmt(hz)).map(function (rw) { return row(rw[0], rw[1]); }).join('') + '</dl>';
        h += '<p class="bkz-note">' + CO.note('home', S.cev) + '</p>';
        h += '<a class="bkz-link" href="' + esc(hc.url || '#') + '">Zum ' + CO.HOME[hz].name + '</a></div>';
      } else {
        h += '<p class="bkz-p">' + CO.TXT.agm + '</p>';
        h += '<table class="bkz-cmpt bkz-cmpt2"><thead><tr><th scope="col"><span class="bkz-sr">Eigenschaft</span></th><th scope="col" class="is-us">LiFePO4</th><th scope="col">AGM</th></tr></thead><tbody>' + CO.agmRows(this.costAmt('p4')).map(function (rw) { return '<tr><th scope="row">' + rw[0] + '</th><td class="is-us">' + rw[1] + '</td><td>' + rw[2] + '</td></tr>'; }).join('') + '</tbody></table>';
        h += '<p class="bkz-note">' + CO.note('agm') + '</p>';
        h += '<a class="bkz-link" href="' + esc((oc.p4 || {}).url || o.kits.p4.url) + '">Zum 12V Solarspeicher 4 kWh</a></div>';
      }
    } else {
      var FD = findFx(), fr = FD.pick(S.fuse, S.flv, S.fdays, S.fev), FU = fr.U, ofd = o.find || {}, fp = ofd[fr.key] || {};
      h += '<div class="bkz-pblock bkz-pblock-tight"><h3 class="bkz-h3">Welcher Speicher passt?</h3>';
      h += '<div class="bkz-seg bkz-seg3" role="group" aria-label="Einsatz wählen">' + FD.ORDER.map(function (k8) { var U8 = FD.USE[k8]; return '<button type="button" class="bkz-segbtn" data-action="fuse" data-v="' + k8 + '" aria-pressed="' + (k8 === fr.u) + '"><span class="bkz-seg-t">' + U8.t + '</span><span class="bkz-seg-s">' + U8.s + '</span></button>'; }).join('') + '</div>';
      h += '<div class="bkz-seg bkz-seg3" role="group" aria-label="Bedarf wählen">' + FU.lv.map(function (L8, i8) { return '<button type="button" class="bkz-segbtn" data-action="flv" data-v="' + i8 + '" aria-pressed="' + (i8 === fr.li) + '"><span class="bkz-seg-t">' + L8[0] + '</span><span class="bkz-seg-s">' + L8[1] + '</span></button>'; }).join('') + '</div>';
      if (FU.opt === 'days') h += '<div class="bkz-seg bkz-seg3" role="group" aria-label="Tage ohne Sonne wählen">' + [1, 2, 3].map(function (d8) { return '<button type="button" class="bkz-segbtn" data-action="fdays" data-v="' + d8 + '" aria-pressed="' + (d8 === fr.d) + '"><span class="bkz-seg-t">' + d8 + (d8 > 1 ? ' Tage' : ' Tag') + '</span><span class="bkz-seg-s">ohne Sonne</span></button>'; }).join('') + '</div>';
      else if (FU.opt === 'ev') h += '<div class="bkz-seg bkz-seg2" role="group" aria-label="E-Auto wählen"><button type="button" class="bkz-segbtn" data-action="fev" data-v="0" aria-pressed="' + !fr.ev + '">Ohne E-Auto</button><button type="button" class="bkz-segbtn" data-action="fev" data-v="1" aria-pressed="' + fr.ev + '">Mit E-Auto</button></div>';
      h += '<dl class="bkz-specs">' + FD.rows(fr).map(function (rw) { return row(rw[0], rw[1]); }).join('') + '</dl>';
      var vl = FD.vars(fr.key, fp.vars), vi = FD.pickVar(vl, S.fkit), vs = vl[vi] || { id: 0, price: 0, avail: true, title: '' }, cs = this.cart && vs.id && this.cart.id === vs.id ? this.cart : null;
      var pUrl = (fp.url || SHOP + '/products/' + fr.P.handle) + (vs.id ? (/\?/.test(fp.url || '') ? '&' : '?') + 'variant=' + vs.id : '');
      h += '<p class="bkz-find-p"><b>' + fr.P.name + '</b><span>' + (vs.price ? FD.chf(vs.price) : esc(fp.price || fr.P.disp)) + '</span></p>';
      h += '<div class="bkz-buy">';
      if (vl.length > 1) h += '<div class="bkz-seg bkz-seg2 bkz-segtall" role="group" aria-label="Ausführung wählen">' + vl.map(function (v9, i9) { var lb = FD.varLabel(v9.title); return '<button type="button" class="bkz-segbtn" data-action="fkit" data-v="' + FD.varKey(v9.title, i9) + '" aria-pressed="' + (i9 === vi) + '"><span class="bkz-seg-t">' + esc(lb[0]) + '</span>' + (lb[1] ? '<span class="bkz-seg-s">' + lb[1] + '</span>' : '') + '</button>'; }).join('') + '</div>';
      var CART = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 4h2.2l2.1 10.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.2L20.6 8H6.3"></path><circle cx="10" cy="19.5" r="1.3"></circle><circle cx="17" cy="19.5" r="1.3"></circle></svg>';
      if (!vs.avail) h += '<button type="button" class="bkz-cartbtn" disabled>Ausverkauft</button>';
      else if (cs && cs.st === 'ok') h += '<a class="bkz-cartbtn is-done" href="' + esc(shopRoot()) + 'cart"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"></path></svg>Zum Warenkorb</a>';
      else if (inShop() && vs.id) h += '<button type="button" class="bkz-cartbtn" data-action="fcart" data-v="' + vs.id + '"' + (cs && cs.st === 'busy' ? ' disabled aria-busy="true"' : '') + '>' + CART + (cs && cs.st === 'busy' ? 'Wird hinzugefügt …' : 'In den Warenkorb') + '</button>';
      else h += '<a class="bkz-cartbtn" href="' + esc(pUrl) + '">' + CART + 'In den Warenkorb</a>';
      h += '<span class="bkz-cartmsg' + (cs && cs.st === 'err' ? ' is-err' : '') + '" role="status">' + (cs && cs.st === 'ok' ? 'Liegt im Warenkorb.' : cs && cs.st === 'err' ? esc(cs.msg) : '') + '</span>';
      h += '</div>';
      h += '<div class="bkz-links"><a class="bkz-link" href="' + esc(pUrl) + '">Zum Produkt</a><a class="bkz-link" href="' + esc(SHOP + FU.link[1]) + '">' + FU.link[0] + '</a><a class="bkz-link" href="' + esc(o.contactUrl || SHOP + '/pages/contact') + '">Beratung</a></div>';
      h += '<p class="bkz-note">' + FD.note(fr) + '</p></div>';
    }
    h += '<button type="button" class="bkz-next" data-action="next">' + NEXT[S.ch] + '</button>';
    return h;
  };

  /* ------------------------------------------------------------------ Start */
  // Ausführungen aus dem Abschnitt: id~Preis in Rappen~lieferbar~Titel, getrennt mit |
  function parseVars(str) {
    if (!str) return null;
    var out = String(str).split('|').map(function (x) { var p = x.split('~'), t = ''; try { t = decodeURIComponent((p[3] || '').replace(/\+/g, ' ')); } catch (e) { t = p[3] || ''; } return { id: +p[0] || 0, price: (+p[1] || 0) / 100, avail: p[2] === '1', title: t === 'Default Title' ? '' : t }; }).filter(function (v) { return v.id; });
    return out.length ? out : null;
  }
  function readOpts(el) {
    var d = el.dataset || {};
    var pick = function (v, def) { return v == null ? def : v; };
    var auto = d.autoplay;
    return {
      autoplay: !(auto === 'false' || auto === '0' || auto === 'no'),
      prices: { lf105: pick(d.priceLf105, MODELS.lf105.price), mb31: pick(d.priceMb31, MODELS.mb31.price), mb56: pick(d.priceMb56, MODELS.mb56.price) },
      notes: { lf105: pick(d.noteLf105, MODELS.lf105.note), mb31: pick(d.noteMb31, MODELS.mb31.note), mb56: pick(d.noteMb56, MODELS.mb56.note) },
      urls: { lf105: d.urlLf105 || MODELS.lf105.url, mb31: d.urlMb31 || MODELS.mb31.url, mb56: d.urlMb56 || MODELS.mb56.url },
      storeUrl: d.storeUrl || SHOP + '/collections/energiespeicher',
      find: findFx().KEYS.reduce(function (acc, k) { var pre = 'kit' + k.charAt(0).toUpperCase() + k.slice(1), F = findFx().PROD[k], am = parseFloat(d[pre + 'Amount']); am = am > 0 ? am / 100 : 0; acc[k] = { url: d[pre + 'Url'] || SHOP + '/products/' + F.handle, price: d[pre + 'Price'] || (am ? costFx().chf(am) : F.disp), vars: parseVars(d[pre + 'Variants']) }; return acc; }, {}),
      contactUrl: d.contactUrl || SHOP + '/pages/contact',
      cost: ['h5', 'h10', 'h15', 'p4'].reduce(function (acc, k) { var pre = 'kit' + k.charAt(0).toUpperCase() + k.slice(1), H = costFx().HOME[k], am = parseFloat(d[pre + 'Amount']); am = am > 0 ? am / 100 : 0; acc[k] = { url: d[pre + 'Url'] || SHOP + '/products/' + (H ? H.handle : KITS.p4.handle), price: d[pre + 'Price'] || (am ? costFx().chf(am) : H ? H.disp : KITS.p4.price), amount: am }; return acc; }, {}),
      kits: KIT_ORDER.reduce(function (acc, k) { var K = KITS[k], pre = 'kit' + k.charAt(0).toUpperCase() + k.slice(1); acc[k] = { url: d[pre + 'Url'] || SHOP + '/products/' + K.handle, price: pick(d[pre + 'Price'], K.price) }; return acc; }, {})
    };
  }
  function init(el, opts) {
    if (!el || el.__bkz) return el && el.__bkz;
    var o = readOpts(el);
    if (opts) for (var k in opts) if (Object.prototype.hasOwnProperty.call(opts, k)) o[k] = opts[k];
    el.__bkz = new Explorer(el, o);
    return el.__bkz;
  }
  function initAll(scope) {
    var root = scope || document;
    if (root.matches && root.matches('[data-bk-zellen-explorer]')) init(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-bk-zellen-explorer]').forEach(function (el) { init(el); });
  }
  function destroyAll(scope) {
    var root = scope || document;
    var list = [].slice.call(root.querySelectorAll ? root.querySelectorAll('[data-bk-zellen-explorer]') : []);
    if (root.matches && root.matches('[data-bk-zellen-explorer]')) list.push(root);
    list.forEach(function (el) { if (el.__bkz) { el.__bkz.destroy(); el.__bkz = null; } });
  }
  window.BKZellenExplorer = { version: '1.9.0', init: init, initAll: initAll, destroyAll: destroyAll };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyAll(e.target); });
})();
